export default {
  app: {
    title: 'Channels',
    description: 'Créez et gérez vos sites vidéo',
  },
  title: 'Sites web',
  newButton: 'Nouveau',
  demoTitle: 'Regarder la présentation',
  createButton: 'Créer un site',
  backToList: 'Retour aux sites',
  header: {
    title: 'Vos',
    titleAccent: 'espaces de diffusion',
    hint: 'Votre propre site, à votre image, pour publier votre contenu — vidéos, audios, articles — et rencontrer votre audience.',
  },
  status: {
    active: 'Actif',
    inactive: 'Inactif',
    maintenance: 'Maintenance',
    draft: 'Brouillon',
    offline: 'Hors ligne',
  },
  previewLink: {
    open: 'Aperçu',
    failed: 'L\'aperçu n\'a pas pu être ouvert.',
    noAddress: 'Votre chaîne ne répond encore sur aucune adresse : connectez-en une pour pouvoir l\'ouvrir.',
  },
  error: {
    title: 'Échec du chargement des sites',
    description: 'Une erreur est survenue lors du chargement de vos sites. Veuillez réessayer.',
    retryButton: 'Réessayer',
  },
  emptyState: {
    title: 'Aucun site pour le moment',
    description: 'Créez votre premier site pour commencer.',
    buttonText: 'Créer un site',
  },
  card: {
    actions: 'Actions',
    rename: {
      title: 'Renommer la chaîne',
      label: 'Nom de la chaîne',
      done: 'Chaîne renommée',
      error: 'Le renommage a échoué',
      stale: 'Quelqu\'un a enregistré avant vous : rien n\'a été écrit. La liste vient d\'être relue.',
    },
    delete: {
      title: 'Supprimer la chaîne',
      message: 'Supprimer « {name} » met son site hors ligne : ses visiteurs n\'y accèdent plus, et ses contenus, ses pages et ses membres sont supprimés avec lui. Son sous-domaine est libéré après la période de rétention. Les médias restent dans votre bibliothèque.',
      confirmLabel: 'Saisissez {name} pour confirmer',
      confirmHint: 'Saisissez le nom de la chaîne exactement tel qu\'il est écrit',
      done: 'Chaîne supprimée',
      error: 'La suppression a échoué',
      stale: 'Quelqu\'un a enregistré avant vous : rien n\'a été écrit. La liste vient d\'être relue.',
      forbidden: 'Seul le propriétaire de la chaîne peut la supprimer.',
    },
  },
  nav: {
    redirects: 'Redirections',
    overview: 'Vue d\'ensemble',
    dashboard: 'Tableau de bord',
    statistics: 'Statistiques',
    content: 'Contenu',
    pages: 'Pages',
    categories: 'Catégories',
    items: 'Éléments',
    publishedMedia: 'Médias publiés',
    users: 'Utilisateurs',
    usersList: 'Utilisateurs',
    inbox: 'Boîte de réception',
    submissions: 'Dépôts',
    messages: 'Messages',
    groups: 'Groupes',
    monetization: 'Monétisation',
    subscriptions: 'Abonnements',
    coupons: 'Coupons',
    productCatalog: 'Catalogue produits',
    sales: 'Ventes',
    salesOverview: 'Vue d\'ensemble',
    salesSubscriptions: 'Abonnements actifs',
    salesTransactions: 'Transactions',
    salesRevenue: 'Revenus & facturation',
    salesProducts: 'Catalogue produits',
    settings: 'Paramètres',
    information: 'Informations',
    domain: 'Domaine',
    external: 'Externe',
    viewSite: 'Voir le site',
    editSite: 'Modifier le site',
    communication: 'Communication',
    comments: 'Commentaires',
    campaigns: 'Campagnes',
    audiences: 'Audiences',
    blog: 'Blog',
    accessRequests: 'Demandes d\'accès',
    myContent: 'Mon contenu',
    newChannel: 'Nouvelle chaîne',
  },
  stats: {
    title: 'Statistiques',
    subtitle: 'Comprenez votre audience et la performance de vos contenus',
    seeAll: 'Tout voir',
    vsPrevious: 'vs période précédente',
    loadError: 'Échec du chargement des statistiques. Veuillez réessayer.',
    filtersRefused: 'La période ou les filtres choisis ont été refusés. Modifiez-les, puis réessayez.',
    unavailable: 'Les statistiques ne sont pas disponibles pour le moment.',
    empty: 'Aucune donnée sur cette période.',
    loadMore: 'Voir plus',
    rankingCap: 'Le classement s\'arrête aux 100 premiers contenus.',
    filters: {
      button: 'Filtres',
      title: 'Filtres',
      subtitle: 'Affinez les statistiques de cette chaîne',
      audience: 'Audience',
      audienceAll: 'Tout le monde',
      audienceRegistered: 'Inscrits',
      devices: 'Appareils',
      countries: 'Pays',
      noCountries: 'Aucun pays sur cette période',
      contentTypes: 'Types de contenu',
      activeCount: '{count} actif(s)',
      noActive: 'Aucun filtre actif',
      clear: 'Effacer',
    },
    contentTypes: {
      video: 'Vidéo',
      audio: 'Audio',
      image: 'Image',
      collection: 'Collection',
      thirdParty: 'Contenu externe',
    },
    periods: {
      '7d': '7 jours',
      '30d': '30 jours',
      '90d': '90 jours',
      '12m': '12 mois',
    },
    tabs: {
      overview: 'Vue d\'ensemble',
      content: 'Contenus',
      users: 'Utilisateurs',
      audience: 'Audience',
    },
    kpi: {
      views: 'Lectures',
      viewsDesc: 'Nombre total de lectures de contenu sur votre chaîne',
      watchTime: 'Temps de lecture',
      watchTimeDesc: 'Temps total passé par les visiteurs à lire vos contenus',
      uniqueViewers: 'Visiteurs uniques',
      uniqueViewersDesc: 'Nombre de visiteurs distincts ayant lu vos contenus',
      completionRate: 'Taux de complétion',
      completionRateDesc: 'Pourcentage moyen du contenu lu avant l\'arrêt des visiteurs',
      avgSession: 'Durée moy. de session',
      avgSessionDesc: 'Temps moyen passé par session de lecture sur la période',
      activeUsers: 'Utilisateurs actifs',
      activeUsersDesc: 'Utilisateurs inscrits ayant lu du contenu sur la période',
      registeredUsers: 'Inscrits',
      registeredUsersDesc: 'Nombre total d\'utilisateurs inscrits sur votre chaîne',
      newUsers: 'Nouveaux inscrits',
      newUsersDesc: 'Utilisateurs inscrits durant la période',
    },
    overview: {
      trend: {
        title: 'Évolution de l\'audience',
        subtitle: 'Lectures et visiteurs uniques sur la période',
      },
      topContent: {
        title: 'Contenus les plus vus',
      },
      activeUsers: {
        title: 'Utilisateurs les plus actifs',
      },
    },
    users: {
      title: 'Utilisateurs les plus actifs',
      subtitle: 'Cliquez sur une colonne pour trier',
      rankingCap: 'Le classement s\'arrête aux 100 premiers utilisateurs.',
      columns: {
        user: 'Utilisateur',
        watchTime: 'Lecture',
        videos: 'Contenus',
        sessions: 'Sessions',
        completion: 'Complétion',
        lastActivity: 'Dernière activité',
      },
    },
    content: {
      title: 'Contenus les plus vus',
      subtitle: 'Cliquez sur une colonne pour trier',
      categoriesTitle: 'Top catégories',
      deleted: 'Supprimé',
      unknownCategory: 'Catégorie supprimée',
      columns: {
        title: 'Contenu',
        views: 'Lectures',
        uniqueViewers: 'Visiteurs uniques',
        watchTime: 'Lecture',
        completion: 'Complétion',
      },
    },
    audience: {
      devices: 'Appareils',
      countries: 'Pays',
      trafficSources: 'Sources de trafic',
      trafficSourcesSubtitle: 'Comment votre audience arrive sur vos contenus',
      referrers: 'Principaux référents',
      referrersSubtitle: 'Domaines référents',
      peakHours: 'Heures de pointe',
      peakHoursSubtitle: 'Activité par jour et par heure, à votre heure locale',
      days: ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'],
      heatmapLess: 'Moins',
      heatmapMore: 'Plus',
    },
    devices: {
      desktop: 'Ordinateur',
      mobile: 'Mobile',
      tablet: 'Tablette',
      tv: 'Téléviseur',
      bot: 'Robot',
      smart_tv: 'Smart TV',
      game_console: 'Console de jeu',
      unknown: 'Inconnu',
    },
    sources: {
      direct: 'Direct',
      social: 'Réseaux sociaux',
      organic: 'Recherche organique',
      referral: 'Référent',
      email: 'Email',
      paid: 'Payant',
      unknown: 'Inconnu',
    },
    user: {
      title: 'Statistiques de lecture',
      subtitle: 'Activité de cet utilisateur sur votre chaîne',
      memberSince: 'Membre depuis',
      lastActive: 'Dernière activité',
      plays: 'lectures',
      openContent: 'Ouvrir la fiche du contenu',
      sessionsSummary: '{count} sessions · {time} · jusqu\'à {completion}%',
      summary: {
        watchTime: 'Temps de lecture total',
        watchTimeDesc: 'Temps total passé par cet utilisateur à lire du contenu',
        videosWatched: 'Contenus lus',
        videosWatchedDesc: 'Nombre de contenus distincts lus par cet utilisateur',
        sessions: 'Sessions',
        sessionsDesc: 'Nombre de sessions de lecture de cet utilisateur',
        completion: 'Complétion moy.',
        completionDesc: 'Pourcentage moyen du contenu lu par cet utilisateur avant l\'arrêt',
        firstSeen: 'Première visite',
        lastActivity: 'Dernière activité',
      },
      activityTitle: 'Activité dans le temps',
      historyTitle: 'Historique de lecture',
      historySubtitle: 'Ce que cet utilisateur a lu, session par session',
      topContentTitle: 'Contenus favoris',
      categoriesTitle: 'Catégories préférées',
      devicesTitle: 'Appareils',
      locationsTitle: 'Localisations',
      history: {
        content: 'Contenu',
        watched: 'Lu le',
        duration: 'Lu',
        completion: 'Complétion',
        stretches: 'Passages lus',
        device: 'Appareil',
      },
      empty: 'Aucune activité de lecture pour le moment',
      historyError: {
        title: 'L\'historique de lecture n\'a pas pu être chargé',
        description: 'Une erreur est survenue lors du chargement des sessions de cet utilisateur. Veuillez réessayer.',
        more: 'La suite de l\'historique n\'a pas pu être chargée.',
        retry: 'Réessayer',
      },
    },
  },
  publish: {
    title: 'Mettre « {name} » en ligne',
    subtitle: 'Votre chaîne devient visible à l\'adresse {address}',
    summary: 'Cette page devient publique à l\'adresse {address}, avec votre logo et vos couleurs.',
    preview: {
      itemNone: 'Aucun contenu pour l\'instant',
      visit: 'Voir en vrai',
    },
    // Le prix est encadré, et la ligne sous le libellé dit enfin ce qui manquait
    // le plus : d'où l'argent sort. La carte ne qualifie plus rien — le loyer est
    // prélevé sur le portefeuille, et une carte au dossier sans crédit ne paie
    // rien.
    feeLabel: 'Chaîne en ligne',
    feeHint: 'Prélevé sur votre portefeuille, chaque mois',
    walletLabel: 'Votre portefeuille',
    // « Consommation comprise » parce que le chiffre retenu est le plus court des
    // deux : le rythme de consommation mesuré par le serveur, ou le solde divisé
    // par le loyer. Annoncer le plus flatteur se retournerait contre nous au
    // premier arrêt.
    runwayMonths: 'De quoi tenir environ {months} mois, consommation comprise.',
    runwayDays: 'De quoi tenir environ {days} jours, consommation comprise.',
    missing: 'Il manque {amount} pour le premier mois.',
    insufficient: 'Sans recharge, le premier prélèvement échouera : la chaîne restera en ligne pendant 14 jours de grâce, puis sera mise hors ligne.',
    // Ni autonomie ni « il manque » : « sans recharge » n'a aucun sens pour qui
    // n'a jamais chargé. On invite, on n'avertit pas. Aucun montant nommé ici :
    // les trois cartes en portent trois, et en désigner un dans la phrase
    // reviendrait à reprendre le choix qu'on vient de donner.
    neverFunded: 'Vous n\'avez encore rien rechargé : le crédit acheté paiera l\'abonnement de votre chaîne et votre consommation.',
    neverFundedNote: 'Le crédit sert à tout : l\'abonnement de la chaîne, le stockage, les sous-titres, la diffusion au-delà des {size} offerts chaque mois.',
    neverFundedNoteNoAllowance: 'Le crédit sert à tout : l\'abonnement de la chaîne, le stockage, les sous-titres, la diffusion dès le premier Go.',
    creditPending: 'Paiement accepté. Le crédit met parfois une minute à arriver — la chaîne est mise en ligne dès qu\'il est là.',
    creditLate: 'Votre paiement est bien passé, mais le crédit n\'est pas encore arrivé. Réessayez de publier dans un instant.',
    fineprint: 'Le premier mois est prélevé dans les 24 heures qui suivent la mise en ligne, puis chaque mois, avec le reste de votre consommation. Vous pouvez remettre la chaîne hors ligne quand vous voulez : l\'abonnement s\'arrête et le mois entamé vous reste.',
    contract: 'Le mensuel de cette chaîne est compris dans votre contrat : rien n\'est prélevé ici.',
    // Une chaîne exonérée : la promesse faite à celles qui étaient en ligne avant que la
    // publication devienne payante. Ni prix ni portefeuille à montrer.
    exempt: 'Cette chaîne a été mise en ligne avant que la publication devienne payante : elle reste gratuite, ses adresses personnalisées comprises. Rien n\'est prélevé.',
    blocked: 'Votre portefeuille est vide : vos contenus publics sont déjà indisponibles. Rechargez-le pour que votre chaîne réponde.',
    published: 'Votre chaîne est en ligne : {address} répond désormais pour tout le monde.',
    publishedNoAddress: 'Votre chaîne est en ligne.',
    failed: 'La chaîne n\'a pas pu être mise en ligne.',
    stale: 'Quelqu\'un a modifié la chaîne avant vous : rien n\'a été écrit. Elle vient d\'être relue, vous pouvez réessayer.',
    topUpTitle: 'Recharger votre portefeuille',
    topUpAndPublish: 'Recharger et publier',
    later: 'Plus tard',
    confirm: 'Mettre en ligne',
  },
  dashboard: {
    viewSite: 'Voir le site',
    noDescription: 'Aucune description',
    proBanner: {
      title: 'Passez à Pro',
      description: 'pour mettre votre site en ligne et débloquer toutes les fonctionnalités',
      button: 'Découvrir',
    },
    hero: {
      status: {
        online: 'En ligne',
        draft: 'Brouillon',
        offline: 'Hors ligne',
      },
      stats: {
        medias: 'médias',
        categories: 'catégories',
        users: 'utilisateurs',
      },
      copyUrl: 'Copier l\'URL',
      preview: {
        unavailable: 'Aperçu momentanément indisponible',
        noCapture: 'Pas d\'aperçu ici : ouvrez le site pour voir votre page d\'accueil',
        noAddress: 'Aperçu disponible dès que votre chaîne aura une adresse',
        refresh: 'Actualiser l\'aperçu',
        capturedAt: 'Capture du {date}',
      },
      actions: {
        view: 'Voir le site',
        preview: 'Aperçu',
        edit: 'Modifier',
        editSEO: 'Modifier les informations',
        editURL: 'Configurer l\'URL',
        editDesign: 'Personnaliser le design',
      },
    },
    shapePromotion: {
      message:
        'Votre chaîne a un deuxième contenu : catégories, liste des médias et recherche sont maintenant disponibles.',
      action: 'Créer une catégorie',
    },
    banners: {
      pastDue: {
        title: 'Le prélèvement de votre chaîne n\'est pas passé',
        description: 'Votre portefeuille était vide. Votre site reste en ligne jusqu\'au {date}, puis il sera mis hors ligne automatiquement.',
        descriptionNoDate: 'Votre portefeuille était vide. Rechargez-le pour que votre site reste en ligne.',
        button: 'Recharger le portefeuille',
      },
      suspended: {
        title: 'Votre site est hors ligne, faute de paiement',
        description: 'Les frais mensuels n\'ont pas pu être prélevés. Vos visiteurs ne voient plus rien. Rechargez votre portefeuille pour le remettre en ligne — vos contenus, catégories et réglages sont intacts.',
        button: 'Recharger et republier',
      },
      private: {
        title: 'Site privé',
        description: 'Passez à un plan Pro pour rendre votre site accessible publiquement.',
      },
      draft: {
        title: 'Votre chaîne est un brouillon',
        description: 'Personne ne la voit encore : ses visiteurs trouvent une page « Bientôt en ligne » tant que vous ne la mettez pas en ligne. L\'aperçu vous la montre telle qu\'elle sera.',
        button: 'Mettre en ligne',
      },
      // The channel's own fee in its dunning (4.2): read by a billing manager only.
      feeUnpaid: {
        title: 'La dernière échéance de la chaîne n’a pas pu être réglée',
        description:
          'Sans recharge, la chaîne sera mise hors ligne le {date}. | Sans recharge, la chaîne sera mise hors ligne le {date}, dans 1 jour. | Sans recharge, la chaîne sera mise hors ligne le {date}, dans {n} jours.',
      },
      feeSuspended: {
        title: 'La chaîne est hors ligne pour impayé',
        description: 'Une recharge la remet en ligne d’elle-même jusqu’au {date}. Ensuite, il faudra la republier.',
      },
      feeTopUp: 'Recharger',
      takenDown: {
        title: 'Votre chaîne est hors ligne',
        description: 'Ses visiteurs trouvent une page « Bientôt en ligne ». Vos contenus et vos réglages sont intacts : remettez-la en ligne quand vous voulez.',
        button: 'Remettre en ligne',
      },
      offline: {
        title: 'Site en maintenance',
        description: 'Votre site est actuellement en mode maintenance et n\'est pas accessible au public.',
        button: 'Remettre en ligne',
        error: 'La remise en ligne a échoué.',
        stale: 'Quelqu\'un a enregistré avant vous : rien n\'a été écrit. La chaîne vient d\'être relue.',
      },
      publishConfirm: {
        title: 'Publier le site',
        description: 'Êtes-vous sûr de vouloir publier votre site ? Il sera accessible publiquement.',
      },
      onlineConfirm: {
        title: 'Remettre en ligne',
        description: 'Êtes-vous sûr de vouloir remettre votre site en ligne ?',
      },
    },
    setupSteps: {
      title: 'Premiers pas',
      subtitle: 'Complétez ces étapes pour finaliser la mise en place de votre site.',
      completed: 'terminées',
      steps: {
        security: {
          title: 'Configurer la sécurité',
          description: 'Définissez les paramètres d\'authentification de votre site.',
          actionConfigure: 'Configurer',
          actionEdit: 'Modifier',
        },
        url: {
          title: 'Ajouter votre propre domaine',
          description: 'Faites répondre votre site sur une adresse qui vous appartient déjà.',
          actionSet: 'Ajouter',
          actionEdit: 'Modifier',
        },
        category: {
          title: 'Créer des catégories',
          description: 'Organisez votre contenu en créant des catégories.',
          actionCreate: 'Créer',
          actionAdd: 'Ajouter',
        },
        media: {
          title: 'Ajouter des médias',
          description: 'Importez vos vidéos, images et autres contenus.',
          actionImport: 'Importer',
          actionAdd: 'Ajouter',
        },
        design: {
          title: 'Personnaliser le design',
          description: 'Adaptez l\'apparence de votre site à votre image.',
          action: 'Personnaliser',
        },
        monetization: {
          actionSee: 'Voir ma demande',
        },
        users: {
          title: 'Inviter des utilisateurs',
          description: 'Ajoutez des collaborateurs ou des membres à votre site.',
          actionStart: 'Démarrer',
          actionInvite: 'Inviter',
        },
      },
    },
    latestCategories: {
      title: 'Dernières catégories créées',
      seeMore: 'Voir tout',
      items: 'contenu',
      items_plural: 'contenus',
      emptyState: {
        title: 'Aucune catégorie',
        description: 'Créez votre première catégorie pour organiser votre contenu.',
        buttonText: 'Créer une catégorie',
      },
    },
    latestItems: {
      title: 'Derniers contenus publiés',
      titleSingle: 'Votre contenu',
      seeMore: 'Voir tout',
      // Le pendant de `shapePromotion.message` : les deux phrases nomment les
      // mêmes trois choses dans le même ordre, c'est ce qui fait reconnaître la
      // seconde comme l'accomplissement de la première.
      add: 'Ajouter un contenu',
      secondUnlocks:
        'Un deuxième contenu et votre chaîne devient un catalogue : catégories, liste des médias et recherche apparaissent d\'eux-mêmes.',
      draft: 'Brouillon',
      paid: 'Payant',
      types: {
        video: 'Vidéo',
        audio: 'Audio',
        image: 'Image',
        document: 'Document',
        playlist: 'Playlist',
        media: 'Média',
        other: 'Autre',
      },
      emptyState: {
        title: 'Aucun contenu',
        description: 'Importez vos premiers médias pour les afficher sur votre site.',
        buttonText: 'Ajouter un contenu',
      },
    },
    pendingAccessRequests: {
      title: 'Demandes d\'accès en attente',
      seeMore: 'Voir tout',
    },
    latestUsers: {
      title: 'Derniers utilisateurs inscrits',
      seeMore: 'Voir tout',
      roles: {
        owner: 'Propriétaire',
        staff: 'Staff',
        fullAccess: 'Accès complet',
      },
      labels: {
        added: 'Ajouté le',
        lastActivity: 'Dernière activité',
        active: 'Actif',
        inactive: 'Inactif',
      },
      emptyState: {
        title: 'Aucun utilisateur',
        descriptionWithoutAuth: 'Activez l\'authentification pour permettre aux utilisateurs de s\'inscrire.',
        descriptionWithAuth: 'Invitez des utilisateurs à rejoindre votre site.',
        buttonWithoutAuth: 'Configurer l\'authentification',
        buttonWithAuth: 'Inviter des utilisateurs',
      },
    },
    statistics: {
      title: 'Statistiques',
      subtitle: 'Performances des 30 derniers jours.',
      seeAll: 'Voir tout',
      videoViews: {
        title: 'Lectures',
        subtitle: '30 derniers jours',
        comparison: 'vs période précédente',
      },
      watchTime: {
        title: 'Temps de lecture moyen',
        subtitle: 'Par lecture',
      },
      uniqueViewers: {
        title: 'Visiteurs uniques',
        subtitle: '30 derniers jours',
        progress: 'Taux de complétion',
      },
      registeredUsers: {
        title: 'Utilisateurs inscrits',
        subtitle: 'Total',
      },
      trafficSources: {
        title: 'Sources de trafic',
        comingSoon: 'Bientôt',
        noData: 'Données non disponibles',
      },
    },
    tutorials: {
      title: 'Apprends en 5 minutes',
      viewAll: 'Tous les tutoriels',
      readingTime: '{minutes} min de lecture',
    },
    monetization: {
      title: 'Monétisation',
      heading: 'Monétisez votre contenu',
      description: 'Générez des revenus en vendant des abonnements et l\'accès à du contenu premium.',
      features: {
        securePayments: 'Paiements sécurisés',
        subscriptions: 'Abonnements récurrents',
        promoCodes: 'Codes promotionnels',
        salesDashboard: 'Tableau de bord des ventes',
      },
      offerTitle: 'Vendez vos contenus',
      offerDescription: 'Proposez vos contenus à l\'unité ou par abonnement. L\'ouverture demande une courte validation de notre part.',
      featureHints: {
        securePayments: 'Carte, virement, Apple Pay',
        subscriptions: 'Mensuels ou annuels, renouvelés seuls',
        promoCodes: 'Remises et périodes d\'essai',
        salesDashboard: 'Revenus, abonnés, transactions',
      },
      activate: 'Activer la monétisation',
      seeRequest: 'Voir ma demande',
      learnMore: 'En savoir plus',
      enabled: {
        title: 'Monétisation',
        subtitle: 'Active',
        subtitleHint: 'Gérez vos ventes, abonnements et codes promo.',
        paymentsPending: 'Paiements non connectés',
        salesOverview: 'Ventes',
        manageSubscriptions: 'Abonnements',
        managePrices: 'Catalogue',
        promoCodes: 'Codes promo',
        settings: 'Paramètres',
      },
    },
    stats: {
      items: 'Éléments',
      categories: 'Catégories',
      users: 'Utilisateurs',
      domains: 'Domaines',
    },
    quickActions: {
      title: 'Actions rapides',
      categories: 'Gérer les catégories',
      items: 'Gérer les éléments',
      users: 'Gérer les utilisateurs',
      settings: 'Paramètres',
    },
    info: {
      title: 'Informations du site',
      domain: 'Domaine principal',
      created: 'Créé le',
      theme: 'Thème',
    },
  },
  create: {
    title: 'Créer une chaîne',
    resumed: 'Brouillon repris',
    startOver: 'Recommencer',
    help: 'Besoin d\'aide ?',
    skip: 'Passer',
    success: 'Chaîne créée.',
    lastQuestion: 'Dernière question',
    questionsLeft: 'Plus que {count} questions',
    questionsLeftOne: 'Plus qu\'une question',
    errors: {
      creation: 'La chaîne n\'a pas pu être créée.',
      draft: 'La chaîne a été créée mais est restée en ligne.',
      nameRequired: 'Votre chaîne a d\'abord besoin d\'un nom.',
      addressUnavailable: 'Cette adresse n\'est plus disponible. Choisissez-en une autre.',
      notMigrated: 'La chaîne n\'a pas pu être créée : votre organisation est encore servie par l\'ancienne plateforme. La création s\'ouvrira une fois sa migration terminée.',
      handleTaken: 'La chaîne n\'a pas pu être créée : « {handle} » est déjà l\'identifiant d\'une autre chaîne. Changez l\'adresse, puis réessayez.',
      conflict: 'La chaîne n\'a pas pu être créée. Soit « {handle} » est déjà l\'identifiant d\'une autre chaîne — changez alors l\'adresse —, soit votre organisation est encore servie par l\'ancienne plateforme, et la création s\'ouvrira une fois sa migration terminée.',
      changeAddress: 'Changer l\'adresse',
      partial: 'Votre chaîne existe, mais {parts} n\'a pas pu être appliqué.',
      accessNotApplied: 'le réglage d\'accès',
      logoNotApplied: 'le logo',
      catalogueNotSeeded: 'le catalogue',
    },
    welcome: {
      notMigrated: 'Votre organisation est encore servie par l\'ancienne plateforme : la création d\'une chaîne ici ouvrira une fois sa migration faite.',
      title: 'Créer votre chaîne',
      subtitle: 'Une chaîne, c\'est votre site de vidéos : une adresse à vous, votre catalogue, vos couleurs.',
      meta: '6 questions · deux minutes',
      stepsLabel: 'En trois temps',
      step1: 'La mise en page',
      step1Hint: 'La forme de votre catalogue, puis un modèle.',
      step2: 'Votre identité',
      step2Hint: 'Un nom, une phrase, une couleur.',
      step3: 'Votre contenu',
      step3Hint: 'Ce qu\'on publie tout de suite, et qui peut le voir.',
      outcomeLabel: 'À la fin',
      outcomeAddress: 'votre-chaine.{domain}',
      outcome: 'Une adresse à partager. Le site reste en brouillon tant que vous ne le publiez pas.',
      start: 'Commencer',
      fine: 'Rien n\'est définitif : tout se modifie ensuite.',
    },
    detect: {
      rich: '<strong>{assets} médias</strong> dans votre espace, dont {sorted} {folders}.',
      richOne: '<strong>1 média</strong> dans votre espace, rangé dans un dossier.',
      richSorted: '<strong>{count}</strong> rangés',
      richSortedOne: '<strong>1</strong> rangé',
      richFolders: 'dans {count} dossiers',
      richFoldersOne: 'dans 1 dossier',
      unsorted: '<strong>{assets} médias</strong> dans votre espace, aucun rangé dans un dossier.',
      unsortedOne: '<strong>1 média</strong> dans votre espace, qui n\'est rangé dans aucun dossier.',
      light: '<strong>{assets} médias</strong> dans votre espace.',
      empty: 'Votre espace est vide — <strong>on monte le site d\'abord</strong>, vous ajouterez vos vidéos ensuite.',
    },
    shape: {
      title: 'Que publiez-vous ?',
      titleEmpty: 'Combien de contenus comptez-vous publier ?',
      subtitle: 'Cela décide des blocs posés sur votre page d\'accueil. Rien n\'est figé : le site s\'adaptera quand votre catalogue grandira.',
      suggested: 'suggéré',
      suggestedFrom: 'D\'après les {assets} médias de votre espace.',
      single: 'Un seul contenu',
      singleHint: 'Un film, une conférence, un webinaire',
      small: 'Une petite sélection',
      smallHint: 'Quelques contenus, sans rangement',
      catalog: 'Un catalogue',
      catalogHint: 'Rangé par catégories, avec recherche',
    },
    template: {
      title: 'Choisissez un modèle',
      colourNote: 'Couleur du modèle, modifiable à l\'étape suivante.',
      comingSoon: 'Bientôt',
      comingSoonNote: 'Le mode formation arrive bientôt. Ce modèle s\'ouvrira à ce moment-là.',
    },
    identity: {
      title: 'Votre identité',
      subtitle: 'Trois champs, et le site à droite devient le vôtre.',
      name: 'Nom du site',
      address: 'Adresse :',
      handle: 'Identifiant :',
      domainNote: 'Vous avez déjà un nom de domaine ? Vous pourrez le brancher depuis les réglages, une fois le site créé.',
      pitch: 'En une phrase, qu\'est-ce qu\'on trouve chez vous ?',
      pitchHint: 'Elle devient le sous-titre de votre accueil et la description affichée quand on partage le lien.',
      logo: 'Logo',
      optional: 'facultatif',
      logoHint: 'Il apparaît en tête de votre site, à côté du nom.',
      color: 'Couleur principale',
      colorCustom: 'Une autre couleur',
      checking: 'vérification…',
      available: 'disponible',
      addressRefused: 'Cette adresse n\'est pas disponible.',
      chooseAnother: 'Choisissez une autre adresse : votre site garde son nom, seule l\'adresse doit être unique.',
      handleLabel: 'Adresse du site',
      addressPinned: 'L\'adresse ne suit plus le nom du site.',
      addressUseName: 'Utiliser {address}',
      colorHint: 'Pré-remplie depuis le modèle.',
    },
    content: {
      title: 'Votre contenu',
      subtitle: 'Chaque dossier devient une catégorie. Tout est coché — décochez ce qui doit rester dehors.',
      subtitleEmpty: 'Rien dans votre espace pour l\'instant. Démarrez maintenant — l\'import tourne pendant que vous continuez.',
      drop: 'Déposez vos premiers médias',
      dropHint: 'Vidéos, images, sons — {count} fichiers au maximum ici',
      uploadRunning: '{done} sur {count} envoyés. L\'envoi continue pendant que vous répondez, et vos médias rejoindront la chaîne dès qu\'ils seront prêts.',
      uploadCapped: 'On n\'envoie que {count} fichiers depuis ici — ajoutez le reste depuis votre médiathèque ensuite.',
      later: 'Je le ferai plus tard',
      loading: 'Lecture de votre médiathèque…',
      folderCount: '{count} dossiers',
      folderCountOne: '{count} dossier',
      itemsLabel: '{count} médias',
      itemsLabelOne: '{count} média',
      categoriesLabel: '{count} catégories',
      categoriesLabelOne: '{count} catégorie',
      selectAll: 'Tout cocher',
      unselectAll: 'Tout décocher',
      consequence: '<strong>{items}</strong> publiés dans <strong>{categories}</strong>.',
      consequenceOne: '<strong>{items}</strong> publié dans <strong>{categories}</strong>.',
      consequenceNone: 'Rien de coché : votre chaîne est créée <strong>vide</strong> et reste en brouillon.',
      unsorted: 'Médias hors dossier',
      unsortedNote:
        'Les médias hors dossier sont publiés sans catégorie : ils apparaissent au catalogue et dans la recherche, mais ne garnissent aucun rayon de la page d\'accueil.',
      consequenceLoose: '<strong>{items}</strong> publiés, sans catégorie.',
      consequenceLooseOne: '<strong>{items}</strong> publié, sans catégorie.',
      consequenceMixed:
        '<strong>{items}</strong> publiés : {sorted} dans {categories}, {loose} sans catégorie.',
      subtitleSingle: 'Lequel publiez-vous ?',
      pickLabel: 'Le contenu à publier',
      showMore: 'Voir plus ({count})',
      consequenceSingle:
        'Votre page d\'accueil s\'ouvrira sur ce contenu. Vous pourrez en publier d\'autres ensuite.',
      consequenceNoPick:
        'Rien de choisi : votre chaîne est créée <strong>vide</strong> et reste en brouillon.',
      noMedia:
        'Rien de publiable dans votre espace pour l\'instant. Votre chaîne est créée vide et vous ajouterez votre contenu depuis la médiathèque.',
      noFolders:
        'Vos médias ne sont pas encore rangés dans des dossiers : il n\'y a rien à transformer en catégories. Votre chaîne est créée vide et vous ajouterez le contenu depuis la médiathèque.',
    },
    access: {
      title: 'Qui peut voir votre site ?',
      subtitle: 'Première des deux questions d\'accès. Celle-ci ne parle pas d\'argent.',
      open: 'Tout le monde',
      openHint: 'Le site est public, trouvable par les moteurs et par les modèles',
      account: 'Les personnes qui ont un compte',
      accountHint: 'Il faut se connecter pour accéder aux contenus',
      free: 'Chacun peut créer son compte',
      freeHint: 'Inscription libre, vous gardez la main sur les droits',
      invite: 'Sur invitation seulement',
      inviteHint: 'Vous décidez qui entre, un par un ou par groupe',
      openConsequence: 'Un site public est le seul qui puisse être trouvé — par les moteurs comme par les modèles de langage.',
      freeConsequence: 'Le catalogue reste visible et référençable, seuls les contenus demandent un compte.',
      inviteConsequence: 'Vos contenus ne seront pas référencés : personne ne peut voir la page d\'accueil sans compte.',
    },
    money: {
      title: 'Est-ce payant ?',
      subtitle: 'Deuxième question d\'accès, indépendante de la première.',
      free: 'Tout est gratuit',
      freeHint: 'Aucun paiement, aucune formule',
      freemium: 'Une partie gratuite, le reste payant',
      freemiumHint: 'De quoi donner envie avant de demander de payer',
      accountsNote: 'On n\'achète pas sans compte : on active les comptes visiteurs pour vous. Votre site reste consultable sans connexion.',
      reviewNote: 'La vente s\'ouvre après une courte validation, que vous demanderez depuis Réglages › Monétisation de votre chaîne, une fois votre site créé.',
      sellLater: 'Votre chaîne pourra vendre ses contenus plus tard — à l\'achat, à la location ou par abonnement — depuis ses écrans de vente. Rien n\'est rendu payant ici.',
    },
    preview: {
      withAnswers: 'Aperçu · avec vos réponses',
      withTemplate: 'Modèle {name} · avec vos réponses',
      hintTitle: 'Votre site, en train de se faire.',
      hintText: 'Il change à chaque réponse ; les vidéos affichées ne sont pas encore les vôtres.',
      desktop: 'Ordinateur',
      mobile: 'Mobile',
      tag: 'aperçu',
      ghostEmpty: 'Vos contenus viendront ici.',
      ghostUnselected: 'Vous n\'avez pas encore choisi vos contenus.',
      ghostHint: 'Sur le site publié, une section sans contenu ne s\'affiche pas du tout.',
    },
    ready: {
      title: 'Votre site est prêt à être créé',
      subtitle: 'Vérifiez ce qui va être posé. Votre chaîne naît en brouillon : personne ne la voit tant que vous ne la mettez pas en ligne.',
      create: 'Créer ma chaîne',
      receiptItems: '{items} médias',
      receiptItemsOne: '{items} média',
      receiptCategories: '{categories} catégories',
      receiptCategoriesOne: '{categories} catégorie',
      receiptEmpty: 'Rien pour l\'instant',
      summaryTemplate: 'Modèle',
      summaryAddress: 'Adresse',
      summaryAccess: 'Accès',
      summaryContent: 'Contenu',
      summaryContentValue: '{items} dans {categories}',
      summaryContentSingle: 'Un seul contenu',
      summaryContentImporting: '{count} médias en cours d\'envoi',
      summaryContentEmpty: 'Rien pour l\'instant',
      done: 'Votre chaîne existe',
      doneSubtitle: 'Elle est en brouillon : personne ne peut la voir tant que vous ne la mettez pas en ligne.',
      onlineSubtitle: 'Toute personne qui a l\'adresse peut la regarder.',
      address: 'Votre adresse',
      addressManage: 'Gérer',
      copy: 'Copier',
      copied: 'Copié',
      missingContent: 'Il vous manque une chose pour publier : du contenu.',
      importArriving: 'Vos {count} médias finissent d\'être préparés. Ils rejoindront votre chaîne tout seuls, sans que vous ayez à y revenir.',
      importPending: 'Vos {count} médias finissent d\'être préparés. Ajoutez-les à votre chaîne dès qu\'ils sont prêts.',
      publishable: 'Votre catalogue est en place. Il ne reste plus qu\'à publier.',
      visit: 'Voir mon site',
      publish: 'Mettre ma chaîne en ligne',
      published: 'Votre chaîne est en ligne.',
      online: 'Votre chaîne est en ligne : l\'adresse ci-dessus fonctionne pour tout le monde.',
      leftover: '{count} médias n\'ont pas pu être ajoutés. Publiez le reste depuis la médiathèque.',
      leftoverTruncated: 'Votre sélection dépassait ce qu\'une création publie d\'un coup : le reste n\'a pas été ajouté. Publiez-le depuis la médiathèque.',
      leftoverLink: 'Ajouter le reste',
      addContent: 'Ajouter mes contenus',
      openEditor: 'Ouvrir l\'éditeur',
      monetization: 'Configurer la vente',
      dashboard: 'Aller à la chaîne',
    },
  },
  categories: {
    conflict: 'Quelqu\'un a enregistré cette catégorie avant vous : rien n\'a été écrit. L\'écran vient d\'être relu — reprenez votre modification et réenregistrez.',
    saveSuccess: 'Catégorie enregistrée',
    saveError: 'Échec de l\'enregistrement de la catégorie',
    moveError: 'Impossible de déplacer cette catégorie',
    duplicateSlug: 'Une catégorie répond déjà à cette adresse. Choisissez un autre nom.',
    slugTaken: 'Une autre catégorie utilise déjà cette adresse. Choisissez-en une autre.',
    maskedByParent: 'Masquée (parent désactivé)',
    deleteDone: 'Catégorie supprimée — {promoted} sous-catégorie(s) remontée(s), {unfiled} contenu(s) désormais sans catégorie.',
    itemCount: '{count} contenu(s)',
    title: 'Catégories',
    description: 'Réorganisez vos catégories par glisser-déposer pour définir leur ordre ou leur arborescence.',
    btnCreateCategory: 'Créer une catégorie',
    searchPlaceholder: 'Rechercher des catégories...',
    deleteTitle: 'Supprimer la catégorie',
    deleteMessage: 'Êtes-vous sûr de vouloir supprimer « {name} » ? Elle sera retirée du site.',
    deleteKeepsItems: 'Son contenu ne sera pas supprimé : il passera sans catégorie. | Ses {count} contenus ne seront pas supprimés : ils passeront sans catégorie.',
    deleteMovesChildren: 'Sa sous-catégorie remonte d\'un niveau. | Ses {count} sous-catégories remontent d\'un niveau.',
    addSubcategory: 'Ajouter une sous-catégorie',
    emptySubcategories: 'Aucune sous-catégorie',
    inline: {
      namePlaceholder: 'Nom de la sous-catégorie...',
    },
    empty: {
      title: 'Aucune catégorie',
      description: 'Créez votre première catégorie pour commencer à organiser votre contenu.',
      noResults: 'Aucune catégorie trouvée',
      noResultsDescription: 'Essayez d\'ajuster vos filtres ou vos termes de recherche.',
    },
    stats: {
      total: 'Total',
      active: 'Actifs',
      items: 'Contenus classés',
    },
    filters: {
      all: 'Tous',
      active: 'Actif',
      inactive: 'Inactif',
    },
    table: {
      title: 'Titre',
      description: 'Description',
      parent: 'Parent',
      root: '— (premier niveau)',
      items: 'Contenus',
      status: 'Statut',
    },
    emptyState: {
      title: 'Aucune catégorie créée',
      description: 'Cliquez sur "Créer une catégorie" pour ajouter votre première catégorie.',
    },
    danger: {
      title: 'Zone dangereuse',
      description: 'Actions qui retirent des éléments du site',
      deleteTitle: 'Supprimer cette catégorie',
      deleteDescription: 'Une fois supprimée, la catégorie disparaît du site. Ses contenus ne sont pas supprimés : ils passent sans catégorie, et ses sous-catégories remontent d\'un niveau.',
      deleteButton: 'Supprimer la catégorie',
    },
    newCategory: 'Nouvelle catégorie',
    saveCategoryFirst: 'Enregistrez la catégorie pour activer cet onglet',
    createSuccess: 'Catégorie créée avec succès',
    createError: 'Échec de la création de la catégorie',
    updateSuccess: 'Catégorie mise à jour avec succès',
    updateError: 'Échec de la mise à jour de la catégorie',
    deleteSuccess: 'Catégorie supprimée avec succès',
    deleteError: 'Échec de la suppression de la catégorie',
    invalidForm: 'Veuillez remplir tous les champs requis',
    tabs: {
      information: 'Informations',
      items: 'Contenus',
      access: 'Droits d\'accès',
    },
    sections: {
      information: {
        title: 'Informations de la catégorie',
        description: 'Configurez le nom, le slug et la description de la catégorie.',
      },
      seo: {
        title: 'SEO',
        description: 'Optimisez l\'apparence de cette catégorie dans les résultats de recherche.',
      },
      appearance: {
        title: 'Apparence',
        description: 'Personnalisez les aspects visuels de votre catégorie.',
      },
      visibility: {
        title: 'Paramètres de visibilité',
        description: 'Contrôlez où et comment votre catégorie apparaît.',
      },
    },
    fields: {
      name: 'Nom de la catégorie',
      namePlaceholder: 'ex. Tutoriels',
      slug: 'Slug URL',
      slugPlaceholder: 'tutoriels',
      slugHint: 'L\'adresse de la catégorie sur le site (/categories/votre-slug/). La modifier laisse une redirection depuis l\'ancienne.',
      description: 'Description',
      descriptionPlaceholder: 'Décrivez cette catégorie...',
      seoTitle: 'Titre SEO',
      seoTitlePlaceholder: 'Titre affiché dans les résultats de recherche',
      seoTitleHint: 'Recommandé : 50 à 60 caractères. Laissez vide pour utiliser le nom de la catégorie.',
      seoDescription: 'Description SEO',
      seoDescriptionPlaceholder: 'Courte description affichée dans les résultats de recherche',
      seoDescriptionHint: 'Recommandé : 150 à 160 caractères.',
      parentCategory: 'Catégorie parente',
      parentCategoryPlaceholder: 'Aucune (racine)',
      icon: 'Icône',
      iconHelper: 'Taille recommandée : 64x64. Utilisée uniquement dans les blocs « Catégories » de l\'éditeur de pages.',
      thumbnail: 'Vignette',
      thumbnailHelper: 'Image carrée, 600x600 recommandé — la carte de catégorie est carrée.',
      banner: 'Image de bannière',
      bannerHelper: 'Taille recommandée : 1320x400. Affichée en en-tête selon le style de bannière défini pour la page catégorie au niveau de l\'éditeur.',
      color: 'Couleur d\'accentuation',
      colorPlaceholder: 'Aucune couleur sélectionnée',
      colorHelper: 'Couleur du titre de la page de la catégorie et de sa vignette. Sans couleur, le titre suit le thème du site et la vignette sa couleur principale.',
      isActive: 'Catégorie active',
      isActiveHelper: 'La catégorie est visible sur votre site',
      isOnHomepage: 'Afficher sur la page d\'accueil',
      isOnHomepageHelper: 'Afficher cette catégorie sur la page d\'accueil du site',
      isOnNavbar: 'Afficher dans la barre de navigation',
      isOnNavbarHelper: 'Inclure cette catégorie dans la navigation principale',
    },
    validation: {
      nameRequired: 'Le nom de la catégorie est requis',
      nameTooShort: 'Le nom doit contenir au moins 2 caractères',
      nameTooLong: 'Le nom ne doit pas dépasser 100 caractères',
      nameNoAddress: 'Le nom doit contenir au moins une lettre ou un chiffre : l\'adresse de la catégorie en est tirée.',
      slugRequired: 'Le slug URL est requis',
      slugInvalid: 'Le slug ne peut contenir que des lettres minuscules, des chiffres et des tirets',
    },
    display: {
      title: 'Affichage',
      description: 'Configurez l\'affichage des contenus dans cette catégorie.',
      bannerItem: 'Contenu de la bannière',
      bannerItemHint: "La vidéo sur laquelle s'ouvre la page de cette catégorie",
      bannerItemAuto: 'Le premier contenu qui se lit',
      useManualOrdering: 'Tri manuel',
      useManualOrderingHint: 'Glissez-déposez les contenus pour définir leur ordre',
      automaticOrderBy: 'Trier par',
      automaticOrderByPlaceholder: 'Sélectionner un ordre de tri',
      orderOptions: {
        created_at: 'Date de création',
        published_at: 'Date de publication',
        title: 'Titre (A-Z)',
        '-title': 'Titre (Z-A)',
        '-created_at': 'Plus récent d\'abord',
        '-published_at': 'Dernier publié',
      },
    },
    itemsTab: {
      manualOrderNotEditable: 'L\'ordre manuel déjà enregistré est respecté sur le site, mais il ne se réarrange pas depuis cet écran.',
      title: 'Contenus',
      description: 'Gérez les contenus inclus dans cette catégorie.',
      emptyTitle: 'Aucun contenu dans cette catégorie',
      emptyDescription: 'Ajoutez du contenu pour l\'afficher dans cette catégorie.',
      btnAdd: 'Ajouter des contenus',
      addExisting: 'Ajouter des contenus existants',
      importFromMediasbox: 'Importer depuis Mediasbox',
      addItems: 'Ajouter des contenus',
      restrictedAlert: '{count} contenu(s) en accès restreint',
      restrictedAlertLink: 'Gérer les accès dans l\'onglet Droits d\'accès',
      itemCount: {
        zero: '0 contenus',
        one: '1 contenu',
        other: '{count} contenus',
      },
      removeDialog: {
        title: 'Retirer le contenu',
        description: 'Que souhaitez-vous faire avec "{name}" ?',
        removeFromCategory: 'Retirer de la catégorie',
        deleteItem: 'Supprimer le contenu',
      },
      toast: {
        itemsAdded: 'Contenus ajoutés à la catégorie',
        itemRemoved: 'Contenu retiré de la catégorie',
        itemDeleted: 'Contenu supprimé',
        reorderSaved: 'Ordre des contenus enregistré',
        reorderFailed: 'Échec de l\'enregistrement de l\'ordre',
        addFailed: 'Échec de l\'ajout des contenus',
        removeFailed: 'Échec du retrait du contenu',
        deleteFailed: 'Échec de la suppression du contenu',
      },
      orderBy: {
        updatedAsc: 'Modification (plus ancienne d\'abord)',
        updatedDesc: 'Modification (plus récente d\'abord)',
        position: 'Manuel (glisser-déposer)',
        nameAsc: 'Nom (A-Z)',
        nameDesc: 'Nom (Z-A)',
        createdAsc: 'Créé (plus ancien)',
        createdDesc: 'Créé (plus récent)',
        publishedAsc: 'Publié (plus ancien)',
        publishedDesc: 'Publié (plus récent)',
      },
      table: {
        title: 'Titre',
        published: 'Publié',
        actions: '',
      },
      itemPickerModal: {
        title: 'Ajouter des contenus existants',
        searchPlaceholder: 'Rechercher des contenus...',
        noItems: 'Aucun contenu disponible à ajouter.',
        noResults: 'Aucun contenu ne correspond à votre recherche.',
        addSelected: 'Ajouter ({count})',
        column: {
          title: 'Titre',
          type: 'Type',
          status: 'Statut',
        },
      },
    },
    accessTab: {
      expired: 'Expiré',
      categoryOnly: 'Cet accès couvre cette catégorie seule, pas ses sous-catégories.',
      subcategoriesTitle: 'Sa sous-catégorie s\'ouvre séparément, depuis son propre écran d\'accès : | Ses sous-catégories s\'ouvrent séparément, chacune depuis son propre écran d\'accès :',
      fullAccessTitle: 'Accès complet',
      fullAccessHint: 'Ces utilisateurs et groupes voient tous les contenus de la chaîne, ceux-ci compris. Cet accès se retire depuis leur fiche.',
      fullAccessGroup: 'Groupe · {count} membre(s)',
      fullAccessChip: 'Accès complet',
      grantCounts: 'Ouverte à {groups} groupe(s) et {members} membre(s).',
      moreItems: 'D\'autres contenus sont classés ici — cette liste montre la première page.',
      title: 'Contenus à accès restreint',
      description: 'Ces contenus ne sont visibles que par les utilisateurs et groupes autorisés ci-dessous.',
      noRestrictedItems: 'Aucun contenu restreint dans cette catégorie. La gestion des accès concerne uniquement les contenus restreints.',
      authorizedTitle: 'Utilisateurs et groupes autorisés',
      authorizedDescription: 'Utilisateurs et groupes ayant accès aux {count} contenu(s) restreint(s).',
      btnGrantAccess: 'Accorder l\'accès',
      btnRevoke: 'Révoquer',
      noAuthorized: 'Aucun utilisateur ou groupe n\'a encore accès aux contenus restreints.',
      usersTitle: 'Utilisateurs',
      groupsTitle: 'Groupes',
      itemAccessCount: '{count}/{total} contenus restreints',
      memberCount: '{count} membre(s)',
      revokeDialogTitle: 'Révoquer l\'accès',
      revokeDialogMessage: 'Révoquer l\'accès de « {name} » à tous les contenus restreints de cette catégorie ?',
      revokeSuccess: 'Accès révoqué avec succès',
      revokeError: 'Échec de la révocation de l\'accès',
      levels: {
        public: 'Public',
        authenticated: 'Authentifié',
        restricted: 'Restreint',
      },
      table: {
        title: 'Titre',
        accessLevel: 'Niveau d\'accès',
      },
      modal: {
        title: 'Gérer les droits d\'accès de la catégorie',
        usersTab: 'Utilisateurs',
        groupsTab: 'Groupes',
        searchUsers: 'Rechercher des utilisateurs...',
        searchGroups: 'Rechercher des groupes...',
        userColumn: 'Utilisateur',
        groupColumn: 'Groupe',
        membersColumn: 'Membres',
        noUsers: 'Aucun utilisateur trouvé',
        noGroups: 'Aucun groupe trouvé',
        grantSuccess: 'Droits d\'accès mis à jour avec succès',
        grantError: 'Échec de la mise à jour des droits d\'accès',
      },
    },
    addItemsModal: {
      title: 'Ajouter des contenus à la catégorie',
      alreadyInCategory: '{count} contenu(s) déjà dans cette catégorie — ils seront ignorés.',
      tabs: {
        channelContent: 'Contenus du channel',
        mediaLibrary: 'Bibliothèque média',
      },
      channelContent: {
        searchPlaceholder: 'Rechercher des contenus...',
        noItems: 'Aucun contenu disponible à ajouter.',
        noResults: 'Aucun contenu ne correspond à votre recherche.',
        addSelected: 'Ajouter la sélection ({count})',
        column: {
          title: 'Titre',
          type: 'Type',
          status: 'Statut',
        },
      },
      mediaLibrary: {
        description: 'Sélectionnez des médias depuis votre bibliothèque pour les ajouter comme nouveaux contenus ou lier des contenus existants à cette catégorie.',
        browseButton: 'Parcourir la bibliothèque',
        badgeInChannel: 'Déjà dans la chaîne',
        badgeInCategory: 'Déjà dans la catégorie',
        existingInfo: '{count} contenu(s) déjà dans votre channel — sera(ont) ajouté(s) directement à cette catégorie.',
        newInfo: '{count} nouveau(x) contenu(s) — sera(ont) publié(s) comme nouveau(x) contenu(s).',
        goBack: 'Modifier la sélection',
        publishBtn: 'Publier',
        addBtn: 'Ajouter à la catégorie',
        addAndPublishBtn: 'Ajouter et publier',
      },
      toast: {
        success: '{count} contenu(s) ajouté(s) à la catégorie',
        successMixed: '{existing} existant(s) + {created} nouveau(x) contenu(s) ajouté(s)',
        error: 'Échec de l\'ajout des contenus',
      },
    },
    editCategory: {
      btnBack: 'Retour aux catégories',
      btnAddContent: 'Ajouter un contenu',
      information: 'Informations',
      access: 'Droits d\'accès',
      itemsTitle: 'Contenus',
      btnDelete: 'Supprimer cette catégorie',
      info: {
        name: 'Nom',
        description: 'Description',
        url: 'URL dans le site',
        parentDescription: 'Si aucun choix n\'est sélectionné ci-dessous, cette catégorie sera à la racine.',
        parentLabel: 'Catégorie parente',
        visibility: {
          title1: 'Visibilité de la catégorie',
          subtitle1: 'En désactivant cette option, cette catégorie ne sera plus visible sur le site.',
          title2: 'Afficher sur la page d\'accueil',
          subtitle2: 'En désactivant cette option, cette catégorie ne sera plus visible sur la page d\'accueil du site.',
          title3: 'Afficher dans la barre de navigation',
          subtitle3: 'En désactivant cette option, cette catégorie ne sera plus visible dans la barre de navigation.',
        },
      },
      accessRights: {
        description1: 'Les droits d\'accès définis ici s\'appliqueront à toutes les vidéos',
        description2: 'Non répertoriée',
        description3: 'de cette catégorie.',
        noItem: 'Aucun contenu restreint dans cette catégorie.',
        btnAddAccessRight: 'Ajouter un droit d\'accès',
        user: 'Utilisateur',
        group: 'Groupe',
        title1: 'Utilisateur / Groupe',
        title2: 'Type',
      },
      items: {
        title: 'Contenus',
        description: 'Gérez les contenus inclus dans cette catégorie.',
        emptyState: 'Aucun contenu dans cette catégorie',
        btnAdd: 'Ajouter des contenus',
        btnDeleteSelected: 'Supprimer la sélection',
        btnAutorizeUsers: 'Autoriser des utilisateurs',
        noAccessItems: 'contenus sont en accès restreint',
        views: 'vues',
        sampleVideo1: 'Introduction à Vue.js',
        samplePlaylist1: 'Documentation projet API',
      },
    },
  },
  form: {
    sortNameAsc: 'Nom (A-Z)',
    sortNameDesc: 'Nom (Z-A)',
    sortDateAsc: 'Plus ancien',
    sortDateDesc: 'Plus récent',
  },
  // Les anciennes adresses de la chaîne — ce que le site public consulte avant de répondre
  // « page introuvable ».
  redirects: {
    title: 'Redirections',
    subtitle: 'Les anciennes adresses que votre site continue de faire suivre.',
    btnCreate: 'Ajouter une redirection',
    table: {
      path: 'Ancienne adresse',
      target: 'Mène vers',
      origin: 'Écrite par',
      created: 'Créée le',
    },
    kinds: {
      item: 'Contenu',
      category: 'Catégorie',
      page: 'Page',
      article: 'Article',
    },
    origins: {
      import: 'Migration',
      rename: 'Renommage',
      manual: 'Manuelle',
      importHint: 'Écrite lors de la reprise depuis l\'ancienne plateforme.',
      renameHint: 'Écrite automatiquement quand l\'adresse de l\'objet a changé.',
      manualHint: 'Saisie à la main, pour une adresse que ce produit n\'a jamais servie.',
    },
    empty: {
      title: 'Aucune redirection',
      description: 'Changer l\'adresse d\'un contenu, d\'une catégorie ou d\'une page publiée en écrit une automatiquement. Vous pouvez aussi en saisir une pour une adresse venue d\'un ancien site.',
    },
    create: {
      title: 'Ajouter une redirection',
      description: 'L\'ancienne adresse mènera désormais à l\'objet choisi. Une redirection existante sur la même adresse est remplacée.',
      path: 'Ancienne adresse',
      pathPlaceholder: '/ancienne-page/',
      pathHint: 'À partir de la barre oblique, sans paramètre ni ancre. Comparée caractère par caractère, la barre oblique finale étant facultative.',
      target: 'Mène vers',
      targetHint: 'Tapez pour chercher parmi les contenus de la chaîne.',
      success: 'Redirection ajoutée',
      error: 'Échec de l\'ajout de la redirection',
      refused: 'Cette adresse ne peut pas être redirigée : le site de la chaîne y répond lui-même (connexion, catalogue, pages légales…), ou elle est mal formée.',
      occupied: 'Un contenu, une page, une catégorie ou un article de la chaîne répond déjà à cette adresse, et le site l\'affiche avant de lire une redirection. Changez d\'abord son adresse, ou choisissez-en une autre.',
    },
    delete: {
      title: 'Supprimer la redirection',
      message: 'L\'adresse {path} répondra de nouveau « page introuvable ». Confirmer ?',
      success: 'Redirection supprimée',
      error: 'Échec de la suppression',
    },
  },
  items: {
    // Le média derrière une publication n'est plus lisible : la pastille nomme la cause
    // plutôt que de laisser lire « brouillon » là où l'auteur n'a rien fait.
    assetStatus: {
      notReady: 'Média indisponible',
      error: 'Média en erreur',
      hint: "Le média de la médiathèque n'est pas encore lisible : ce contenu ne se joue pas sur le site tant qu'il ne l'est pas.",
    },
    order: {
      newest: 'Les plus récents d\'abord',
      oldest: 'Les plus anciens d\'abord',
    },
    inEveryPlan: 'Inclus dans tous les abonnements',
    loadMore: 'Charger la suite',
    loadedCount: '{count} contenu(s) affiché(s)',
    // Le pager de la liste, quand elle sait compter ce qu'elle parcourt.
    pager: {
      range: '{first}–{last} sur {total}',
      rangeUncounted: '{first}–{last}',
      perPage: 'Par page',
      previous: 'Page précédente',
      next: 'Page suivante',
    },
    allMatchingSelected: 'Les {count} contenus correspondant au filtre sont sélectionnés.',
    bulkDone: '{count} contenu(s) traité(s)',
    bulkPartial: '{done} contenu(s) traité(s), {failed} en échec',
    bulkFailed: 'Aucun contenu n\'a pu être traité',
    // Bandeau de chiffres de la fiche : avec un seul contenu, les chiffres de la
    // chaîne sont ceux du contenu.
    numbers: {
      views: 'Vues',
      completion: 'Vu en entier',
      completionHint: 'Part de la lecture menée jusqu\'au bout, en moyenne.',
      viewers: 'Spectateurs',
      watchTime: 'Temps de visionnage',
      purchases: 'Achats',
      revenue: 'Revenus',
    },
    title: 'Contenus',
    subtitle: 'Gérez les contenus publiés sur votre site.',
    searchPlaceholder: 'Rechercher des contenus...',
    btnAdd: 'Ajouter des contenus',
    filterByAccess: 'Niveau d\'accès',
    filterByType: 'Type',
    filterByStatus: 'Statut',
    filterByCategory: 'Catégorie',
    filterUncategorized: 'Sans catégorie',
    table: {
      title: 'Titre',
      type: 'Type',
      status: 'Statut',
      access: 'Accès',
      pricing: 'Tarification',
      engagement: 'Engagement',
      date: 'Date',
    },
    accessLevel: {
      public: 'Public',
      authenticated: 'Connectés',
      restricted: 'Restreint',
      accessRequest: 'Sur demande',
    },
    status: {
      archived: 'Archivé',
      published: 'Publié',
      unpublished: 'Programmé',
      scheduled: 'Programmé',
      scheduledOn: 'Programmé le {date}',
      draft: 'Brouillon',
      mediaDeleted: 'Média supprimé',
      mediaDeletedHint: 'Le média a été supprimé de la médiathèque : ce contenu est repassé en brouillon et n\'est plus visible sur le site. Restaurez le média depuis la corbeille (30 jours) pour pouvoir le republier.',
    },
    unlisted: {
      label: 'Non répertorié',
      hint: 'Ce contenu est en ligne et accessible par son lien, mais il n\'apparaît dans aucune liste publique : ni le catalogue, ni les catégories, ni la recherche.',
    },
    types: {
      video: 'Vidéo',
      audio: 'Audio',
      image: 'Image',
      collection: 'Collection',
      thirdParty: 'Vidéo externe',
    },
    visibility: {
      public: 'Public',
      private: 'Privé',
      notListed: 'Non répertorié',
    },
    type: {
      video: 'Vidéo',
      playlist: 'Playlist',
      image: 'Image',
      audio: 'Audio',
      document: 'Document',
    },
    emptyState: {
      title: 'Aucun contenu',
      description: 'Ajoutez vos premiers contenus pour les afficher sur votre site.',
      noResults: 'Aucun contenu trouvé',
      noResultsDescription: 'Essayez d\'ajuster vos filtres ou vos termes de recherche.',
    },
    deleteTitle: 'Supprimer le contenu',
    deleteMessage: 'Êtes-vous sûr de vouloir supprimer « {title} » ? Il sera retiré du site, avec ses prix, ses accès accordés et ses commentaires. Le média reste dans votre médiathèque.',
    deleteSuccess: 'Contenu supprimé avec succès',
    deleteError: 'Échec de la suppression du contenu',
    addSuccess: '{count} contenu(s) ajouté(s) avec succès',
    addError: 'Échec de l\'ajout des contenus',
    paid: 'Payant',
    free: 'Gratuit',
    noPricing: 'Aucun tarif',
    priceCount: '{count} prix | {count} prix',
    subscriptionCount: '{count} abo | {count} abos',
    bulkSelected: '{count} contenu(s) sélectionné(s)',
    selectAllMatching: 'Sélectionner les {count} correspondants',
    selectAllCapped: 'Sélectionner les {max} premiers',
    bulkSelectCapped: '{max} max par action groupée',
    bulkSelectError: 'Impossible de tout sélectionner',
    publish: 'Publier',
    publishOn: 'Publier le {date}',
    schedule: 'Programmer',
    unpublish: 'Dépublier',
    publishSuccess: 'Contenu publié',
    scheduleSuccess: 'Contenu programmé',
    scheduleSuccessOn: 'Sera publié le {date}',
    publishError: 'Échec de la publication',
    unpublishSuccess: 'Contenu repassé en brouillon',
    unpublishError: 'Échec de la dépublication',
    unpublishConfirmTitle: 'Dépublier ce contenu ?',
    unpublishConfirmMessage: 'Il repassera en brouillon et sera retiré du site public. Il reste dans votre back-office et peut être republié à tout moment.',
    unpublishOrDeleteHint: 'Si vous ne comptez pas le republier, vous pouvez aussi le supprimer depuis la zone de danger.',
    bulkPublish: 'Publier',
    bulkUnpublish: 'Dépublier',
    bulkUnpublishTitle: 'Dépublier {count} contenu(s) ?',
    bulkUnpublishMessage: 'Ils repasseront en brouillon et seront retirés du site public. Ils restent dans votre back-office et peuvent être republiés à tout moment.',
    bulkStatusSuccess: '{count} contenu(s) mis à jour',
    bulkStatusError: 'Erreur lors de la mise à jour des contenus',
    bulkEdit: 'Modifier en lot',
    bulkEditSuccess: '{count} contenu(s) mis à jour avec succès',
    bulkEditError: 'Erreur lors de la mise à jour des contenus',
    bulkDelete: 'Supprimer',
    bulkDeleteModal: {
      title: 'Supprimer {count} contenu(s)',
      message: 'Les contenus sélectionnés seront retirés du site et de leurs catégories, avec leurs prix, leurs accès accordés et leurs commentaires. Les médias restent dans votre médiathèque.',
      confirmLabel: 'Tapez {count} pour confirmer',
      confirmHint: 'Entrez le nombre de contenus à supprimer',
    },
    bulkDeleteSuccess: '{count} contenu(s) supprimé(s) avec succès',
    bulkDeleteError: 'Échec de la suppression des contenus',
    bulkAddPrice: 'Appliquer un prix',
    bulkPriceSuccess: 'Prix appliqué à {count} contenus',
    bulkPriceError: 'Erreur lors de l\'application du prix',
    bulkEditModal: {
      title: 'Modifier en lot',
      subtitle: '{count} contenu(s) sélectionné(s)',
      enableAccessLevel: 'Changer le niveau d\'accès',
      enableCategories: 'Ajouter des catégories',
      categoriesHint: 'Les catégories seront ajoutées aux existantes, pas remplacées.',
      enableAccessRights: 'Configurer les droits d\'accès',
      accessRightsHint: 'Les groupes et utilisateurs sélectionnés auront accès à tous les contenus sélectionnés.',
      enablePrice: 'Appliquer un prix',
      priceDisabledHint: 'Changez d\'abord le niveau d\'accès en Payant',
      priceMonetizationDisabledHint: 'Activez d\'abord la monétisation dans les paramètres du site',
      paidNoPriceHint: 'Contenus en accès payant — pensez à ajouter un prix pour que les utilisateurs puissent acheter l\'accès.',
      applyChanges: 'Appliquer les modifications',
      noChanges: 'Aucune modification à appliquer',
    },
    addModal: {
      title: 'Ajouter des contenus à la chaîne',
      existingInfo: '{count} contenu(s) déjà dans votre chaîne — ils seront ignorés.',
      newInfo: '{count} nouveau(x) contenu(s) seront publiés.',
      allExisting: 'Tous les contenus sélectionnés sont déjà dans votre chaîne.',
      goBack: 'Modifier la sélection',
      publishBtn: 'Publier ({count})',
      badgeInChannel: 'Déjà dans la chaîne',
      badgeNew: 'Nouveau',
      viewItem: 'Voir le contenu',
      scheduleTitle: 'Programmer la publication',
      scheduleDateLabel: 'Date de publication',
      scheduleBtn: 'Programmer ({count})',
      showPreview: 'Aperçu avant publication',
      showPreviewHint: 'Afficher un aperçu même avant la date de publication.',
      toast: {
        success: '{count} contenu publié | {count} contenus publiés',
        successSkipped: '{count} contenu publié (déjà dans la chaîne : {skipped}) | {count} contenus publiés (déjà dans la chaîne : {skipped})',
        allFailed: 'Le contenu n\'a pas pu être créé. | Aucun des {count} contenus n\'a pu être créé.',
        partialSuccess: '{success} contenu publié, en échec : {failed} | {success} contenus publiés, en échec : {failed}',
      },
    },
    addStepper: {
      title: 'Ajouter des contenus',
      subtitle: '{count} contenu(s) sélectionné(s)',
      back: 'Retour',
      next: 'Suivant',
      steps: {
        selection: 'Sélection',
        visibility: 'Visibilité',
        categories: 'Catégories',
      },
      validation: {
        required: 'Veuillez compléter les champs requis',
      },
      publish: {
        visibilityTitle: 'Visibilité',
        accessLevel: 'Niveau d\'accès',
        paid: 'Payant',
        categoriesTitle: 'Catégories',
        advancedOptions: 'Options avancées',
      },
      visibility: {
        restrictedTitle: 'Droits d\'accès',
        restrictedDescription: 'Sélectionnez les groupes et utilisateurs qui auront accès à ces contenus.',
        groupsLabel: 'Groupes',
        groupsPlaceholder: 'Sélectionner des groupes...',
        usersLabel: 'Utilisateurs',
        usersPlaceholder: 'Sélectionner des utilisateurs...',
        priceTemplateTitle: 'Modèle de prix',
        priceTemplateDescription: 'Appliquer un prix par défaut à tous les contenus créés.',
        paidConfigTitle: 'Configuration des tarifs',
        paidConfigDescription: 'Choisissez comment vos utilisateurs accèdent à ce contenu payant. Vous pouvez combiner abonnements et tarification individuelle.',
        subscriptionCardTitle: 'Abonnements',
        subscriptionCardSubtitle: 'Inclure dans des formules d\'abonnement existantes',
        priceCardTitle: 'Prix individuel',
        priceCardSubtitle: 'Définir un prix d\'achat ou de location',
        paidValidationWarning: 'Sélectionnez au moins un abonnement, ou ajoutez un tarif avec un nom et un montant, pour continuer.',
        paidValidationTooltip: 'Configurez vos tarifs',
      },
      categories: {
        description: 'Organisez vos contenus en les assignant à des catégories.',
        emptyWarning: 'Aucune catégorie sélectionnée — ce contenu sera publié mais n\'apparaîtra pas dans la navigation par catégories de votre chaîne. Il restera accessible via la recherche, la page « Tout le contenu » et son lien direct.',
      },
      processing: {
        creating: 'Création des contenus...',
        permissions: 'Configuration des droits d\'accès...',
        prices: 'Application des prix...',
      },
      toast: {
        permissionsPartial: 'Échec de la configuration des permissions sur {failed}/{total} contenus.',
        pricesPartial: 'Échec de l\'application du modèle de prix sur certains contenus.',
      },
      monetization: {
        selectPlansTitle: 'Abonnements',
        selectPlansDescription: 'Associez ces contenus à des abonnements pour que les abonnés puissent y accéder.',
        selectPlans: 'Sélectionnez les abonnements qui incluront ces contenus :',
        noPlans: 'Aucun abonnement configuré',
        noPlansDescription: 'Créez d\'abord un abonnement pour y rattacher des contenus payants.',
        manageSubscriptions: 'Gérer les abonnements',
        fullAccess: 'Accès complet',
        fullAccessNotice: 'Ces abonnements donnent accès à tout le catalogue : ces contenus y sont déjà inclus, rien à sélectionner.',
        periods: {
          daily: 'jour',
          weekly: 'semaine',
          monthly: 'mois',
          yearly: 'an',
          days: '{count} jours',
        },
      },
    },
    detail: {
      conflict: 'Quelqu\'un a enregistré ce contenu avant vous : rien n\'a été écrit. L\'écran vient d\'être relu — reprenez votre modification et réenregistrez.',
      viewInMediasbox: 'Voir dans Mediasbox',
      tabs: {
        general: 'Général',
        access: 'Accès',
        monetization: 'Monétisation',
        sales: 'Ventes',
        comments: 'Commentaires',
      },
      backToItems: 'Retour aux contenus',
      saveSuccess: 'Contenu mis à jour avec succès',
      saveError: 'Échec de la mise à jour du contenu',
      information: {
        title: 'Informations',
        description: 'Identifiant et URL publique de ce contenu.',
        slug: 'Slug URL',
        slugHint: 'Caractères autorisés : a-z, 0-9, tirets',
        slugPrefix: '/',
        viewOnChannel: 'Ouvrir sur la chaîne',
        publishedAt: 'Publié le',
        slugChangeWarning: 'Modifier le slug change l\'URL publique et casse les liens et intégrations existants.',
      },
      publication: {
        title: 'Publication',
        description: 'Gérez quand et où ce contenu est visible.',
        statusLabel: 'Statut',
        dateHint: 'Une date future programme le contenu — il sera mis en ligne automatiquement à cette date.',
        draftDateHint: 'Appliquée quand vous publiez le contenu : vide, il prend la date du jour ; une date future le programme.',
        dayAtTime: '{day} à {time}',
        goesLiveHint: 'Sera mis en ligne automatiquement à cette date.',
        draftBanner: 'Ce contenu est en brouillon : masqué du site public, visible uniquement ici. Publiez-le pour le mettre en ligne.',
      },
      categories: {
        title: 'Catégories',
        description: 'Organisez ce contenu en l\'ajoutant dans une ou plusieurs catégories.',
        categories: 'Catégories',
        categoriesPlaceholder: 'Sélectionner des catégories',
        primaryCategory: 'Catégorie principale',
        primaryCategoryPlaceholder: 'Sélectionner une catégorie principale',
        primaryCategoryHint: 'Définit le fil d\'Ariane sur la page publique et sert à suggérer des contenus associés.',
      },
      access: {
        expired: 'Expiré',
        title: 'Accès',
        description: 'Choisissez qui peut voir ce contenu.',
        level: 'Niveau d\'accès',
        publicHint: 'Ce contenu sera visible par tout le monde.',
        authenticatedHint: 'Accès réservé aux utilisateurs connectés de votre site.',
        restrictedHint: 'Accès limité à une sélection d\'utilisateurs ou de groupes.',
        accessRequestHint: 'L\'utilisateur doit soumettre une demande qui sera approuvée par un administrateur.',
        paidGrantHint: 'Offrez l\'accès à ce contenu à un membre ou un groupe, sans qu\'il ait à payer.',
        accessRequestGrantHint: 'Accorder l\'accès ici revient à approuver une demande : le membre ou le groupe voit ce contenu sans avoir à le demander. Les demandes que vous approuvez apparaissent aussi dans cette liste.',
        noGrantedPaid: 'Aucun accès offert pour l\'instant : ce contenu s\'ouvre à l\'achat ou par abonnement.',
        noGrantedAccessRequest: 'Aucun accès accordé pour l\'instant : ce contenu s\'ouvre aux membres dont vous approuvez la demande.',
        offerAccessLink: 'Offrir l\'accès',
        paidUnavailable: {
          closed: 'La vente n\'est pas encore ouverte sur cette chaîne.',
          needsAccounts: 'L\'ouvrir activera aussi les comptes visiteurs, nécessaires pour acheter. Votre site reste consultable sans connexion.',
          closedAction: 'Ouvrir la vente',
          review: 'Votre demande de vente est en cours d\'examen. Nous vous écrivons dès qu\'elle est traitée.',
          rejected: 'Votre demande de vente a été refusée.',
          rejectedAction: 'Voir le motif',
          waiting: 'En examen',
        },
        configureAccessLink: 'Configurer les droits d\'accès',
        manageAccess: 'Gérer les accès (utilisateurs / groupes)',
        noAuthorized: 'Aucun utilisateur ou groupe n\'a encore accès à ce contenu.',
        usersTitle: 'Utilisateurs',
        groupsTitle: 'Groupes',
        memberCount: '{count} membre(s)',
        fullAccessTitle: 'Accès complet',
        fullAccessHint: 'Ces utilisateurs et groupes voient tous les contenus de la chaîne. Cet accès se retire depuis leur fiche.',
        fullAccessGroup: 'Groupe · {count} membre(s)',
        openHolder: 'Ouvrir la fiche',
        btnRevoke: 'Révoquer',
        revokeDialogTitle: 'Révoquer l\'accès',
        revokeDialogMessage: 'Êtes-vous sûr de vouloir révoquer l\'accès pour « {name} » ?',
        revokeSuccess: 'Accès révoqué avec succès',
        revokeError: 'Échec de la révocation de l\'accès',
        saveSuccess: 'Accès mis à jour avec succès',
        saveError: 'Échec de la mise à jour des accès',
        modal: {
          fullAccessChip: 'Accès complet',
          title: 'Gérer les droits d\'accès',
          usersTab: 'Utilisateurs',
          groupsTab: 'Groupes',
          searchUsers: 'Rechercher des utilisateurs...',
          searchGroups: 'Rechercher des groupes...',
          userColumn: 'Utilisateur',
          groupColumn: 'Groupe',
          membersColumn: 'Membres',
          noUsers: 'Aucun utilisateur trouvé',
          noGroups: 'Aucun groupe trouvé',
        },
      },
      options: {
        title: 'Options',
        description: 'Paramètres supplémentaires pour ce contenu.',
        isListed: 'Répertorié',
        isListedHint: 'Le contenu apparaît dans les listes et les résultats de recherche',
        allowComments: 'Autoriser les commentaires',
        allowCommentsHint: 'Les visiteurs peuvent commenter ce contenu',
        commentsOff: 'Les commentaires sont désactivés sur la chaîne.',
        newsletterOff: 'La newsletter est désactivée sur la chaîne.',
        channelOptionsLink: 'Options de la chaîne',
        isNewsletterEligible: 'Éligible newsletter',
        isNewsletterEligibleHint: 'Inclure dans les notifications de la newsletter',
        isDownloadable: 'Autoriser le téléchargement',
        isDownloadableHint: 'Les visiteurs peuvent télécharger le fichier original',
        isEmbeddable: 'Autoriser l\'intégration',
        isEmbeddableHint: 'Ce contenu peut être intégré sur d\'autres sites',
        showPreview: 'Aperçu avant publication',
        showPreviewHint: 'Afficher un aperçu avant la date de publication',
        isShownLocked: 'Afficher verrouillé',
        isShownLockedHint: 'La page et la vignette restent visibles, sans lecture, pour qui n\'y a pas accès. Désactivé, le contenu est introuvable pour eux.',
      },
      embed: {
        action: 'Intégrer',
        title: 'Intégrer ce contenu',
        intro: 'Collez ce code sur n\'importe quel site. Un contenu libre s\'y lit ; un contenu payant, sur demande ou réservé aux membres y montre sa bande-annonce, ou une carte, qui renvoie vers sa page sur votre chaîne.',
        code: 'Code à coller',
        link: 'Lien du lecteur',
        copyCode: 'Copier le code',
        copyLink: 'Copier le lien',
        copied: 'Copié',
        size: 'Taille',
        responsive: 'Responsive',
        audioHint: 'Un lecteur audio est une bande de hauteur fixe : il occupe la largeur disponible, sans notion de format.',
        responsiveHint: 'Le lecteur occupe la largeur disponible sur la page hôte et garde son format.',
        fixedHint: 'Taille fixe en pixels. Sur une page plus étroite, le lecteur débordera.',
        ratio: 'Format',
        options: 'Options du lecteur',
        showTitleBar: 'Afficher le titre et le nom de la chaîne',
        showEndCard: 'Afficher une carte de fin après la lecture',
        autoPlay: 'Démarrer la lecture automatiquement',
        autoPlayHint: 'La plupart des navigateurs le bloquent si le lecteur n\'est pas muet',
        disabledWebsite: 'L\'intégration est désactivée pour cette chaîne. Activez-la dans les options de la chaîne pour obtenir un code.',
        disabledItem: 'L\'intégration est désactivée pour ce contenu. Activez « Autoriser l\'intégration » dans l\'onglet Général, section Options, puis enregistrez.',
        disabledNoDomain: 'Cette chaîne n\'a pas encore de domaine. Publiez-la pour obtenir un code d\'intégration.',
      },
      paid: {
        trial: '{period} d\'essai',
        planConflict: 'Cet abonnement a été modifié entre-temps : rien n\'a été écrit. Rouvrez l\'onglet et recommencez.',
        planSaveError: 'Échec de la mise à jour de l\'abonnement',
        priceConflict: 'Ce tarif a été modifié entre-temps : rien n\'a été écrit. Rouvrez le tarif et recommencez.',
        title: 'Monétisation',
        description: 'Configurez la tarification et l\'accès par abonnement pour ce contenu.',
        hint: 'Ce contenu est disponible à l\'achat ou via des abonnements.',
        configureMonetizationLink: 'Configurer la monétisation',
        monetizationNotEnabled: 'La monétisation n\'est pas activée sur ce site.',
        enableLink: 'Activer',
        trailer: 'Bande-annonce',
        trailerHint: 'Un court aperçu affiché aux visiteurs avant qu\'ils achètent l\'accès.',
        trailerChange: 'Changer',
        trailerEmptyTitle: 'Sélectionner une bande-annonce',
        trailerEmptyDescription: 'Cliquez pour parcourir votre bibliothèque vidéo',
        trailerDialogTitle: 'Sélectionner une bande-annonce',
        subscriptions: 'Abonnements',
        subscriptionsDescription: 'Sélectionnez les plans d\'abonnement qui donnent accès à ce contenu.',
        inEveryPlan: 'Inclus dans toutes les formules',
        inEveryPlanHint: 'Toutes les formules d\'abonnement de la chaîne donnent accès à ce contenu, y compris celles créées plus tard.',
        selectSubscriptions: 'Sélectionner les plans d\'abonnement',
        selectSubscriptionsPlaceholder: 'Choisir les plans...',
        saveSubscriptions: 'Enregistrer les abonnements',
        subscriptionsSaveSuccess: 'Associations d\'abonnements mises à jour',
        subscriptionsSaveError: 'Échec de la mise à jour des associations d\'abonnements',
        selectAll: 'Tout sélectionner',
        deselectAll: 'Tout désélectionner',
        noPlans: 'Aucun plan d\'abonnement',
        noPlansDescription: 'Créez d\'abord des plans d\'abonnement, puis revenez ici pour les associer à ce contenu.',
        manageSubscriptions: 'Gérer les abonnements',
        recommended: 'Recommandé',
        trialDays: '{count}j d\'essai gratuit',
        subscribers: '{count} abonnés',
        fullAccess: 'Accès complet',
        fullAccessNoticeTitle: 'Également inclus dans vos abonnements « accès complet »',
        fullAccessNoticeDescription: 'Ces abonnements donnent accès à tout le catalogue : ce contenu y est déjà inclus, rien à sélectionner. Ils apparaissent sur la fiche publique sous « Ou accédez à tout le contenu de cette plateforme ».',
        periodDaily: 'jour',
        periodWeekly: 'semaine',
        periodMonthly: 'mois',
        periodYearly: 'an',
        periodDays: '{count} jours',
        prices: 'Prix',
        addPrice: 'Ajouter un prix',
        noPrices: 'Aucun prix configuré.',
        priceCreateSuccess: 'Prix créé avec succès',
        priceUpdateSuccess: 'Prix mis à jour avec succès',
        priceDeleteSuccess: 'Prix supprimé avec succès',
        priceDeleteError: 'Échec de la suppression du prix',
        priceSaveError: 'Échec de l\'enregistrement du prix',
        setupRequired: 'Ce contenu est défini comme payant mais n\'a pas encore de tarification. Ajoutez au moins un prix ou sélectionnez un abonnement pour que les utilisateurs puissent y accéder.',
      },
      sales: {
        title: 'Ventes',
        description: 'Achats de ce contenu.',
        searchPlaceholder: 'Rechercher par client...',
        filterStatus: 'Statut',
        filterType: 'Type',
        table: {
          customer: 'Client',
          price: 'Prix',
          type: 'Type',
          status: 'Statut',
          date: 'Date',
        },
        status: {
          active: 'Actif',
          expired: 'Expiré',
          refunded: 'Remboursé',
          cancelled: 'Annulé',
        },
        type: {
          purchase: 'Achat',
          rental: 'Location',
        },
        emptyState: {
          title: 'Aucune vente',
          description: 'Les ventes apparaîtront ici une fois que des clients achèteront ce contenu.',
          noResults: 'Aucune vente trouvée',
          noResultsDescription: 'Essayez d\'ajuster vos filtres ou termes de recherche.',
        },
      },
      comments: {
        description: 'Voir et modérer les commentaires sur ce contenu.',
      },
      trailer: {
        title: 'Bande-annonce',
        description: 'Un aperçu que les visiteurs peuvent lancer sans ouvrir le contenu.',
        hint: 'Sur un contenu payant, c\'est ce que voient les visiteurs qui n\'ont pas encore acheté l\'accès. Sur un contenu gratuit, c\'est une accroche.',
      },
      danger: {
        title: 'Zone dangereuse',
        description: 'Actions qui retirent des éléments du site',
        deleteTitle: 'Supprimer ce contenu',
        deleteDescription: 'Une fois supprimé, ce contenu est retiré de votre site. Le média reste dans votre médiathèque.',
        deleteButton: 'Supprimer le contenu',
      },
    },
  },
  editor: {
    // Le média d'un hero partagé ou centré : une image choisie, ou une vidéo par
    // son adresse (le sélecteur de fichiers ne stocke que des images).
    heroFields: {
      mediaType: 'Type de média',
      image: 'Image',
      video: 'Vidéo',
      videoUrl: 'Adresse de la vidéo (MP4)',
      videoUrlHint: 'Lue en boucle et sans le son, à côté du texte.',
    },
    // Échecs des quatre étapes de l'enregistrement. Elles s'enchaînaient sans
    // filet : une seule qui échouait emportait les suivantes, et le bouton
    // paraissait ne rien faire. Chaque étape dit désormais son propre échec.
    blocksSaveError: "Les blocs n'ont pas pu être enregistrés.",
    blocksReorderError: "L'ordre des blocs n'a pas pu être enregistré.",
    blocksStale: 'Quelqu\'un a modifié cette page entre-temps. Rien n\'a été enregistré : la page a été rechargée.',
    // The canvas: the page being edited, drawn by the channel's own site. When it
    // cannot be drawn it says why, rather than showing an empty frame an operator
    // would read as a broken channel.
    canvas: {
      frameTitle: 'Aperçu de la page en cours d\'édition',
      unavailableTitle: 'Aperçu indisponible',
      noHost:
        "Cette chaîne ne répond encore sur aucune adresse : connectez-en une dans l'onglet Domaine pour voir l'aperçu de ses pages. En attendant, les blocs s'ajoutent, se règlent et s'enregistrent normalement.",
      unavailable:
        "L'aperçu n'a pas pu être préparé. Les blocs s'ajoutent, se règlent et s'enregistrent normalement ; pour voir le résultat, ouvrez le site de la chaîne.",
      openSite: 'Ouvrir le site',
      blockCount: 'aucun bloc | 1 bloc sur cette page | {count} blocs sur cette page',
      loadFailed: "L'aperçu n'a pas pu être mis à jour : il montre la dernière version affichée.",
      bandRefused: 'Ce bloc ne peut pas être affiché tel quel — {reason}',
      savedMenus:
        "Les menus modifiés apparaîtront dans l'aperçu une fois enregistrés.",
    },
    // Whom the preview is drawn for: the visitors the channel's door knows.
    viewAs: {
      label: 'Voir en tant que',
      stranger: 'Visiteur anonyme',
      sharedPassword: 'Visiteur avec le mot de passe',
      member: 'Membre',
      hint: "L'aperçu montre la page telle que ce visiteur la voit. Le membre n'a ici que son inscription : aucun achat, abonnement, groupe ni accès accordé — les contenus payants restent verrouillés.",
    },
    // Les trois pages que la chaîne sert depuis son catalogue : elles n'ont pas
    // de blocs à elles, leur allure vient du modèle de la chaîne.
    templatePages: {
      categoryList: 'Page Catégories',
      categoryDetail: 'Page Catégorie',
      itemDetail: 'Page Contenus',
    },
    // Les réglages des trois pages que la chaîne tire de son catalogue.
    templatePageSettings: {
      pages: {
        categoryList: { title: 'Page Catégories', description: 'Affichage de la liste des catégories' },
        categoryDetail: { title: 'Page Catégorie', description: 'Apparence de la page de détail d\'une catégorie' },
        itemDetail: { title: 'Page Contenus', description: 'Mise en page de la page de détail d\'un contenu' },
      },
      categoryDisplay: 'Mode d\'affichage',
      bannerStyle: 'Style de la bannière',
      bannerStyleHint: 'Le même style pour toutes les catégories. Chaque catégorie fournit ensuite son image, ou le contenu qu\'elle met à la une.',
      bannerStyles: {
        simple: 'Simple',
        simpleHint: 'Le titre et la description de la catégorie',
        framed: 'Encadré',
        framedHint: 'L\'image de la catégorie dans un cadre',
        hero: 'Héro',
        heroHint: 'L\'image de la catégorie en pleine largeur',
        featured: 'À la une',
        featuredHint: 'Un contenu en grand, la grille par-dessus : celui choisi sur la catégorie, sinon le premier',
      },
      rows: 'Rangées de sous-catégories',
      rowsHint: 'Les rangées démarrent toujours au bord du contenu. Ce réglage décide si elles s\'arrêtent à la largeur de la page ou si elles continuent hors écran.',
      itemStyle: 'Style de la page',
      options: {
        grid: 'Grille',
        gridHint: 'Affichage en grille',
        slider: 'Carousel',
        sliderHint: 'Défilement horizontal',
        contained: 'Dans la page',
        edge: 'Hors écran',
        cinematic: 'Cinématique',
        showcase: 'Showcase',
        spotlight: 'Lecteur centré',
        classic: 'Classique',
        minimal: 'Minimal',
        twoColumn: 'Deux colonnes',
      },
      // Le type de publication avec lequel le canevas dessine la page contenu ; rien n'est enregistré.
      previewKind: 'Type de contenu',
      previewKindContent: 'Contenu',
      previewKindCollection: 'Collection',
      previewKindHint: 'Choisissez le type de page à prévisualiser',
    },
    settingsSaveError: "Les réglages du site n'ont pas pu être enregistrés.",
    // La suppression est la seule action qui touchait le site en ligne : si le
    // serveur la refuse, dire que le bloc y est toujours évite de le croire parti.
    blockDeleteError: "Le bloc n'a pas pu être supprimé : il est toujours en ligne.",
    // Messages d'échec de la gestion des pages. Sans eux, chaque action ratée
    // partait dans la console : le bouton « Créer » ne faisait rien de visible.
    pageErrors: {
      addressReserved: "Cette adresse est réservée par le site de la chaîne — son catalogue, son blog, sa connexion, ses pages légales… Une page à cet endroit ne serait jamais affichée : choisissez une autre adresse.",
      addressTaken: "Cette adresse est déjà celle d'une autre page ou d'un contenu publié de la chaîne. Choisissez une autre adresse, ou changez d'abord celle de l'autre.",
      refused: "Cette modification est refusée. Une page d'accueil, par exemple, doit rester publique : changez son accès ou choisissez une autre page d'accueil.",
      load: "Les pages n'ont pas pu être chargées.",
      create: "La page n'a pas pu être créée.",
      save: "Les réglages de la page n'ont pas pu être enregistrés.",
      delete: "La page n'a pas pu être supprimée.",
      duplicate: "La page n'a pas pu être dupliquée.",
      publish: "La page n'a pas pu être publiée.",
      unpublish: "La page n'a pas pu être dépubliée.",
      setHomepage: "La page n'a pas pu devenir la page d'accueil.",
      // Quelqu'un a enregistré avant : rien n'a été écrit, et la page est
      // relue plutôt que d'écraser son travail.
      stale: "Quelqu'un a modifié cette page entre-temps. Rien n'a été enregistré : rechargez et réessayez.",
    },
    itemPicker: {
      // Libellés génériques : le bloc Médias laisse choisir n'importe quel
      // contenu de la chaîne, quel que soit son type.
      // L'état vide ne veut pas dire « rien ne s'affiche » : le bloc suit alors
      // le contenu le plus récemment publié. Ne pas le dire faisait croire à un
      // bloc muet à des créateurs dont la page marchait très bien.
      emptyTitle: 'Le contenu le plus récent',
      emptyDescription: 'Cliquez pour choisir un contenu précis à la place',
      dialogTitle: 'Sélectionner un contenu',
      add: 'Ajouter des contenus',
      select: 'Sélectionner des contenus',
      selectedCount: 'aucun sélectionné | 1 sélectionné | {count} sélectionnés',
      // Un bloc continue de nommer un contenu mis à la corbeille : le dire vaut
      // mieux qu'une puce qui reste vide.
      missing: 'Contenu supprimé',
      searchPlaceholder: 'Rechercher un contenu...',
      noResults: 'Aucun contenu trouvé',
      noItems: 'Aucun contenu disponible',
      // Libellés des sélecteurs restreints à un seul type (Hero, Chapitres,
      // Transcription) : dire « contenu » là où seules les vidéos sont listées
      // ferait chercher un podcast qui n'apparaîtra jamais.
      emptyTitleVideo: 'La vidéo la plus récente',
      emptyDescriptionVideo: 'Cliquez pour choisir une vidéo précise à la place',
      dialogTitleVideo: 'Sélectionner une vidéo',
      searchPlaceholderVideo: 'Rechercher une vidéo...',
      noResultsVideo: 'Aucune vidéo trouvée',
      noItemsVideo: 'Aucune vidéo disponible',
      change: 'Changer',
      paid: 'Payant',
      free: 'Gratuit',
      onRequest: 'Sur demande',
      paidNoPrice: 'Payant · aucun tarif',
      filterAll: 'Tous',
      filterVideo: 'Vidéos',
      filterAudio: 'Audio',
      filterImage: 'Images',
      filterCollection: 'Collections',
      typeVideo: 'Vidéo',
      typeAudio: 'Audio',
      typeImage: 'Image',
      typeCollection: 'Collection',
    },
    mediaPicker: {
      selectMedia: 'Choisir une image',
      library: 'Bibliothèque',
      upload: 'Importer',
      change: 'Changer',
      remove: 'Supprimer',
      video: 'Vidéo',
      dragOrClick: 'Glisser-déposer ou cliquer pour importer',
      fileTooLarge: 'Fichier trop volumineux (max {size} Mo)',
      invalidFileType: 'Type de fichier non pris en charge',
      uploadFailed: 'Échec de l\'import',
      libraryNoPicture: 'Ce média n\'a pas d\'image utilisable.',
      // Une image déjà enregistrée dont l'adresse n'est pas connue ici : rien
      // ne transforme l'identifiant d'un fichier en adresse signée, et un
      // encadré vide se lirait comme « aucune image ».
      savedNoPreview: 'Image enregistrée',
    },
    untitledPage: 'Page sans titre',
    editorTitle: 'Éditeur',
    pagePublished: 'Page publiée',
    pageDraft: 'Page en brouillon',
    draft: 'Brouillon',
    discard: 'Annuler les modifications',
    discardTitle: 'Annuler les modifications ?',
    discardConfirm: 'Tout ce qui n\'a pas été enregistré sera perdu : les blocs, l\'apparence, les menus et les réglages de la page.',
    discardConfirmAction: 'Tout annuler',
    leavePageTitle: 'Quitter cette page ?',
    leavePageConfirm: 'Les blocs et les réglages de cette page qui n\'ont pas été enregistrés seront perdus.',
    leavePageAction: 'Quitter sans enregistrer',
    blockCategories: {
      vod: 'VOD / Vidéo',
      layout: 'Mise en page',
      content: 'Contenu',
      interactive: 'Interactif',
      other: 'Autres',
    },
    leaveEditor: {
      title: 'Quitter l\'éditeur ?',
      text: 'Tout ce qui n\'a pas été enregistré sera perdu : les blocs, l\'apparence, les menus et les réglages de la page.',
      stay: 'Rester',
      leave: 'Quitter sans enregistrer',
    },
    // Le panneau d'un bloc : ses deux onglets, et chaque réglage de l'onglet Style.
    blockPanel: {
      tabs: { content: 'Contenu', style: 'Style' },
      content: {
        texts: 'Textes',
        title: 'Titre',
        subtitle: 'Sous-titre',
        description: 'Description',
        mediaType: {
          label: 'Type de média',
          all: 'Tous',
          videos: 'Vidéos',
          photos: 'Photos',
          hint: 'Vidéos : les vidéos et les collections de vidéos. Photos : les images et les albums.',
        },
      },
      style: {
        layout: 'Disposition',
        typography: 'Typographie',
        elements: {
          title: 'Titre',
          subtitle: 'Sous-titre',
          description: 'Description',
          body: 'Corps de texte',
          ctaPrimary: 'Bouton principal',
          ctaSecondary: 'Bouton secondaire',
        },
        questionColor: 'Couleur des questions',
        answerColor: 'Couleur des réponses',
        alignment: 'Alignement',
        horizontal: 'Horizontal',
        vertical: 'Vertical',
        buttons: 'Boutons',
        align: {
          left: 'Gauche',
          center: 'Centre',
          right: 'Droite',
          top: 'Haut',
          bottom: 'Bas',
          likeContent: 'Comme le contenu',
        },
        background: 'Arrière-plan',
        bgColor: 'Couleur',
        bgMedia: 'Média',
        bgGradient: 'Dégradé',
        pickColor: 'Choisir une couleur',
        mediaImage: 'Image',
        mediaVideo: 'Vidéo',
        videoUrl: 'Adresse de la vidéo (MP4)',
        videoUrlHint: 'Une adresse complète vers un fichier MP4, lu en boucle et sans le son.',
        videoStoredFileHint:
          'Un fichier vidéo enregistré avec ce bloc est lu en fond. Une adresse saisie ici le remplace.',
        videoPoster: 'Image affichée avant la lecture',
        videoSourceChannel: 'De la chaîne',
        videoSourceUrl: 'Par adresse',
        videoFromChannelHint:
          'Une vidéo de la chaîne, lue en boucle et sans le son, pour les visiteurs autorisés à la voir. Les autres voient l\'image ci-dessous, ou celle de la vidéo. Non lue dans l\'éditeur.',
        fitCover: 'Remplir',
        fitContain: 'Contenir',
        overlayEnable: 'Activer l\'overlay',
        opacity: 'Opacité',
        overlayOpacity: 'Opacité de l\'overlay',
        overlayColor: 'Couleur de l\'overlay',
        gradientOverlayNote: 'Le dégradé teinte déjà l\'arrière-plan. Pour l\'assombrir, choisissez des couleurs plus sombres ci-dessus.',
        size: 'Taille de la section',
        height: 'Hauteur',
        padding: 'Marges intérieures',
        heights: { auto: 'Auto', small: 'Petit', medium: 'Moyen', large: 'Grand', fullscreen: 'Plein écran' },
        paddings: { none: 'Aucune', small: 'Petites', medium: 'Moyennes', large: 'Grandes' },
      },
      textStyle: {
        font: 'Police',
        themeFont: 'Par défaut (thème)',
        size: 'Taille',
        sizes: {
          sm: 'Petit',
          base: 'Normal',
          lg: 'Grand',
          xl: 'XL',
          '2xl': '2XL',
          '3xl': '3XL',
          '4xl': '4XL',
          '5xl': '5XL',
          '6xl': '6XL',
          '7xl': '7XL',
          '8xl': '8XL',
        },
        bold: 'Gras',
        italic: 'Italique',
        caseAsTyped: 'Texte tel que saisi',
        caseUpper: 'TOUT EN MAJUSCULES',
        caseCapitalize: 'Initiale De Chaque Mot',
        alignLeft: 'Aligner cet élément à gauche',
        alignCenter: 'Centrer cet élément',
        alignRight: 'Aligner cet élément à droite',
        appearance: 'Apparence',
        shapes: { filled: 'Rempli', tonal: 'Tonal', outlined: 'Contour', text: 'Texte' },
        themeColour: 'Couleur du thème',
        buttonColour: 'Couleur du bouton',
        buttonTextColour: 'Couleur du texte',
        buttonTextColourAuto: 'Automatique',
        lineHeight: 'Interligne',
        letterSpacing: 'Espacement',
      },
      banner: {
        media: 'Média',
        mediaImage: 'Image',
        mediaVideo: 'Vidéo',
        videoUrl: 'Adresse de la vidéo (MP4)',
        videoUrlHint: 'Lue en boucle, sans le son, derrière le texte.',
        videoPoster: 'Image affichée pendant le chargement',
        videoPosterHint: 'Une adresse complète vers une image. Vide : l\'image de l\'onglet Style.',
      },
      newsletter: {
        invitation: 'Invitation',
        buttonText: 'Texte du bouton',
        buttonHint: 'Le bouton mène à la création d\'un compte sur la chaîne : aucune adresse n\'est collectée sans compte.',
        privacy: 'Confidentialité',
        showPrivacy: 'Afficher la mention de confidentialité',
        privacyText: 'Texte de la mention',
        privacyPlaceholder: 'En vous inscrivant, vous acceptez notre politique de confidentialité.',
      },
    },
    // The picker's starters (`mocks/blockPresets.ts`), by block type: the previous builder's examples.
    presets: {
      hero_section: {
        centered_video_background: 'Centré – vidéo en fond',
        centered_image_background: 'Centré – image en fond',
        centered_gradient_background: 'Centré – couleur unie',
        centered_media_below: 'Centré + média dessous',
        split_left_text_image: 'Texte à gauche, image',
        split_right_image_text: 'Image, texte à droite',
        overlay_bottom_content: 'Superposé – contenu en bas',
        featured_video_netflix_style: 'Vidéo à la une',
        compact_split_left: 'Compact – texte à gauche',
        compact_split_right: 'Compact – texte à droite',
      },
      banner: {
        image_banner: 'Bannière image',
        video_banner: 'Bannière vidéo',
        banner_with_text: 'Bannière avec texte',
      },
      search: {
        hero_search: 'Grande recherche',
        carte_flottante: 'Carte flottante',
        minimal: 'Minimale',
      },
      custom_html: {
        iframe: 'Iframe',
      },
      continue_watching: {
        reprendre_la_lecture: 'Reprendre la lecture',
      },
      blog: {
        blog_grid_standard: 'Grille standard',
        blog_carousel: 'Carrousel',
        featured_articles: 'Articles à la une',
        blog_list: 'Liste',
        compact_grid: 'Grille compacte',
      },
      categories: {
        grid_cards: 'Cartes en grille',
        grid_minimal: 'Grille minimale',
        grid_overlay: 'Grille superposée',
        grid_poster: 'Affiches en grille',
        carousel: 'Carrousel',
        carousel_poster: 'Carrousel d\'affiches',
        list_horizontal: 'Liste horizontale',
        list_detailed: 'Liste détaillée',
      },
      content_block: {
        texte_image_droite: 'Texte + image (droite)',
        texte_image_gauche: 'Texte + image (gauche)',
        texte_seul: 'Texte seul',
        image_seule: 'Image seule',
      },
      faq: {
        faq_simple_accordion: 'Accordéon simple',
        faq_premium_cartes_bord_es: 'Cartes bordées',
        faq_grille_cartes: 'Grille de cartes',
        faq_long_deux_colonnes: 'Deux colonnes',
      },
      features: {
        grid_3_colonnes: 'Grille 3 colonnes',
        alternating: 'En alternance',
        cards: 'Cartes',
      },
      items: {
        hero_carousel: 'Carrousel à la une',
        top_10_netflix_style: 'Top 10',
        derniers_ajouts: 'Derniers ajouts',
        films_populaires_grid: 'Populaires en grille',
        d_couvrir_backdrop: 'À découvrir (panoramique)',
        liste_d_taill_e: 'Liste détaillée',
        en_direct: 'En direct',
        item_en_vedette: 'Contenu en vedette',
        hero_carousel_portrait: 'À la une + affiches',
        showcase_derni_res_sorties: 'Vitrine – dernières sorties',
      },
      logo_cloud: {
        grid_partenaires: 'Grille de partenaires',
        carousel_ils_nous_font_confiance: 'Carrousel de logos',
        featured_partenaire_principal: 'Partenaire principal',
      },
      pricing: {
        cartes_modernes: 'Cartes',
        compact: 'Compact',
        horizontal: 'Horizontal',
      },
      team: {
        grille_4_colonnes: 'Grille 4 colonnes',
        carrousel_quipe: 'Carrousel',
        cartes_d_taill_es: 'Cartes détaillées',
        vue_compacte: 'Vue compacte',
        spotlight: 'Spotlight',
      },
      testimonials: {
        grille_3_colonnes: 'Grille 3 colonnes',
        citation_centr_e: 'Citation centrée',
        carrousel_moderne: 'Carrousel',
      },
    },
    homepage: 'Accueil',
    preview: 'Aperçu',
    save: 'Enregistrer',
    saved: 'Enregistré',
    siteSettings: 'Paramètres',
    addBlock: 'Ajouter un bloc',
    addThisBlock: 'Ajouter ce bloc',
    searchBlocks: 'Rechercher un bloc...',
    noBlocksFound: 'Aucun bloc trouvé',
    pageBlocks: 'Blocs de la page',
    addFirstBlock: 'Ajoutez votre premier bloc',
    selectBlockToEdit: 'Sélectionnez un bloc pour le modifier',
    noFieldsAvailable: 'Aucun champ disponible',
    loadingPreview: 'Chargement de l\'aperçu...',
    noPreviewAvailable: 'Aperçu non disponible',
    noPageSelected: 'Aucune page sélectionnée',
    imageUrl: 'URL de l\'image',
    variant: 'Variante',
    hide: 'Masquer',
    show: 'Afficher',
    moveUp: 'Monter',
    moveDown: 'Descendre',
    duplicate: 'Dupliquer',
    duplicateBlock: 'Dupliquer le bloc',
    delete: 'Supprimer',
    deleteBlock: 'Supprimer le bloc',
    deleteBlockConfirm: 'Êtes-vous sûr de vouloir supprimer ce bloc ?',
    tabs: {
      blocks: 'Blocs',
      editor: 'Édition',
      settings: 'Page',
      menus: 'Menus',
    },
    pageSettings: 'Paramètres de la page',
    pageTitle: 'Titre de la page',
    pageSlug: 'Slug URL',
    pageSlugHint: 'Utilisé dans l\'URL de la page',
    seo: 'Référencement (SEO)',
    metaTitle: 'Titre SEO',
    metaDescription: 'Description SEO',
    options: 'Options',
    setAsHomepage: 'Définir comme page d\'accueil',
    advanced: 'Avancé',
    customCss: 'CSS personnalisé',
    customJs: 'JavaScript personnalisé',
    menus: {
      title: 'Menus',
      addMenu: 'Ajouter un menu',
      noMenus: 'Aucun menu créé',
      visible: 'Visible',
      hidden: 'Masqué',
      noItems: 'Aucun élément dans ce menu',
      addItem: 'Ajouter un élément',
      createMenu: 'Créer un menu',
      editItem: 'Modifier l\'élément',
      menuName: 'Nom du menu',
      menuType: 'Type de menu',
      deleteMenu: 'Supprimer le menu',
      deleteMenuConfirm: 'Êtes-vous sûr de vouloir supprimer le menu "{name}" ?',
      itemLabel: 'Libellé',
      itemType: 'Type de lien',
      selectPage: 'Sélectionner une page',
      selectCategory: 'Sélectionner une catégorie',
      sectionId: 'ID de la section',
      email: 'Adresse email',
      phone: 'Numéro de téléphone',
      openIn: 'Ouvrir dans',
      icon: 'Icône (optionnel)',
      types: {
        navbar: 'Barre de navigation',
        footer: 'Pied de page',
        sidebar: 'Barre latérale',
        custom: 'Personnalisé',
      },
      itemTypes: {
        external: 'Lien externe',
        internal: 'Page interne',
        category: 'Catégorie',
        section: 'Section (ancre)',
        item: 'Vidéo du catalogue',
        asset: 'Média',
        email: 'Email',
        phone: 'Téléphone',
      },
      addLink: 'Ajouter un lien',
      addSubItem: 'Ajouter un sous-élément',
      // Destinations que la chaîne possède d'office : elles n'existent pas comme
      // pages du constructeur, mais elles ont bien une adresse publique.
      systemRoutes: {
        browse: 'Catalogue',
        categories: 'Catégories',
        subscriptions: 'Abonnements',
        contact: 'Contact',
        login: 'Connexion',
        register: 'Inscription',
        profile: 'Mon profil',
        blog: 'Blog',
        legal: 'Mentions légales',
      },
    },
    pageDrawer: {
      title: 'Pages',
      subtitle: 'Gérez les pages de votre site',
      page: 'Page',
      searchPlaceholder: 'Rechercher une page...',
      draft: 'Brouillon',
      published: 'Publiée',
      publishedHint: 'La page est visible sur le site',
      draftHint: 'La page n\'est pas encore visible',
      layoutPages: 'Mise en page',
      noPageFound: 'Aucune page trouvée',
      createPage: 'Créer une page',
      newPage: 'Nouvelle page',
      newPageTitle: 'Titre de la page',
      selectAPage: 'Sélectionnez une page',
      duplicate: 'Dupliquer',
      slugWarning: 'Modifier le slug change l\'URL de cette page. Si elle a déjà été publiée, ses anciens liens redirigent vers la nouvelle adresse.',
      authorizedGroups: 'Groupes autorisés',
      selectGroups: 'Sélectionner des groupes',
      searchGroupPlaceholder: 'Rechercher un groupe...',
      subscriptionPlans: 'Plans d\'abonnement',
      noSubscriptionPlan: 'Aucun plan d\'abonnement configuré',
      plansReadError: "Les offres qui ouvrent cette page n'ont pas pu être lues.",
      fullAccess: 'Accès complet',
      deleteTitle: 'Supprimer la page',
      deleteMessage: 'Êtes-vous sûr de vouloir supprimer "{title}" ? Cette action est irréversible.',
      sections: {
        information: 'Informations',
        layout: 'Gabarit',
        seo: 'SEO',
        access: 'Accès',
        publication: 'Publication',
        actions: 'Actions',
      },
      // Le cadre dans lequel la page est dessinée : l'en-tête, le pied de page
      // et l'emplacement où ses blocs prennent place.
      makeHomepage: "Définir comme page d'accueil",
      layoutDefault: 'Gabarit par défaut de la chaîne',
      layoutDefaultNamed: 'Gabarit par défaut ({name})',
      fields: {
        title: 'Titre',
        slug: 'Slug',
        path: 'Chemin (URL)',
        metaTitle: 'Meta title',
        metaDescription: 'Meta description',
        metaDescriptionPlaceholder: 'Description pour les moteurs de recherche...',
      },
      access: {
        public: { label: 'Public', description: 'Accessible à tous' },
        authenticated: { label: 'Connectés', description: 'Nécessite un compte' },
        restricted: { label: 'Restreint', description: 'Accès sur autorisation' },
      },
    },
    backToBlocks: 'Retour aux blocs',
  },
  siteSettings: {
    title: 'Paramètres du site',
    description: 'Ces paramètres s\'appliquent à toutes les pages',
    tabs: {
      branding: 'Identité',
      menus: 'Menus',
      layout: 'Styles',
      footer: 'Pied de page',
      code: 'CSS',
      advanced: 'Code avancé',
    },
    branding: {
      logo: {
        title: 'Logo',
        placeholder: 'URL ou ID du logo',
        hint: 'Le logo s\'affiche dans la navigation et le pied de page',
      },
      favicon: {
        title: 'Favicon',
        hint: "L'icône affichée dans l'onglet du navigateur. Une image carrée, en PNG ou WebP.",
      },
      colors: {
        title: 'Couleurs',
        primary: 'Couleur principale',
        secondary: 'Couleur secondaire',
      },
      theme: {
        title: 'Thème par défaut',
        description: 'Le thème par défaut pour les visiteurs de votre site',
        light: 'Clair',
        dark: 'Sombre',
      },
      login: {
        title: 'Style de la page de connexion',
        description: "La mise en page de la connexion, de l'inscription et des pages de mot de passe de vos membres",
        card: 'Carte centrée',
        splitImage: 'Image latérale',
        imageHint:
          "L'image de connexion choisie dans Réglages › Authentification, affichée à gauche du formulaire. Sans elle, l'image de partage de la chaîne est utilisée, sinon un dégradé de la couleur secondaire.",
      },
    },
    menus: {
      topbar: {
        title: 'Bandeau supérieur',
        description: "Liens affichés tout en haut, au-dessus de la navigation. Ignorés si vous avez renseigné un bandeau en HTML dans l'onglet Code.",
      },
      header: {
        title: 'Menu principal (header)',
        description: 'Liens affichés dans la barre de navigation',
      },
      footer: {
        title: 'Menu pied de page',
        description: 'Liens affichés dans le footer',
      },
      saveError: "Les menus n'ont pas pu être enregistrés.",
      // Une entrée dont la page a été supprimée revient en « lien externe » sans
      // adresse, et l'enregistrement entier est refusé. Sans cette phrase, le
      // bouton semblait ne rien faire.
      saveStale: "Les menus ont été modifiés ailleurs entre-temps : ils ont été relus, refaites vos changements.",
      saveErrorEmptyLink: 'Une entrée de menu n\'a pas de destination : choisissez une page, une catégorie ou saisissez une adresse, ou retirez cette entrée.',
    },
    code: {
      topbar: {
        title: 'Bandeau supérieur',
        description: "HTML affiché tout en haut de chaque page, au-dessus de la navigation",
        placeholder: '<iframe src="https://…" style="width:100%;height:36px;border:0"></iframe>',
        hint: "Prévu pour une barre que vous maintenez ailleurs — une iframe, un script. Sa hauteur est mesurée automatiquement, la navigation se décale en conséquence.",
        framingHint: "Si vous intégrez une iframe et qu'elle reste vide : le site intégré doit autoriser l'affichage depuis ce domaine. Un en-tête X-Frame-Options ou une directive CSP frame-ancestors trop stricte la fait refuser par le navigateur, sans rien afficher sur la page.",
      },
      css: {
        title: 'CSS personnalisé',
        description: 'Ajoutez du CSS appliqué à toutes les pages de votre site',
        hint: 'Ce CSS est chargé sur toutes les pages et surcharge le thème par défaut. Une règle invalide peut casser la mise en page de votre site.',
        fontsTitle: 'Utiliser votre propre police',
        hooksTitle: "Cibler une bande",
        hooks: "Chaque bande porte la classe de son type, .<type>-block, et celle de sa disposition, .<type>-block--<disposition> — par exemple .items-block--carousel ou .faq-block--accordion —, ainsi que les classes et l’identifiant CSS que vous lui donnez dans l’éditeur.",
        // `@` ouvre un message lié en vue-i18n : laissé nu, il casse la
        // compilation du message et la ligne ne s'affiche pas. `{'@'}` le passe
        // en littéral.
        fontsGoogle: "Police hébergée (Google Fonts et équivalents) : placez la ligne {'@'}import tout en haut du champ, avant toute autre règle — sinon le navigateur l'ignore.",
        fontsSelfHosted: "Police auto-hébergée : déclarez-la avec {'@'}font-face. Le serveur qui distribue le fichier doit autoriser le partage entre origines (en-tête Access-Control-Allow-Origin), sans quoi la police est refusée sans message d'erreur.",
      },
    },
    footer: {
      text: {
        title: 'Textes du pied de page',
        description: 'Affichés sous le logo dans les pieds de page « Colonnes » et « Centré ». Le pied de page minimal ne les affiche pas.',
        tagline: 'Accroche',
        taglinePlaceholder: 'Une phrase qui résume votre chaîne',
        about: 'À propos',
        aboutPlaceholder: 'Quelques phrases sur votre organisation',
      },
      socials: {
        title: 'Réseaux sociaux',
        description: "Une icône par réseau renseigné, dans le pied de page. Collez l'adresse complète de votre page ou votre nom d'utilisateur ({'@'}chaine).",
        placeholder: "https://… ou {'@'}chaine",
        networks: {
          facebook: 'Facebook',
          twitter: 'X (Twitter)',
          instagram: 'Instagram',
          youtube: 'YouTube',
          linkedin: 'LinkedIn',
          tiktok: 'TikTok',
        },
      },
    },
    advanced: {
      warning: "Ce code s'exécute sur toutes les pages de contenu de votre site, chez chacun de vos visiteurs. Un script défaillant peut casser l'affichage ou la lecture : testez-le d'abord sur une chaîne de démonstration. Il n'est jamais chargé sur les pages de connexion, d'inscription ni de paiement.",
      head: {
        title: 'Balises dans <head>',
        description: "Balises ajoutées dans l'en-tête de chaque page : vérification d'un outil, balise meta, feuille de style externe…",
      },
      javascript: {
        title: 'JavaScript personnalisé',
        description: 'Script exécuté en fin de page, sans balise <script> autour.',
      },
    },
  },
  settings: {
    title: 'Paramètres',
    subtitle: 'Gérez la configuration de votre site.',
    saveSuccess: 'Paramètres enregistrés avec succès',
    saveError: 'Échec de l\'enregistrement des paramètres',
    conflict: 'Quelqu\'un a enregistré avant vous : rien n\'a été écrit. L\'écran vient d\'être relu — reprenez votre modification et réenregistrez.',
    tabs: {
      information: 'Informations',
      domain: 'Domaine',
      authentication: 'Authentification',
      template: 'Modèle',
      options: 'Options',
      notifications: 'Notifications',
      monetization: 'Monétisation',
      legal: 'Légales',
    },
    legal: {
      onlineWithoutNotice:
        'Votre chaîne est en ligne sans mentions légales. Elles sont obligatoires pour tout site accessible au public : renseignez qui édite la chaîne ci-dessous, puis relisez et publiez le texte pré-rempli.',
      identity: {
        title: 'Qui édite cette chaîne',
        description:
          'Ces informations identifient votre structure. Elles sont partagées par toutes les chaînes de votre organisation et alimentent vos documents légaux.',
        seeded: 'Repris de votre dossier de monétisation.',
        locked: {
          body: 'Ces informations sont verrouillées : elles figurent sur les mentions légales déjà en ligne. Notre équipe les met à jour après vérification.',
        },
        saved: 'Informations enregistrées',
        legalName: 'Raison sociale',
        legalForm: 'Forme juridique',
        legalFormPlaceholder: 'SAS, SARL, association…',
        registrationNumber: 'Numéro d\'immatriculation (RCS / SIRET)',
        registrationCity: 'Ville d\'immatriculation',
        taxId: 'Numéro de TVA intracommunautaire',
        shareCapital: 'Capital social',
        addressLine1: 'Adresse du siège social',
        addressLine2: 'Complément d\'adresse',
        postalCode: 'Code postal',
        city: 'Ville',
        country: 'Pays',
        publicationDirector: 'Directeur de la publication',
        publicationDirectorHint: 'Le plus souvent le représentant légal. Aucun autre écran ne vous le demande.',
        contactEmail: 'Contact affiché sur le site',
        contactEmailHint: 'Adresse à laquelle vos visiteurs peuvent vous écrire.',
        contactPhone: 'Téléphone affiché sur le site',
        host: 'Hébergeur',
        hostFilled: 'Rempli par Videas',
        hostValue: 'VIDEAS SAS — Frelinghien, France',
        countryHint: 'Code pays à deux lettres, par exemple FR.',
        shareCapitalHint: 'En euros. Laissez vide si votre forme juridique ne l\'exige pas.',
        save: 'Enregistrer',
        saveFailed: 'L\'enregistrement a échoué.',
        conflict: 'Quelqu\'un a modifié ces informations avant vous : elles ont été rechargées. Reprenez votre modification.',
        invalid: 'Une valeur est refusée : vérifiez le code pays (deux lettres), l\'adresse de contact et le capital.',
      },
      documents: {
        title: 'Vos documents',
        description:
          'Chacun a sa propre page publique et son adresse. Ils sont pré-remplis à partir d\'un modèle et des informations ci-dessus : vous les relisez, les ajustez si besoin, puis les publiez.',
        blockedOne: 'Il manque une information pour générer vos documents : {fields}. Renseignez-la ci-dessus, puis enregistrez.',
        blockedMany: 'Il manque des informations pour générer vos documents : {fields}. Renseignez-les ci-dessus, puis enregistrez.',
        outdated: 'Vos informations ont changé depuis la génération de ce texte.',
        generate: 'Générer',
        generated: 'Document généré, à relire avant publication',
        generateFailed: 'La génération a échoué',
        review: 'Relire',
        reviewAndPublish: 'Relire et publier',
        viewPage: 'Voir la page',
        openMonetization: 'Ouvrir la monétisation',
        updatedOn: 'Mis à jour le {date}',
        write: 'Rédiger',
        publishedOn: 'Publié le {date}',
        takenDownSince: 'Publié le {date}, retiré depuis',
        otherLanguage: 'Ce texte est en {language}, alors que votre chaîne publie dans une autre langue.',
        withdrawn: {
          legalNotice: 'Ce document a été retiré du site : il ne s\'applique plus à cette chaîne.',
          privacy: 'Ce document a été retiré du site : il ne s\'applique plus à cette chaîne.',
          termsOfUse: 'Retirées du site : votre chaîne n\'ouvre plus de comptes. Le texte est conservé — vous n\'aurez qu\'à le republier si vous les rouvrez.',
          termsOfSale: 'Retirées du site : votre chaîne ne vend plus. Le texte est conservé — vous n\'aurez qu\'à le republier si vous reprenez la vente.',
        },
      },
      languages: {
        fr: 'Français',
        en: 'English',
      },
      kinds: {
        legalNotice: 'Mentions légales',
        privacy: 'Confidentialité et cookies',
        termsOfUse: 'Conditions d\'utilisation',
        termsOfSale: 'Conditions de vente',
      },
      why: {
        legalNotice: 'Obligatoires dès qu\'un site est accessible au public.',
        privacy: 'Votre chaîne mesure son audience et dépose des cookies : le document est requis.',
        termsOfUse: 'Ce que vos membres acceptent en créant un compte sur la chaîne.',
        termsOfSale: 'Ce que vos acheteurs acceptent. À rédiger vous-même : elles décrivent ce que vous vendez.',
      },
      status: {
        absent: 'Absent',
        review: 'À relire',
        published: 'Publié',
        custom: 'Personnalisé',
        notApplicable: 'Sans objet',
        withdrawn: 'Retiré',
      },
      fields: {
        legalName: 'Raison sociale',
        legalForm: 'Forme juridique',
        shareCapital: 'Capital social',
        registrationNumber: 'Immatriculation',
        registrationCity: 'Ville d\'immatriculation',
        taxId: 'TVA',
        address: 'Siège social',
        publicationDirector: 'Directeur de la publication',
        contactEmail: 'Contact',
        contactPhone: 'Téléphone',
        host: 'Hébergeur',
        hostAddress: 'Adresse de l\'hébergeur',
        siteName: 'Nom du site',
      },
      sources: {
        identity: 'Votre structure',
        videas: 'Videas',
        channel: 'Cette chaîne',
      },
      review: {
        caveat:
          'Texte type. Il ne remplace pas l\'avis d\'un professionnel du droit, et vous restez responsable de son contenu.',
        content: 'Texte du document',
        edit: 'Modifier le texte',
        provenanceTitle: 'Informations insérées',
        generatedHint:
          'Modifiez votre structure et ce document se met à jour tout seul. Si vous réécrivez le texte ici, il devient le vôtre et ne sera plus régénéré.',
        customHint: 'Vous avez réécrit ce texte : il ne sera jamais régénéré sans votre accord.',
        restore: 'Restaurer le texte généré',
        unpublish: 'Dépublier',
        save: 'Enregistrer',
        publish: 'Publier',
        published: 'Document publié',
        publishFailed: 'La publication a échoué',
        restored: 'Texte généré restauré',
        restoreFailed: 'La restauration a échoué',
        unpublished: 'Document dépublié',
        markdown: 'Texte du document (Markdown)',
        markdownHint: 'Les titres commencent par #, les listes par -. La page publique met tout en forme.',
        saveDraft: 'Enregistrer sans publier',
        saved: 'Brouillon enregistré',
        saveFailed: 'L\'enregistrement a échoué.',
        unpublishFailed: 'Le retrait a échoué.',
        conflict: 'Quelqu\'un a enregistré ce document avant vous : rien n\'a été écrit. Relisez-le et reprenez votre modification.',
        prefilled: 'Texte pré-rempli à partir du modèle et de vos informations. Relisez-le et complétez-le avant de le publier.',
        missing: 'Il manque des informations sur l\'éditeur : {fields}. Elles apparaissent « à compléter » dans le texte — renseignez-les plus haut, puis repartez du modèle.',
        fromTemplate: 'Repartir du modèle',
        fromTemplateHint: 'Remplace le texte de l\'éditeur par le modèle rempli avec vos informations actuelles. Rien n\'est enregistré tant que vous ne cliquez pas sur Enregistrer.',
        ownText: 'Ce document n\'a pas de modèle : rédigez-le vous-même.',
      },
    },
    template: {
      current: {
        title: 'Votre apparence',
        description:
          'Sept réglages décident du squelette de votre site : sa navigation, ses vignettes, ses fiches. Choisir un modèle les réécrit tous ; votre contenu ne bouge pas.',
        changed: '· modifié',
        driftNoticeOne:
          'Un réglage a été modifié depuis l\'éditeur. Choisir un modèle réécrit les sept réglages, celui-ci compris.',
        driftNoticeMany:
          '{count} réglages ont été modifiés depuis l\'éditeur. Choisir un modèle réécrit les sept réglages, ceux-ci compris.',
        none: 'Aucun modèle',
        noneHint:
          'Cette chaîne a été créée avant les modèles. En choisir un réécrira son apparence ; son contenu ne bougera pas.',
        change: 'Changer de modèle',
        restore: 'Rétablir les réglages de {template}',
      },
      gallery: {
        title: 'Changer de modèle',
        description:
          'Des mises en page réellement différentes les unes des autres. Choisir un modèle réécrit l\'apparence du site ; votre contenu, vos catégories et vos réglages ne bougent pas.',
        current: 'Actuel',
      },
      fields: {
        layout_navbar_style: 'Navigation',
        layout_footer_style: 'Pied de page',
        layout_item_card_template: 'Vignettes',
        layout_item_detail_style: 'Fiche du contenu',
        layout_category_banner_width: 'Bandeau de catégorie',
        layout_category_banner_content: 'Contenu du bandeau',
        base_theme: 'Thème',
      },
      values: {
        navbar: {
          transparent: 'Transparente',
          solid: 'Solide',
          pill: 'Pastilles',
          underline: 'Soulignée',
        },
        footer: {
          columns: 'Colonnes',
          centered: 'Centré',
          minimal: 'Minimal',
        },
        card: {
          cinematic: 'Cinématique',
          minimal: 'Minimal',
          poster: 'Affiche',
          posterSmall: 'Affiche compacte',
          formation: 'Formation',
          formation2: 'Formation 2',
          arte: 'Arte',
          netflix: 'Netflix',
          reveal: 'Révélation au survol',
          media: 'Média',
        },
        detail: {
          cinematic: 'Cinématique',
          showcase: 'Vitrine',
          spotlight: 'Projecteur',
          classic: 'Classique',
          minimal: 'Minimal',
          twoColumn: 'Deux colonnes',
        },
        banner: {
          contained: 'Dans la largeur de page',
          full: 'Pleine largeur',
          none: 'Titre seul',
          image: 'Image de la catégorie',
          item: 'Un contenu de la catégorie',
        },
        theme: {
          light: 'Clair',
          dark: 'Sombre',
        },
      },
      shapes: {
        single: 'une fiche',
        small: 'une petite sélection',
        catalog: 'un catalogue',
      },
      confirm: {
        title: 'Passer au modèle {template} ?',
        restoreTitle: 'Rétablir les réglages de {template} ?',
        applyLead: '{template} réécrit les sept réglages ci-dessous, sur toutes les pages, tout de suite.',
        lead: 'Votre chaîne porte {from}. {to} réécrit son apparence sur toutes les pages, tout de suite.',
        restoreLead: 'Les réglages que vous avez modifiés depuis reprendront les valeurs de {template}.',
        changes: 'Ce qui change',
        changed: '{field} : {from} → {to}',
        unchanged: '{field} : {value} (inchangé)',
        kept: 'Ce qui ne bouge pas',
        keptContent: 'Vos contenus et vos catégories',
        keptDomain: 'Votre domaine et votre adresse',
        keptSales: 'Vos abonnements et vos ventes',
        keptAccess: 'Vos réglages d\'accès',
        keptPages: 'Vos autres pages',
        colorTitle: 'Reprendre la couleur du modèle',
        colorHint: 'Sans cette case, votre couleur principale actuelle est conservée.',
        homepageTitle: 'Remplacer aussi ma page d\'accueil',
        homepageHint:
          'Votre chaîne compte {count} contenus : l\'accueil sera composé comme {shape}, à partir de ce qu\'elle contient aujourd\'hui.',
        homepageWarningOne:
          'Le bloc de votre page d\'accueil sera remplacé. Une copie dépubliée est conservée sous « Accueil — avant {template} » : vous pourrez la remettre à tout moment depuis vos pages.',
        homepageWarningMany:
          'Vos {count} blocs actuels seront remplacés. Tout ce que vous avez arrangé dans l\'éditeur disparaît de la page en ligne. Une copie dépubliée est conservée sous « Accueil — avant {template} » : vous pourrez la remettre à tout moment depuis vos pages.',
        apply: 'Appliquer {template}',
      },
      editorHint: {
        label: "Ces réglages viennent du modèle de la chaîne",
        change: 'Changer',
      },
      applied: {
        simple: 'Votre chaîne porte maintenant {template}.',
        withHomepage:
          'Votre chaîne porte maintenant {template}. La page d\'accueil précédente est conservée sous « {backup} ».',
        error: 'Le modèle n\'a pas pu être appliqué.',
      },
    },
    publication: {
      title: 'Publication',
      description: 'Contrôlez la visibilité de votre site.',
      online: 'En ligne',
      offline: 'Hors ligne',
      draft: 'Brouillon',
      onlineHint: 'Votre site est accessible publiquement',
      maintenance: 'En maintenance',
      maintenanceHint: 'Votre site est en ligne mais fermé : les visiteurs voient la page de maintenance. Remettez-le en ligne depuis le tableau de bord.',
      offlineHint: 'Votre site n\'est pas accessible aux visiteurs',
      draftHint: 'Votre chaîne n\'a jamais été en ligne : personne ne peut la voir tant que vous ne l\'activez pas',
      // U7: a fee is the whole month, charged at its anniversary and never prorated.
      feeStops: 'En la mettant hors ligne, le mois en cours reste dû ; plus rien n’est prélevé pour la chaîne ensuite.',
    },
    general: {
      title: 'Informations générales',
      description: 'Détails de base de votre site.',
      displayName: 'Nom d\'affichage',
      displayNamePlaceholder: 'Mon Site',
      descriptionField: 'Description',
      descriptionPlaceholder: 'Une brève description de votre site',
      thumbnailHelper: 'Recommandé : 1280x720px, JPG ou PNG',
    },
    authentication: {
      title: 'Authentification',
      description: 'Configurez le contrôle d\'accès de votre site.',
      modeChange: {
        title: 'Changer le mode d\'accès ?',
        confirm: 'Changer le mode',
        membersLose: '{count} membre perdra ses accès : la connexion disparaît du site et ses droits sur les contenus restreints ne s\'appliquent plus. Son compte et ses droits sont conservés et reviendront si vous rétablissez le mode Utilisateurs. | {count} membres perdront leurs accès : la connexion disparaît du site et leurs droits sur les contenus restreints ne s\'appliquent plus. Leurs comptes et leurs droits sont conservés et reviendront si vous rétablissez le mode Utilisateurs.',
        accountsGo: 'La connexion et l\'inscription disparaissent du site.',
        passwordWhole: 'Tout visiteur devra saisir le mot de passe pour voir le site.',
        passwordPartial: 'Les contenus restreints ne s\'ouvriront qu\'avec le mot de passe.',
        signInRequired: 'Les visiteurs non connectés ne verront plus rien du site : il leur faudra un compte.',
        passwordGone: 'Le mot de passe partagé est supprimé : les visiteurs qui l\'ont saisi ne s\'en serviront plus.',
        generic: 'Les visiteurs verront le site selon le nouveau mode dès l\'enregistrement.',
      },
      modeTitle: 'Mode d\'accès',
      modeDescription: 'Choisissez comment les visiteurs accèdent à votre site.',
      monetizationAlert: 'La monétisation est active sur ce site. Certains modes d\'authentification peuvent être restreints.',
      mode: {
        public: 'Public',
        publicDescription: 'Aucune authentification requise. Tout le contenu est accessible publiquement.',
        publicDisabledMonetization: 'Le mode public n\'est pas disponible lorsque la monétisation est active.',
        password: 'Mot de passe',
        passwordDescription: 'Les visiteurs doivent saisir un mot de passe partagé pour accéder au contenu.',
        passwordDisabledMonetization: 'Le mode mot de passe n\'est pas disponible lorsque la monétisation est active.',
        usersOptional: 'Utilisateurs (optionnel)',
        usersOptionalDescription: 'Les visiteurs peuvent naviguer librement et créer un compte pour accéder à des contenus supplémentaires.',
        usersRequired: 'Utilisateurs (requis)',
        usersRequiredDescription: 'Les visiteurs doivent créer un compte et se connecter pour accéder au contenu.',
      },
      passwordTitle: 'Mot de passe',
      passwordSubtitle: 'Définissez un mot de passe partagé pour les visiteurs.',
      password: 'Mot de passe partagé',
      passwordPlaceholder: 'Saisissez un mot de passe',
      passwordCopy: 'Copier le mot de passe',
      passwordCopied: 'Mot de passe copié',
      passwordKeep: 'Inchangé — laissez vide pour garder celui en place',
      passwordRequired: 'Définissez un mot de passe partagé pour activer le mode protégé.',
      passwordUnreadable: 'Ce mot de passe a été enregistré avant que le back office en garde une copie lisible : saisissez-le à nouveau pour pouvoir l\'afficher ici.',
      passwordWholeSite: 'Protéger toute la chaîne',
      passwordWholeSiteOn: 'Le mot de passe est demandé dès l\'arrivée sur le site.',
      passwordWholeSiteOff: 'L\'accueil et le catalogue restent publics ; seuls les contenus réservés aux membres demandent le mot de passe.',
      usersTitle: 'Comptes utilisateurs',
      usersSubtitle: 'Configurez les paramètres d\'inscription et de connexion.',
      allowRegistration: 'Autoriser l\'inscription',
      allowRegistrationHint: 'Les utilisateurs peuvent créer leurs propres comptes',
      requireTwoFactor: 'Exiger la double authentification',
      requireTwoFactorHint: 'Chaque membre devra confirmer sa connexion avec un code à usage unique de son application d\'authentification.',
      loginBackground: 'Arrière-plan de la page de connexion',
      loginBackgroundHint: 'Affichée derrière les pages de connexion et d\'inscription de la chaîne.',
    },
    options: {
      display: {
        title: 'Affichage',
        description: 'Contrôlez ce qui est affiché sur votre site.',
        shareBtn: 'Bouton de partage',
        shareBtnHint: 'Afficher un bouton de partage sur les pages de contenu',
        embed: 'Intégration sur d\'autres sites',
        embedHint: 'Permettre de coller le lecteur d\'un contenu sur un site tiers, et proposer son code dans le bouton de partage',
        viewsCount: 'Nombre de vues',
        viewsCountHint: 'Afficher le nombre de vues sur les contenus',
      },
      player: {
        title: 'Lecteur',
        description: 'Réglez le comportement du lecteur sur les pages de contenu.',
        autoplay: 'Lecture automatique',
        autoplayHint: "Les vidéos démarrent seules, sans le son, à l'ouverture d'une page de contenu",
        continueWatching: 'Reprendre la lecture',
        continueWatchingHint: "Afficher la progression de lecture et la rangée « Reprendre la lecture » pour reprendre là où on s'était arrêté",
      },
      interactions: {
        title: 'Interactions',
        description: 'Activez les fonctionnalités d\'engagement des visiteurs.',
        likes: 'J\'aime',
        likesHint: 'Permettre aux visiteurs d\'aimer le contenu',
        comments: 'Commentaires',
        commentsHint: 'Permettre aux visiteurs de commenter le contenu',
        commentsModeration: 'Modération des commentaires',
        commentsModerationHint: 'Exiger une approbation avant la publication des commentaires. Désactivé, les commentaires sont publiés automatiquement.',
      },
      access: {
        title: 'Accès',
        description: 'Comment vos visiteurs obtiennent les contenus qui ne leur sont pas ouverts.',
        accessRequest: 'Demandes d\'accès',
        accessRequestHint: 'Ajoute le niveau « Sur demande » à vos contenus : un visiteur connecté demande l\'accès, vous l\'accordez ou le refusez depuis Utilisateurs → Demandes d\'accès.',
        requiresMembers: 'Nécessite les comptes membres.',
        requiresMembersLink: 'Régler l\'accès à la chaîne',
      },
      contact: {
        title: 'Contact',
        description: 'Configurez le formulaire de contact de votre site.',
        contactForm: 'Formulaire de contact',
        contactFormHint: 'Afficher un formulaire de contact sur votre site',
        contactFormRecipient: 'Email du destinataire',
        contactFormRecipientPlaceholder: "contact{'@'}example.com",
        contactFormRecipientHint: 'Laissez vide pour utiliser l\'adresse email de l\'administrateur',
      },
      content: {
        title: 'Gestion de contenu',
        description: 'Configurez les fonctionnalités de contenu de votre site.',
        pageBuilder: 'Éditeur de pages',
        pageBuilderHint: 'Activer l\'éditeur de pages par glisser-déposer',
        blog: 'Blog',
        blogHint: 'Activer une section blog / articles sur votre site',
      },
      upload: {
        title: 'Dépôt de fichiers',
        description: 'Permettez aux membres de vous envoyer du contenu.',
        assetsInbox: 'Boîte de dépôt',
        assetsInboxHint: 'Permettre aux membres de déposer des fichiers sur votre chaîne',
        inboxWorkspace: 'Espace de travail de destination',
        inboxWorkspaceHint: 'Les contenus envoyés par les membres arrivent dans cet espace de votre médiathèque, en attente de relecture.',
        inboxWorkspaceSuspended: 'Cet espace de travail est à la corbeille : la boîte de dépôt est fermée sur la chaîne. Choisissez un autre espace de travail.',
        inboxWorkspaceTrashed: '{name} (à la corbeille)',
      },
      newsletter: {
        title: 'Newsletter',
        description: 'Paramètres d\'abonnement par email.',
        newsletter: 'Newsletter',
        newsletterHint: 'Permettre aux visiteurs de s\'abonner à votre newsletter',
      },
    },
    notifications: {
      userEmails: {
        title: 'Emails envoyés aux utilisateurs',
        description: 'Configurez les emails automatiques reçus par vos utilisateurs.',
        account: {
          title: 'Compte',
          welcomeEmail: 'Email de bienvenue',
          welcomeEmailHint: 'Envoyé à l\'inscription d\'un nouvel utilisateur — ou, sur une chaîne qui valide les inscriptions, quand vous validez la sienne',
          accountExpired: 'Compte expiré',
          accountExpiredHint: 'Quand le compte d\'un utilisateur arrive à expiration',
        },
        purchases: {
          title: 'Achats & Abonnements',
          purchaseConfirmation: 'Confirmation d\'achat',
          purchaseConfirmationHint: 'Reçu envoyé après un achat réussi',
          newSubscription: 'Nouvel abonnement',
          newSubscriptionHint: 'Confirmation de création d\'abonnement',
          subscriptionRenewal: 'Renouvellement d\'abonnement',
          subscriptionRenewalHint: 'Confirmation de renouvellement automatique',
          subscriptionExpiring: 'Abonnement expirant bientôt',
          subscriptionExpiringHint: 'Rappel avant expiration de l\'abonnement',
          configureDelay: 'Configurer',
          expiringDelayLabel: 'Délai de rappel',
          expiringDelaySuffix: 'jours avant expiration',
          expiringDelayHint: 'L\'utilisateur sera notifié ce nombre de jours avant l\'expiration de son abonnement',
          subscriptionCancelled: 'Abonnement annulé',
          subscriptionCancelledHint: 'Confirmation d\'annulation',
          rentalExpired: 'Location expirée',
          rentalExpiredHint: 'Quand une location arrive à terme',
        },
        content: {
          title: 'Contenu & Accès',
          accessRequestApproved: 'Demande d\'accès approuvée',
          accessRequestApprovedHint: 'Quand l\'admin approuve une demande',
          accessRequestDenied: 'Demande d\'accès refusée',
          accessRequestDeniedHint: 'Quand l\'admin refuse une demande',
          accessGranted: 'Accès accordé',
          accessGrantedHint: 'Quand un accès direct est accordé (hors demande)',
        },
      },
      adminAlerts: {
        title: 'Alertes administrateur',
        description: 'Choisissez les événements pour lesquels vous souhaitez être notifié.',
        newUserRegistered: 'Nouvel utilisateur inscrit',
        newUserRegisteredHint: 'Quand un utilisateur s\'inscrit sur le site',
        invitationAccepted: 'Invitation acceptée',
        invitationAcceptedHint: 'Quand un utilisateur invité accepte l\'invitation',
        newPaymentReceived: 'Nouveau paiement reçu',
        newPaymentReceivedHint: 'Quand un paiement est confirmé',
        paymentFailed: 'Paiement échoué',
        paymentFailedHint: 'Quand un paiement échoue',
        accessRequestSubmitted: 'Demande d\'accès soumise',
        accessRequestSubmittedHint: 'Quand un utilisateur soumet une demande d\'accès',
        contactFormSubmitted: 'Formulaire de contact soumis',
        contactFormSubmittedHint: 'Quand un visiteur soumet le formulaire de contact',
      },
      history: {
        title: 'Historique des notifications',
        description: 'Consultez les notifications envoyées.',
        emptyTitle: 'Aucune notification envoyée',
        emptySubtitle: 'Les notifications envoyées apparaîtront ici une fois le système activé.',
        searchPlaceholder: 'Rechercher par objet ou destinataire...',
        columns: {
          date: 'Date',
          recipient: 'Destinataire',
          subject: 'Objet',
          status: 'Statut',
        },
        statuses: {
          sent: 'Envoyé',
          queued: 'En file d\'attente',
          failed: 'Échoué',
        },
      },
      validation: {
        expiringDaysRange: 'Le délai de rappel doit être compris entre 1 et 90 jours',
      },
      loadError: 'Échec du chargement des notifications. Veuillez réessayer.',
    },
    monetization: {
      deactivateSuccess: 'Monétisation désactivée',
      activateSuccess: 'Vente ouverte',
      landing: {
        title: 'Vendez vos contenus directement depuis votre chaîne',
        subtitle:
          'Achat à l\'unité, location, abonnement. Les paiements sont encaissés sur un compte de paiement à votre nom, et versés sur votre compte bancaire.',
        startButton: 'Demander l\'activation',
        approvedSubtitle:
          'Votre demande a été acceptée. Ouvrez la vente, puis configurez votre compte de paiement pour encaisser.',
        openButton: 'Ouvrir la vente',
        features: {
          commission: {
            title: 'Commission simple',
            description: 'Un pourcentage tout compris sur chaque vente, sans frais fixes ni abonnement.',
          },
          secure: {
            title: 'Paiements sécurisés',
            description: 'Notre partenaire de paiement gère l\'encaissement, la conformité et la lutte contre la fraude.',
          },
          instant: {
            title: 'Accès immédiat',
            description: 'Vos acheteurs accèdent au contenu dès le paiement confirmé.',
          },
          analytics: {
            title: 'Suivi des ventes',
            description: 'Chiffre d\'affaires, abonnés et contenus les plus vendus, en un coup d\'œil.',
          },
        },
        howItWorksTitle: 'Comment ça marche',
        howItWorksSubtitle: 'De la demande à la première vente, en quatre étapes.',
        howItWorks: {
          steps: {
            configure: {
              title: 'Renseignez votre entreprise',
              description: 'Les informations qui figureront sur les factures de vos acheteurs.',
            },
            request: {
              title: 'Faites valider votre demande',
              description: 'Notre équipe l\'examine sous 2 jours ouvrés.',
            },
            connectStripe: {
              title: 'Ouvrez votre compte de paiement',
              description: 'Pièce d\'identité, justificatif d\'entreprise et coordonnées bancaires.',
            },
            startSelling: {
              title: 'Fixez vos tarifs et vendez',
              description: 'Vos revenus sont versés directement sur votre compte bancaire.',
            },
          },
        },
      },
      pricing: {
        title: 'Ce que ça coûte',
        subtitle: 'Aucun frais d\'entrée : vous ne payez que sur ce que vous vendez.',
        commission: {
          title: 'Commission {platform}',
          description: 'Prélevée sur chaque vente, frais de paiement compris. Aucun frais fixe, aucun abonnement.',
          features: {
            noSetupFees: 'Aucun frais de mise en service',
            noMonthlyFees: 'Aucun abonnement mensuel',
            payAsYouEarn: 'Vous ne payez que si vous vendez',
          },
        },
        stripe: {
          title: 'Frais de paiement',
          fees: 'Inclus',
          description: 'Compris dans la commission : rien d\'autre n\'est prélevé sur vos ventes.',
          features: {
            securePayments: 'Paiements sécurisés et conformes',
            globalReach: 'Cartes internationales acceptées',
            automaticTaxes: 'Gestion automatique de la TVA',
          },
        },
        example: {
          title: 'Exemple sur une vente à 10 €',
          description:
            'Sur une vente à 10 € TTC, seule la commission de {commission} est retenue, frais de paiement compris. Le reste vous revient.',
        },
      },
      faq: {
        title: 'Questions fréquentes',
        subtitle: 'Ce qu\'on nous demande le plus souvent avant de se lancer.',
        items: {
          whoCanSell: {
            question: 'Puis-je vendre en tant que particulier ?',
            answer:
              'Non. Vos ventes sont facturées au nom d\'une entité immatriculée en France et identifiée par son SIREN : société, association ou entreprise individuelle (micro-entreprise comprise). Votre entité n\'est pas française ? Contactez-nous directement à support{\'@\'}videas.fr pour en parler. Une fois votre demande validée, vous enregistrez cette entité comme vendeur, puis notre partenaire de paiement vérifie votre identité et le compte bancaire qui recevra les versements.',
          },
          whenPaid: {
            question: 'Quand suis-je payé ?',
            answer:
              'Chaque paiement est encaissé sur votre compte de paiement, commission {platform} déjà déduite, puis versé automatiquement sur le compte bancaire indiqué lors de la vérification de votre dossier : vous n\'avez aucune démarche à faire.',
          },
          howLong: {
            question: 'Combien de temps prend l\'activation ?',
            answer:
              'Notre équipe examine d\'abord votre demande, dont le statut s\'affiche sur cette page. Une fois validée, il vous reste à enregistrer votre entité, à compléter votre dossier de vérification et à signer le mandat de facturation. La vérification prend de quelques minutes à quelques jours selon les pièces demandées.',
          },
          refunds: {
            question: 'Comment gérer un remboursement ?',
            answer:
              'Depuis Ventes → Transactions, avec l\'action « Rembourser… » de la vente : total ou partiel, le remboursement est prélevé sur vos fonds et il est définitif. La commission {platform} perçue sur la vente n\'est pas restituée. Un remboursement total d\'un achat ou d\'une location retire l\'accès au contenu ; rembourser une échéance d\'abonnement ne résilie pas l\'abonnement.',
          },
        },
      },
      wizard: {
        previous: 'Retour',
        next: 'Continuer',
        identity: {
          step: 'Identité',
          title: 'Qui vend ?',
          subtitle:
            'Ces informations apparaîtront sur les factures remises à vos acheteurs et seront vérifiées par notre partenaire de paiement. Elles doivent correspondre exactement à l\'entité enregistrée qui encaissera les paiements.',
          entityRequiredTitle: 'Vendre exige une entité enregistrée',
          entityRequiredDescription:
            'Vous ne pouvez pas encaisser de paiements en tant que particulier. Il vous faut une société, une association ou une entreprise individuelle (auto-entrepreneur) immatriculée. Notre partenaire de paiement vérifiera ces informations auprès des registres officiels avant d\'ouvrir la vente : une identité incomplète ou inexacte fera refuser le dossier.',
          allRequired: 'Tous les champs sont obligatoires.',
          required: 'Ce champ est obligatoire.',
          legalName: 'Raison sociale',
          legalForm: 'Forme juridique',
          legalFormPlaceholder: 'SAS, SARL, association…',
          registrationNumber: 'SIREN / SIRET',
          registrationNumberHint: 'Le numéro d\'immatriculation de votre entité.',
          taxId: 'Numéro de TVA',
          addressLine1: 'Adresse du siège',
          postalCode: 'Code postal',
          city: 'Ville',
          country: 'Pays',
          invoiceEmail: 'Email de facturation',
          invoiceEmailHint: 'Adresse à laquelle vous recevrez vos factures et vos relevés de vente.',
          invoiceEmailInvalid: 'Cette adresse email n\'est pas valide.',
          invoiceEmailReservedDomain:
            'Ce domaine n\'est pas accepté : les domaines réservés aux tests (.test, .local, .example) ne peuvent pas recevoir d\'email.',
          rejected: 'Cette valeur a été refusée. Vérifiez-la et renvoyez la demande.',
          sharedTitle: 'Une seule fois par organisation',
          sharedDescription:
            'Vos autres chaînes réutiliseront cette identité et le même compte de paiement. Vous n\'aurez pas à refaire cette étape.',
        },
        activity: {
          step: 'Activité',
          title: 'Votre activité',
          subtitle: 'Ce que vous comptez vendre, et dans quelle devise.',
          currency: 'Devise de vente',
          taxCountry: 'Pays de taxation',
          description: 'Que vendez-vous ?',
          descriptionHint: 'Transmis à notre partenaire de paiement pour vérifier votre compte.',
          salesModes: 'Modes de vente envisagés',
          allModes: 'Une fois la vente acceptée, vous pourrez vendre à l\'achat, à la location et par abonnement.',
          currencyEur: 'Euro (EUR)',
          countryFr: 'France',
          modes: {
            purchase: { label: 'Achat à l\'unité', hint: 'Accès définitif au contenu' },
            subscription: { label: 'Abonnement', hint: 'Accès récurrent au catalogue' },
            rental: { label: 'Location', hint: 'Accès limité dans le temps' },
          },
        },
        review: {
          step: 'Récapitulatif',
          title: 'Vérifiez et envoyez',
          subtitle: 'Un dernier coup d\'œil avant que notre équipe examine votre demande.',
          requestButton: 'Envoyer la demande',
          stripeInfo: {
            title: 'Et après ?',
            description:
              'Après validation par notre équipe, vous serez invité à ouvrir votre compte de paiement — pièce d\'identité, justificatif d\'entreprise et coordonnées bancaires. Comptez 10 minutes.',
          },
        },
      },
      request: {
        recapTitle: 'Votre demande',
      },
      // Les portes vers le prestataire de paiement, à côté du miroir de ce qu'il a dit.
      account: {
        title: 'Configurer vos paiements',
        intro: 'Pour encaisser vos ventes, {platform} ouvre un compte de paiement au nom de votre organisation. L\'argent payé par vos spectateurs arrive sur ce compte, puis sur votre compte bancaire. Comptez une dizaine de minutes, en trois étapes, toutes depuis cette page.',
        noPermission: 'Le compte de paiement qui encaisse les ventes est celui de votre organisation : seule une personne qui gère la facturation peut le configurer.',
        unavailable: 'Le service de facturation ne répond pas pour le moment. Réessayez plus tard.',
        readError: 'L\'état de votre compte de paiement n\'a pas pu être lu. Réessayez.',
        ready: 'Votre organisation peut encaisser et facturer des ventes.',
        notReady: 'Votre organisation ne peut pas encore encaisser de ventes.',
        steps: {
          identity: 'Votre entreprise',
          payments: 'Votre compte de paiement',
          mandate: 'L\'autorisation de facturer',
        },
        identity: {
          description: 'Indiquez l\'entreprise au nom de laquelle vous vendez : elle figurera sur les factures de vos spectateurs. Le SIREN ne peut plus être modifié ensuite.',
          start: 'Renseigner mon entreprise',
          done: 'Votre entreprise est enregistrée.',
          legalName: 'Raison sociale',
          tradeName: 'Nom commercial (optionnel)',
          legalForm: 'Forme juridique (optionnel)',
          siren: 'SIREN',
          sirenHint: 'Neuf chiffres.',
          sirenInvalid: 'Ce n\'est pas un SIREN valide : vérifiez les neuf chiffres.',
          line1: 'Adresse du siège',
          line2: 'Complément d\'adresse (optionnel)',
          postalCode: 'Code postal',
          city: 'Ville',
          invoiceEmail: 'Adresse de réception des factures (optionnel)',
          invoiceEmailHint: 'Où envoyer les copies des factures émises en votre nom.',
          vatLiable: 'Mon activité est assujettie à la TVA',
          vatLiableHint: 'Décochez si vous êtes en franchise en base de TVA.',
          vatNumber: 'Numéro de TVA intracommunautaire (optionnel)',
          vatPlaceholder: 'FR12345678901',
          submit: 'Enregistrer et continuer',
          created: 'Votre entreprise est enregistrée. Étape suivante : votre compte de paiement.',
          error: 'Votre entreprise n\'a pas pu être enregistrée.',
        },
        payments: {
          description: 'Notre partenaire de paiement, Stripe, encaisse vos ventes et vous les reverse. Il vérifie votre compte sur son formulaire sécurisé, puis vous ramène ici : préparez une pièce d\'identité et l\'IBAN qui recevra vos virements.',
          onboarding: 'Configurer mon compte de paiement',
          update: 'Modifier mes informations',
          dashboard: 'Ouvrir mon tableau de bord Stripe',
          verifying: 'Votre dossier est en cours de vérification. Si vous avez tout envoyé, vous n\'avez rien à faire : cela prend de quelques minutes à 2 jours ouvrés. Vous pouvez déjà donner l\'autorisation de facturer ci-dessous. Si vous vous êtes arrêté en cours de route, reprenez votre dossier là où vous l\'avez laissé.',
          resume: 'Reprendre mon dossier',
          refresh: 'Actualiser',
          actionNeeded: 'Notre partenaire de paiement a besoin d\'un complément pour terminer la vérification de votre compte. Rouvrez votre dossier pour voir ce qui manque et l\'envoyer.',
          complete: 'Compléter mon dossier',
          done: 'Votre compte de paiement est actif : vous pouvez encaisser des ventes.',
          linkError: 'Le lien n\'a pas pu être créé. Réessayez.',
          due: 'Il vous reste à fournir :',
          dueBy: 'Il vous reste à fournir, avant le {date} :',
          nothingDue: 'Vous n\'avez plus rien à fournir.',
          requirements: {
            individual_verification_document: 'Une pièce d\'identité',
            business_profile_url: 'L\'adresse du site de votre activité',
            external_account: 'L\'IBAN qui recevra vos virements',
            tos_acceptance_date: 'L\'acceptation des conditions du partenaire de paiement',
          },
        },
        mandate: {
          description: 'Dernière étape : autorisez Videas à envoyer les factures à vos spectateurs en votre nom. Vous n\'avez ainsi aucune facture à faire vous-même.',
          text: 'J\'autorise Videas à émettre, en mon nom et pour mon compte, les factures et avoirs de mes ventes aux spectateurs de mes chaînes, et à en conserver une copie. Ce mandat peut être révoqué à tout moment auprès du support.',
          accept: 'J\'autorise Videas à facturer',
          accepted: 'Mandat accepté le {date} (version {version}).',
          signed: 'Le mandat est accepté.',
          unknown: 'Le service de facturation ne répond pas : l\'état du mandat est inconnu.',
          error: 'Le mandat n\'a pas pu être enregistré.',
        },
        vat: {
          title: 'TVA',
          liable: 'Assujetti à la TVA',
          exempt: 'Franchise en base de TVA',
          unknown: 'Pas encore connu',
          change: 'Déclarer un changement',
          newStatus: 'Mon activité est désormais assujettie à la TVA',
          effectiveFrom: 'Date d\'effet',
          effectiveFromHint: 'Le jour où le changement a pris effet, jamais dans le futur.',
          submit: 'Déclarer',
          declared: 'Le changement de TVA est déclaré.',
          error: 'Le changement n\'a pas pu être déclaré.',
        },
      },
      seller: {
        onboarding: 'Votre dossier de vérification',
        note: 'Ces informations viennent de notre partenaire de paiement, à la date de dernière synchronisation. C\'est lui seul qui décide d\'accepter ou non un paiement.',
        status: {
          none: 'Pas encore ouvert',
          pending: 'En cours',
          complete: 'Complet',
          restricted: 'Restreint',
        },
      },
      track: {
        submitted: 'Demande envoyée',
        review: 'Validation {platform}',
        reviewPending: 'En cours',
        stripe: 'Compte de paiement',
        stripePending:
          'Rien à fournir | 1 information à fournir | {count} informations à fournir',
        stripeVerifying: 'Vérification en cours',
        stripeBlocked: 'Compte suspendu',
        stripeDone: 'Terminée',
        stripePendingSeller: 'À vous : configurez votre compte',
        selling: 'Première vente',
      },
      pending: {
        title: 'Demande envoyée le {date}',
        description:
          'Notre équipe l\'examine sous 2 jours ouvrés. Vous recevrez un email dès qu\'elle est traitée.',
        editBtn: 'Modifier la demande',
        cancelBtn: 'Annuler la demande',
        toast: 'Demande envoyée',
        cancelled: 'Demande annulée',
      },
      rejected: {
        title: 'Demande refusée le {date}',
        retryBtn: 'Corriger et renvoyer',
      },
      setup: {
        notStarted: {
          title: 'Votre demande est acceptée',
          description:
            'Dernière étape : configurez votre compte de paiement. Préparez une pièce d\'identité, un justificatif d\'entreprise et votre IBAN.',
          action: 'Configurer mes paiements',
        },
        incomplete: {
          title: 'Configuration à terminer',
          description:
            'Vous avez commencé à configurer vos paiements sans aller au bout. Vos réponses ont été gardées : reprenez là où vous vous êtes arrêté.',
          action: 'Reprendre la configuration',
        },
        verifying: {
          title: 'Vos informations sont en cours de vérification',
          description:
            'Vous n\'avez rien à faire. La vérification prend le plus souvent quelques minutes, parfois jusqu\'à deux jours ouvrés. Nous vous préviendrons par email dès que la vente sera ouverte — vous pouvez déjà préparer vos tarifs.',
          action: 'Voir mon dossier',
        },
        blocked: {
          title: 'Votre compte de paiement est suspendu',
          description:
            'Vos encaissements sont arrêtés. Contactez notre support : nous voyons le motif avec notre partenaire de paiement et vous accompagnons pour contester la décision.',
          action: 'Contacter le support',
        },
        remainingTitle: 'Ce qu\'il reste à fournir',
        remainingSubtitle: 'Comptez une dizaine de minutes, documents en main.',
        remainingNote:
          'D\'autres pièces peuvent vous être demandées selon votre situation. La liste exacte s\'affiche pendant la configuration.',
      },
      restricted: {
        title: 'Vos virements sont en attente d\'une pièce',
        description:
          'Vos ventes continuent normalement et vos fonds sont conservés. Ils seront versés dès que votre dossier sera complet.',
        descriptionDated:
          'Vos ventes continuent normalement et vos fonds sont conservés. Ils seront versés dès que votre dossier sera complet — à faire avant le {date}.',
        fixBtn: 'Compléter mon dossier',
      },
      stripe: {
        title: 'Compte de paiement',
        leavingNotice:
          'Vous passez sur le formulaire sécurisé de notre partenaire de paiement, Stripe, le temps de la configuration, puis vous revenez ici automatiquement. Vos tarifs et vos contenus restent accessibles entre-temps.',
        chips: {
          notConnected: 'Non configuré',
          chargesOn: 'Encaissements actifs',
          chargesOff: 'Encaissements bloqués',
          payoutsOn: 'Virements actifs',
          payoutsOff: 'Virements en attente',
        },
        // Familles d'informations demandées par Stripe, jamais les clés brutes.
        requirements: {
          personalInfo: {
            label: 'Vos informations personnelles',
            hint: 'Nom, date de naissance et adresse du dirigeant.',
          },
          identityDocument: {
            label: 'Pièce d\'identité du dirigeant',
            hint: 'Carte d\'identité, passeport ou titre de séjour en cours de validité.',
          },
          companyDocument: {
            label: 'Justificatif d\'immatriculation',
            hint: 'Extrait Kbis, ou son équivalent dans votre pays.',
          },
          businessInfo: {
            label: 'Informations sur l\'entreprise',
            hint: 'Raison sociale, adresse du siège, secteur d\'activité et site web.',
          },
          bankAccount: {
            label: 'Coordonnées bancaires',
            hint: 'L\'IBAN sur lequel vos revenus seront versés.',
          },
          terms: {
            label: 'Acceptation des conditions du partenaire',
            hint: 'Une case à cocher à la fin du parcours.',
          },
          other: {
            label: 'Informations complémentaires',
            hint: 'Elles vous seront demandées pendant la configuration.',
          },
        },
      },
      tax: {
        title: 'Vos obligations fiscales et sociales',
        description: 'Les sommes que vous percevez au titre de vos ventes sont imposables et doivent être déclarées à l\'administration fiscale. Selon votre situation, elles peuvent aussi donner lieu à des cotisations sociales. {platform} n\'effectue aucune déclaration à votre place.',
        summaryHint: 'Chaque mois de janvier, nous vous adressons un récapitulatif des transactions de l\'année écoulée. Il reste disponible dans Ventes → Revenus & facturation.',
      },
      notifications: {
        title: 'Vos notifications',
        newSale: 'Me prévenir de chaque vente',
        newSaleHint:
          'Un e-mail « Nouvelle vente » et une ligne dans vos notifications à chaque achat, location ou nouvel abonnement — pas aux renouvellements. Ce réglage ne concerne que vous, et cette chaîne seulement : {settings}, dans les paramètres de votre compte, le désactive sur toutes vos chaînes.',
        settingsLink: 'Notifications',
      },
      contributions: {
        sectionTitle: 'Paiement',
        title: 'Contribution de soutien',
        subtitle:
          'Au moment du paiement, vos acheteurs peuvent ajouter le montant de leur choix (1 €, 2 € ou 5 €, ou un montant libre) pour soutenir votre chaîne. Il vous est reversé avec leur achat.',
        unavailable: 'Disponible une fois la monétisation de la chaîne validée.',
      },
      settings: {
        active: 'Monétisation active',
        activeDescription: 'Votre chaîne peut encaisser des paiements.',
        generalTitle: 'Conditions',
        seller: 'Vendeur',
        lastSync: 'Dernière synchronisation',
        currencyHint:
          'La devise et les conditions sont fixées à l\'activation. Contactez le support pour les modifier.',
        stripeAccountId: 'Identifiant du compte',
        stripeDashboard: 'Dashboard Stripe',
        quickActionsTitle: 'Et maintenant',
        managePrices: 'Définir les tarifs',
        manageSubscriptions: 'Abonnements',
        manageCoupons: 'Codes promo',
        salesReports: 'Ventes',
        statements: 'Relevés & factures',
        dangerWarning:
          'Désactiver la monétisation coupe l\'accès aux contenus payants pour vos abonnés en cours.',
        deactivateBtn: 'Désactiver la monétisation',
        deactivateTitle: 'Désactiver la monétisation ?',
        deactivateConfirm:
          'Les contenus payants ne seront plus accessibles et aucune nouvelle vente ne sera possible.',
        deactivateIrreversible:
          'Vos abonnés en cours perdront immédiatement l\'accès aux contenus payants.',
        deactivateTypePrompt: 'Tapez « {word} » pour confirmer :',
      },
      errors: {
        submit: 'L\'envoi de la demande a échoué. Réessayez dans un instant.',
        submitInvalid: 'La demande a été refusée : une des informations saisies n\'est pas acceptée.',
        submitInvalidField: 'La demande a été refusée — corrigez « {field} », le champ est signalé ci-dessus.',
        cancel: 'L\'annulation a échoué. Réessayez dans un instant.',
        onboarding: 'La configuration n\'a pas pu s\'ouvrir. Réessayez dans un instant.',
        dashboard: 'Stripe n\'a pas pu ouvrir le tableau de bord. Réessayez dans un instant.',
        deactivate: 'La désactivation a échoué. Réessayez dans un instant.',
        activate: 'L\'ouverture de la vente a échoué. Réessayez dans un instant.',
        needsMembers: 'La vente nécessite les comptes membres : un acheteur a besoin d\'un compte pour retrouver ses achats. Activez-les dans Réglages › Authentification, puis ouvrez la vente.',
      },
    },
    danger: {
      title: 'Zone dangereuse',
      description: 'Actions qui retirent des éléments du site',
      deleteTitle: 'Supprimer ce site',
      deleteDescription: 'Une fois supprimé, le site n\'est plus accessible à ses visiteurs, et ses contenus, ses pages et ses membres sont supprimés avec lui.',
      deleteButton: 'Supprimer le site',
      deleteDone: 'Site supprimé',
      deleteFailed: 'La suppression a échoué.',
    },
  },
  domain: {
    title: 'Domaine',
    subtitle: 'Gérez les domaines de votre site.',
    addButton: 'Ajouter un domaine',
    primaryDomain: {
      title: 'Domaine principal',
      description: 'Le domaine principal est celui affiché dans la barre d\'adresse de votre site.',
      empty: 'Aucun domaine principal',
      emptyDescription: 'Ajoutez un domaine personnalisé ou utilisez un sous-domaine gratuit de {suffix}.',
      emptyDescriptionNoSuffix: 'Ajoutez un domaine personnalisé ou utilisez un sous-domaine gratuit de la plateforme.',
    },
    secondaryDomains: {
      title: 'Domaines secondaires',
      description: 'Ces domaines redirigent automatiquement vers votre domaine principal.',
    },
    platformDomains: {
      title: 'Domaines plateforme',
      description: 'Domaines fournis par la plateforme Videas.',
    },
    customDomains: {
      title: 'Domaines personnalisés',
      description: 'Vos propres domaines pointant vers ce site.',
      empty: 'Aucun domaine personnalisé',
      emptyDescription: 'Ajoutez un domaine personnalisé pour utiliser votre propre URL pour ce site.',
      addFirst: 'Ajouter votre premier domaine',
    },
    helpBanner: {
      text: 'Besoin d\'aide pour configurer votre domaine ?',
      button: 'Consulter le centre d\'aide',
    },
    readiness: {
      switched_off: 'Désactivé',
      redirecting: 'Redirige',
      awaiting_dns: 'DNS requis',
      awaiting_certificate: 'Certificat en attente',
      serving: 'En ligne',
    },
    refusal: {
      malformed: 'Ce n\'est pas un nom de domaine valide.',
      connected: 'Cette adresse est déjà celle de cette chaîne.',
      taken: 'Cette adresse est déjà utilisée par une autre chaîne.',
      other_organization: 'Ce nom appartient déjà à une autre organisation.',
      reserved: 'Ce nom a été libéré récemment et reste réservé trente jours.',
      segmented: 'Ce nom est déjà partagé par langue, ou ne l\'est pas du tout : les deux ne se mélangent pas.',
    },
    setActiveError: 'L\'état de ce nom n\'a pas pu être changé.',
    badges: {
      primary: 'Principal',
      active: 'Actif',
      inactive: 'Inactif',
      platform: 'Plateforme',
      custom: 'Personnalisé',
      online: 'En ligne',
      dnsRequired: 'DNS requis',
      verifying: 'Vérification…',
      billingExempt: 'Compris',
      monthlyFee: '+{amount}/mois',
    },
    // The custom name's monthly fee in its dunning (`DomainCard.vue`, `apps/billing/fees.ts`).
    fee: {
      active: 'Actif · prochain prélèvement le {date}',
      unpaid:
        'Impayé · hors ligne le {date} sans recharge | Impayé · hors ligne dans 1 jour, le {date}, sans recharge | Impayé · hors ligne dans {n} jours, le {date}, sans recharge',
      offline: 'Hors ligne pour impayé · réactivable par une recharge jusqu’au {date}',
      topUp: 'Recharger',
      topUpReactivate: 'Recharger et réactiver',
    },
    card: {
      ssl: {
        active: 'SSL actif',
        pending: 'SSL en attente',
        none: 'Pas de SSL',
      },
      dns: {
        verified: 'DNS vérifié',
        pending: 'DNS en attente',
      },
      actions: {
        setPrimary: 'Définir comme principal',
        verifyDns: 'Vérifier le statut',
        configureDns: 'Configurer le DNS',
        viewDns: 'Voir les instructions DNS',
        toggleDetails: 'Afficher les détails',
        delete: 'Retirer',
        switchOn: 'Réactiver',
        switchOff: 'Désactiver',
      },
      pendingMessage: 'Configuration DNS en attente. Votre domaine sera actif une fois les enregistrements DNS vérifiés.',
      createdAt: 'Vérifié le',
      steps: {
        dns: 'DNS',
        ssl: 'Certificat SSL',
        active: 'Actif',
      },
      stepMessages: {
        not_required: 'Rien à configurer : ce nom est celui de la plateforme.',
        awaiting_dns: 'Ajoutez les enregistrements ci-dessous chez votre hébergeur. La vérification se fait toute seule.',
        records_mismatch: 'Ce nom pointe ailleurs que vers nos serveurs.',
        unpublished: 'Les adresses à viser ne sont pas publiées sur cette installation.',
        verified: 'Le nom pointe bien vers nous.',
      },
      mismatch: 'Ce nom répond {resolved}, alors qu\'il devrait répondre {expected}.',
      checkedAt: 'Vérifié le {date}',
      certificate: {
        platform_wildcard: 'Le certificat de la plateforme couvre ce nom.',
        per_host: 'Ce nom a besoin de son propre certificat, délivré par notre équipe. Rien à faire de votre côté.',
      },
    },
    billing: {
      domains: 'dont aucune adresse raccordée | dont {n} adresse raccordée | dont {n} adresses raccordées',
      online: 'La chaîne est en ligne : ce montant est débité chaque mois.',
      offline: 'La chaîne est hors ligne : rien n\'est débité tant qu\'elle ne sert personne.',
      exempt: 'Cette chaîne a été mise en ligne avant que la publication devienne payante : elle reste gratuite, ses adresses personnalisées comprises. Rien n’est prélevé.',
      channelNotBilled: 'La chaîne elle-même n’est pas facturée.',
      // A total of zero is debited by nobody: « ce montant est débité » under 0,00 € read as a
      // contradiction (`[reglages I-10]`).
      nothingDue: 'La chaîne est en ligne : rien n’est débité tant que ce total reste nul.',
    },
    // Connecting a custom name on a channel online (`components/domain/DomainConnectForm.vue`): the
    // wallet against the next month of every fee the channel will run.
    confirmCharge: {
      title: 'Connecter {host}',
      summary: 'Ce domaine s’ajoute aux frais mensuels de votre chaîne, débités de votre portefeuille.',
      atPublication: 'Facturé à la publication de la chaîne',
      billedNow: 'Déjà facturé chaque mois',
      theChannel: 'La chaîne',
      domainLine: 'Domaine {host}',
      channelAndDomains: 'la chaîne et {n} domaine actif | la chaîne et {n} domaines actifs',
      domainsOnly: '{n} domaine actif | {n} domaines actifs',
      thisDomain: 'Nouveau domaine',
      newTotal: 'Nouveau total mensuel',
      balanceNow: 'Solde actuel',
      debitedNow: 'Débité à la connexion',
      nothingNow: 'Rien pour l’instant',
      balanceAfter: 'Solde après',
      fineprintOnline: 'Le premier mois du domaine est débité dès la connexion, puis chaque mois à la même date. Retirer le domaine arrête les frais : le mois en cours reste dû, rien n’est facturé ensuite.',
      fineprintOffline: 'Votre chaîne est hors ligne : rien n’est débité maintenant. Les frais démarrent quand elle sera publiée, pour la chaîne et ses domaines.',
      confirm: 'Confirmer et connecter',
    },
    connectBilling: {
      alreadyBilled: 'Déjà facturé pour cette chaîne',
      theChannel: 'la chaîne',
      missing: 'Votre solde ne couvre pas le prochain mois des frais de la chaîne ({total}).',
      neverFunded: 'Votre portefeuille n’est pas encore alimenté : le crédit acheté paie la chaîne, ses adresses et votre consommation.',
      dunning: 'Sans crédit, le domaine passe en impayé. Il est mis hors ligne après 14 jours, et reste réactivable pendant 30 jours.',
      channelOffline: 'Rien n’est facturé pour l’instant : les frais démarrent quand la chaîne sera en ligne.',
      topUpTitle: 'Recharger le portefeuille',
      topUpAndConnect: 'Recharger {amount} et connecter',
      connectPaid: 'Connecter · {amount}/mois',
      firstMonthNow: 'Le premier mois est débité dès la connexion, puis chaque mois.',
      creditPending: 'Paiement accepté. Le crédit met parfois une minute à arriver — l’adresse se raccorde dès qu’il est là.',
      creditLate: 'Votre paiement est bien passé, mais le crédit n’est pas encore arrivé. Réessayez de raccorder l’adresse dans un instant.',
    },
    editSubdomain: {
      title: 'Modifier le sous-domaine',
      description: 'Personnalisez votre sous-domaine Videas. L\'ancien sous-domaine sera conservé comme redirection.',
      preview: 'Aperçu :',
      save: 'Enregistrer',
      success: 'Sous-domaine mis à jour avec succès',
      error: 'Impossible de mettre à jour le sous-domaine',
      unavailable: 'Ce sous-domaine est déjà utilisé',
      available: 'Nom disponible',
      checking: 'Vérification de la disponibilité...',
    },
    addModal: {
      title: 'Ajouter un domaine',
      subtitle: 'Choisissez le type de domaine',
      preview: 'Aperçu :',
      setPrimary: 'Définir comme domaine principal',
      setPrimaryHint: 'Ce domaine sera affiché dans la barre d\'adresse',
      subdomain: {
        title: 'Sous-domaine Videas',
        description: 'Rapide et gratuit — utilisez un sous-domaine de {suffix}',
        descriptionNoSuffix: 'Rapide et gratuit — utilisez un sous-domaine de la plateforme',
        free: 'Gratuit',
        placeholder: 'mon-site',
        activate: 'Activer',
        tooShort: 'Minimum 3 caractères',
      },
      custom: {
        title: 'Domaine personnalisé',
        includedChip: 'Compris',
        description: 'Raccordez une adresse que vous possédez déjà, pour une image professionnelle',
        placeholder: 'videos.monentreprise.com',
        addAndConfigure: 'Ajouter et configurer',
        invalidFormat: 'Format de domaine invalide',
        alreadyAdded: 'Ce domaine est déjà ajouté',
        apex: 'Domaine racine',
        subdomain: 'Sous-domaine',
      },
      dns: {
        title: 'Configuration DNS requise',
        description: 'Ajoutez les enregistrements DNS suivants chez votre fournisseur de domaine pour connecter votre domaine.',
        name: 'Nom :',
        value: 'Valeur :',
        copy: 'Copier',
        applies: {
          below_apex: 'Si ce nom n\'est pas la racine de sa zone DNS',
          zone_apex: 'Si ce nom est la racine de sa zone DNS (un CNAME y est interdit)',
        },
        providersTitle: 'Instructions par hébergeur',
        otherProvider: 'Autre',
        propagation: 'La propagation DNS peut prendre jusqu\'à 48h (généralement quelques minutes).',
        ovh: {
          step1: 'Connectez-vous à votre espace client OVH',
          step2: 'Allez dans « Domaines » puis « Zone DNS »',
          step3: 'Cliquez sur « Ajouter une entrée »',
          step4: 'Ajoutez les enregistrements ci-dessus',
        },
        cloudflare: {
          step1: 'Connectez-vous à votre dashboard Cloudflare',
          step2: 'Sélectionnez votre domaine',
          step3: 'Allez dans « DNS » puis « Records »',
          step4: 'Ajoutez les enregistrements ci-dessus',
        },
        gandi: {
          step1: 'Connectez-vous à votre compte Gandi',
          step2: 'Allez dans « Domaines » puis « Enregistrements DNS »',
          step3: 'Cliquez sur « Ajouter »',
          step4: 'Ajoutez les enregistrements ci-dessus',
        },
        generic: {
          step1: 'Connectez-vous à l\'interface de gestion de votre hébergeur',
          step2: 'Trouvez la section « DNS » ou « Zone DNS »',
          step3: 'Ajoutez les enregistrements indiqués ci-dessus',
          step4: 'Sauvegardez les modifications',
        },
      },
      addSuccess: 'Domaine ajouté avec succès',
    },
    dnsConfig: {
      title: 'Configuration DNS',
      description: 'Pour connecter un domaine personnalisé, ajoutez l\'enregistrement DNS suivant chez votre fournisseur de domaine :',
      recordType: 'Type',
      host: 'Hôte',
      value: 'Valeur',
      cnameHost: 'votre-sous-domaine',
    },
    deleteConfirm: {
      title: 'Supprimer le domaine',
      message: 'Êtes-vous sûr de vouloir supprimer ce domaine ? Cette action est irréversible.',
      // U7: a fee is the whole month, charged at its anniversary and never prorated.
      feeStops: 'Le mois en cours reste dû ; plus rien n’est prélevé pour ce domaine ensuite.',
    },
    setPrimaryConfirm: {
      title: 'Définir comme domaine principal',
      message: 'Êtes-vous sûr de vouloir définir ce domaine comme domaine principal ? Le domaine principal actuel sera remplacé.',
    },
    deleteSuccess: 'Domaine supprimé avec succès',
    setPrimarySuccess: 'Domaine principal mis à jour avec succès',
    verifySuccess: 'Vérification DNS lancée',
    cannotDeletePrimary: 'Impossible de supprimer le domaine principal. Définissez d\'abord un autre domaine comme principal.',
    cannotDeletePlatform: 'Les domaines plateforme ne peuvent pas être supprimés.',
    addError: 'Impossible d\'ajouter le domaine',
    deleteError: 'Impossible de supprimer le domaine',
    setPrimaryError: 'Impossible de définir le domaine principal',
    verifyError: 'Impossible de lancer la vérification DNS',
    updateError: 'Impossible de mettre à jour le domaine',
    list: {
      title: 'Domaines',
      description: 'Domaines actuellement associés à votre site.',
      empty: 'Aucun domaine',
      emptyDescription: 'Aucun domaine n\'a encore été configuré pour ce site.',
    },
    info: {
      title: 'Gestion des domaines',
      description: 'La gestion des domaines personnalisés est assurée par votre administrateur. Contactez le support si vous avez besoin d\'ajouter ou de modifier un domaine.',
    },
    table: {
      domain: 'Domaine',
      type: 'Type',
      status: 'Statut',
      createdAt: 'Créé le',
    },
  },
  users: {
    cockpit: {
      kpis: {
        total: 'Membres',
        totalHint: 'tous les membres',
        active: 'Actifs (30 j)',
        activeHint: 'venus ces 30 derniers jours',
        joined: 'Nouveaux (30 j)',
        joinedHint: 'inscrits ces 30 derniers jours',
        pending: 'En attente',
        pendingHint: 'à approuver',
        invited: 'Invités',
        invitedHint: 'compte pas encore créé',
        customers: 'Clients',
        customersHint: 'un achat ou un abonnement',
        subscribers: 'Abonnés',
        subscribersHint: 'abonnement en cours',
        trial: 'En essai',
        trialHint: 'période d\'essai en cours',
      },
      quick: {
        all: 'Tous',
        active: 'Actifs',
        pending: 'En attente',
        invited: 'Invités',
        suspended: 'Suspendus',
        expired: 'Accès expiré',
        customers: 'Clients',
        subscribers: 'Abonnés',
      },
      reset: 'Réinitialiser',
      client: 'Client',
      clientNone: '—',
      subscriber: 'Abonné · {plan}',
      formerSubscriber: 'Ancien abonné',
      inTrial: 'En essai · {plan}',
      trialUntil: 'jusqu\'au {date}',
      trialNotConverted: 'Essai non converti',
      purchases: '{count} achat | {count} achats',
      invitedOn: 'Invité le {date}',
      invitationExpired: 'Invitation expirée',
      export: 'Exporter (CSV)',
      exporting: 'Export en cours…',
      exportError: 'L\'export a échoué',
      selected: '{count} membre sélectionné | {count} membres sélectionnés',
      clearSelection: 'Tout désélectionner',
      bulk: {
        approve: 'Approuver',
        addToGroup: 'Ajouter à un groupe',
        removeFromGroup: 'Retirer d\'un groupe',
        fullAccess: 'Donner l\'accès complet',
        export: 'Exporter',
        delete: 'Supprimer',
        deleteTitle: 'Supprimer {count} membre ? | Supprimer {count} membres ?',
        deleteMessage: 'Leurs adhésions sont retirées de la chaîne. Leurs achats restent dans les comptes.',
        done: '{count} membre mis à jour | {count} membres mis à jour',
        partial: '{done} sur {total} mis à jour : les autres ont changé entre-temps, rechargez la liste.',
      },
    },
    title: 'Utilisateurs & Groupes',
    subtitle: 'Gérez les utilisateurs et les groupes de votre site.',
    searchPlaceholder: 'Rechercher des utilisateurs...',
    btnInvite: 'Inviter',
    picker: {
      label: 'Utilisateurs',
      placeholder: 'Sélectionner des utilisateurs...',
      noResults: 'Aucun utilisateur trouvé',
    },
    filterByStatus: 'Statut',
    filterByGroup: 'Groupe',
    filterByAccess: 'Accès',
    filterByJoined: 'Inscription',
    filterByActivity: 'Activité',
    filterByTrial: 'Période d\'essai',
    trialFilter: {
      current: 'En essai',
      ever: 'A eu un essai',
      converted: 'Essai converti',
      not_converted: 'Essai non converti',
    },
    fullAccessFilter: {
      full: 'Accès complet',
      standard: 'Accès standard',
    },
    order: {
      newest: 'Les plus récents',
      oldest: 'Les plus anciens',
    },
    approve: 'Approuver l\'adhésion',
    approveSuccess: 'Adhésion approuvée',
    approveError: 'L\'approbation a échoué',
    staleMessage: 'Quelqu\'un a enregistré avant vous : rien n\'a été écrit. La fiche vient d\'être relue.',
    standing: {
      active: 'Actif',
      suspended: 'Suspendu',
      expired: 'Expiré',
      awaiting_approval: 'En attente d\'approbation',
      no_password: 'Inscription non finalisée',
      unverified_email: 'E-mail non vérifié',
    },
    standingHint: {
      active: 'Rien ne bloque l\'accès de cette personne.',
      suspended: 'Son adhésion est fermée. Son compte et ses achats sont conservés.',
      expired: 'Sa fenêtre d\'accès est passée : elle n\'atteint plus rien, quels que soient ses droits.',
      awaiting_approval: 'Personne ne l\'a encore laissée entrer. Une adhésion en attente n\'accorde rien.',
      no_password: 'Son compte n\'a pas de mot de passe : elle n\'a jamais terminé son inscription.',
      unverified_email: 'Sa boîte mail n\'a jamais répondu. La chaîne peut exiger cette vérification.',
    },
    passwordReset: {
      issued: 'Lien de réinitialisation envoyé',
      no_password: 'Ce compte n\'a pas de mot de passe : aucun lien de réinitialisation ne peut l\'atteindre. Envoyez-lui une invitation.',
      password_login_closed: 'Cette chaîne n\'autorise pas la connexion par mot de passe.',
      throttled: 'Un lien vient déjà d\'être envoyé. Réessayez dans quelques minutes.',
    },
    tabs: {
      users: 'Utilisateurs',
      groups: 'Groupes',
      invitations: 'Invitations',
    },
    invitations: {
      title: 'Invitations',
      subtitle: 'Gérez les invitations e-mail en attente et les liens d\'invitation.',
      emailTitle: 'Invitations par e-mail ({count})',
      linksTitle: 'Liens d\'invitation ({count})',
      empty: 'Aucune invitation en attente',
      noLinks: 'Aucun lien d\'invitation',
      unnamed: 'Lien sans nom',
      access: {
        full: 'Accès complet',
        standard: 'Standard',
      },
      table: {
        email: 'E-mail',
        access: 'Accès',
        invitedBy: 'Invité par',
        expires: 'Expiration',
        sendCount: 'Envois',
        delivery: 'Remise',
        name: 'Nom',
        status: 'Statut',
        uses: 'Utilisations',
        accessExpiry: 'Accès accordé',
      },
      actions: {
        resend: 'Renvoyer',
        cancel: 'Annuler',
        copyLink: 'Copier le lien',
        activate: 'Activer',
        deactivate: 'Désactiver',
        deleteLink: 'Supprimer le lien',
      },
      status: {
        active: 'Actif',
        accepted: 'Acceptée',
        outstanding: 'En attente',
        noAuthority: 'Émetteur sans autorité',
        inactive: 'Inactif',
        exhausted: 'Épuisé',
      },
      delivery: {
        queued: 'E-mail en file d\'envoi',
        no_relay: 'Aucun relais : le lien est toute la remise',
        sent: 'Envoyée',
      },
      urlOnceHint: 'Copiez ces liens maintenant : ils ne seront plus affichés. Au besoin, renvoyez l\'invitation depuis la fiche du membre.',
      noAuthorityHint: 'Le compte qui a émis ce lien n\'a plus autorité sur cette organisation : le lien est listé mais n\'inscrit personne.',
      // Les deux listes répondent à la clé qui émet, pas à celle qui lit la liste des membres.
      viewOnly: 'Les invitations et les liens se consultent avec le droit de gérer les membres, que votre rôle n\'a pas. Demandez-le à un administrateur de l\'organisation.',
      lastUsed: 'Dernière utilisation le {date}',
      expiry: {
        noExpiry: 'Sans expiration',
        expired: 'Expirée',
        today: 'Aujourd\'hui',
        tomorrow: 'Demain',
        expiresIn: 'Dans {days} jours',
      },
      toast: {
        resent: 'Invitation renvoyée',
        noRelay: 'Invitation créée. Ce déploiement n\'a pas de relais e-mail : copiez le lien pour le transmettre.',
        resendError: 'Impossible de renvoyer l\'invitation.',
        cancelled: 'Invitation annulée',
        cancelError: 'Impossible d\'annuler l\'invitation.',
        linkCopied: 'Lien copié',
        linkUpdated: 'Lien mis à jour',
        linkDeleted: 'Lien supprimé',
        urlUnavailable: 'Ce lien a été créé ailleurs : son adresse ne peut pas être redonnée. Créez-en un nouveau.',
        linkError: 'Impossible de mettre à jour le lien.',
      },
    },
    table: {
      email: 'Utilisateur',
      standing: 'Statut',
      groups: 'Groupes',
      joinedAt: 'Inscrit le',
      lastActivity: 'Dernière activité',
    },
    badges: {
      fullAccess: 'Accès complet',
      owner: 'Propriétaire',
      staff: 'Staff',
      inactive: 'Inactif',
      pending: 'En attente',
      expired: 'Expiré',
      pendingRegistration: 'Inscription non finalisée',
      pendingRegistrationHint: "Cet utilisateur n'a pas encore finalisé la création de son compte (aucun mot de passe défini).",
    },
    labels: {
      active: 'Actif',
      inactive: 'Inactif',
      pending: 'En attente',
      expired: 'Expiré',
      neverActive: 'Jamais',
      lastActivityHint: 'Écrit au plus une fois par heure : c\'est un « vu vers cette date », pas un horodatage.',
      recentlyActiveHint: 'Actif récemment',
    },
    filters: {
      joinedThisMonth: 'Inscrit ce mois-ci',
      joinedThisYear: 'Inscrit cette année',
      activityLt7: 'Actif (< 7 jours)',
      activityLt30: 'Actif (< 30 jours)',
      activityGt30: 'Inactif (> 30 jours)',
      activityNever: 'Jamais actif',
      clear: 'Effacer le filtre',
    },
    emptyState: {
      title: 'Aucun utilisateur',
      description: 'Invitez des utilisateurs à rejoindre votre site.',
      noResults: 'Aucun utilisateur trouvé',
      noResultsDescription: 'Essayez d\'ajuster vos filtres ou vos termes de recherche.',
    },
    deleteTitle: 'Supprimer l\'utilisateur',
    deleteMessage: 'Êtes-vous sûr de vouloir supprimer « {name} » ? Cette action est irréversible.',
    deleteSuccess: 'Utilisateur supprimé avec succès',
    deleteError: 'Échec de la suppression de l\'utilisateur',
    sendPasswordReset: 'Envoyer un lien de réinitialisation',
    passwordResetSuccess: 'Email de réinitialisation envoyé à {email}',
    passwordResetError: 'Échec de l\'envoi de l\'email de réinitialisation',
    detail: {
      backToUsers: 'Retour aux utilisateurs',
      saveSuccess: 'Utilisateur mis à jour avec succès',
      saveError: 'Échec de la mise à jour de l\'utilisateur',
      reactivateSuccess: 'Utilisateur réactivé avec succès',
      reactivateError: 'Échec de la réactivation de l\'utilisateur',
      deactivateSuccess: 'Utilisateur désactivé',
      deactivateError: 'Échec de la désactivation de l\'utilisateur',
      deleteSuccess: 'Utilisateur supprimé avec succès',
      deleteError: 'Échec de la suppression de l\'utilisateur',
      deleteTitle: 'Supprimer l\'utilisateur',
      deleteMessage: 'Êtes-vous sûr de vouloir supprimer « {name} » ?',
      deleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer cet utilisateur ?',
      inactiveAlert: 'Cet utilisateur ne s\'est pas encore inscrit.',
      pendingAlert: 'Cet utilisateur a été invité mais n\'a pas finalisé son inscription. Il ne peut pas accéder au site.',
      awaitingApprovalAlert: 'Cette personne attend qu\'on la laisse entrer. Tant qu\'elle n\'est pas approuvée, son adhésion n\'accorde rien.',
      unverifiedEmailAlert: 'Sa boîte mail n\'a jamais répondu. Si la chaîne exige la vérification, elle ne peut pas entrer.',
      deactivatedAlert: 'Cet utilisateur a été désactivé et ne peut pas accéder au site.',
      expiredAlert: 'L\'accès de cet utilisateur a expiré le {date}. Il ne peut plus accéder au site.',
      expiredGroupsAlert: 'Cet utilisateur appartient à {count} groupe(s) expiré(s) : {names}. L\'accès aux contenus de ces groupes n\'est plus actif.',
      resendInvitation: 'Renvoyer l\'invitation',
      sendInvitation: 'Envoyer l\'invitation',
      copyRegistrationLink: 'Copier le lien d\'inscription',
      linkCopied: 'Lien copié !',
      linkError: 'Échec de la génération du lien d\'inscription',
      extendAccess: 'Prolonger l\'accès',
      btnReactivate: 'Réactiver',
      reactivate: 'Réactiver',
      deactivate: 'Désactiver le compte',
      deactivateTitle: 'Désactiver ce compte ?',
      deactivateMessage: '{name} ne pourra plus se connecter ni accéder aux contenus. Son compte, ses groupes et ses accès sont conservés : vous pourrez le réactiver à tout moment.',
      status: {
        active: 'Actif',
        inactive: 'Inactif',
        pending: 'Inscription en attente',
        deactivated: 'Désactivé',
        expired: 'Expiré',
        groupExpired: 'Groupe expiré',
      },
      roles: {
        owner: 'Propriétaire',
        staff: 'Staff',
      },
      tabs: {
        overview: 'Vue d\'ensemble',
        purchases: 'Achats',
        information: 'Informations',
        access: 'Accès',
        statistics: 'Statistiques',
      },
      overview: {
        viewingTitle: 'Visionnage sur 90 jours',
        allStatistics: 'Toutes les statistiques',
        watchTime: 'Temps de visionnage',
        contentsWatched: 'Contenus vus',
        sessions: 'Sessions',
        completion: 'Complétion moyenne',
        recentTitle: 'Dernières sessions',
        noSessions: 'Aucun visionnage sur cette période.',
        watchedAt: 'vu à {pct}',
        customerTitle: 'Client',
        seePurchases: 'Voir les achats',
        notCustomer: 'N\'a encore rien acheté sur cette chaîne.',
        spentSince: 'dépensés · {refunded} remboursés',
        subscription: 'Abonnement',
        noSubscription: 'Aucun',
        nextRenewal: 'Prochain prélèvement',
        accessUntil: 'Accès jusqu\'au',
        purchasesCount: 'Achats et locations',
        lastPurchase: 'Dernier achat',
        groupsTitle: 'Groupes',
        noGroups: 'Dans aucun groupe.',
        manageGroups: 'Gérer',
        joinTitle: 'Inscription',
      },
      invitation: {
        invited: 'Invité le {date}',
        invitedBy: 'par {name}',
        reminded: 'Relancé {count} fois',
        accepted: 'Invitation acceptée le {date}',
        joined: 'Membre depuis le {date}',
        registeredAlone: 'Inscrit lui-même le {date}',
        notCreated: 'Compte pas encore créé',
        expiresOn: 'L\'invitation expire le {date}',
        expiredOn: 'L\'invitation a expiré le {date}',
        firstSeen: 'Première visite le {date}',
        lastSeen: 'Dernière activité {when}',
        neverSeen: 'Jamais venu sur la chaîne',
        banner: 'Cette personne a été invitée le {date} et n\'a pas encore créé son compte.',
        bannerExpired: 'L\'invitation envoyée le {date} a expiré sans que le compte soit créé.',
        bannerReminded: 'Relancée {count} fois.',
        bannerNeverSent: 'Ajouté le {date}, cette personne n\'a jamais reçu d\'invitation et n\'est jamais venue sur la chaîne.',
        chip: 'Invité · compte non créé',
        chipNeverSent: 'Jamais invité',
        chipExpired: 'Invitation expirée',
      },
      purchases: {
        totalSpent: 'Total dépensé',
        totalSpentHint: 'TTC, remboursements déduits',
        subscription: 'Abonnement',
        noSubscription: 'Aucun abonnement en cours',
        purchases: 'Achats et locations',
        refunded: 'Remboursé',
        paymentsTitle: 'Paiements',
        paymentsHint: 'Chaque paiement de ce membre sur la chaîne',
        noPayments: 'Aucun paiement.',
        imported: 'importé',
        kind: {
          purchase: 'Achat',
          rental: 'Location',
          contribution: 'Contribution de soutien',
          subscription: 'Abonnement',
        },
      },
      accessView: {
        accountTitle: 'Accès au compte',
        fullAccess: 'Accès complet',
        fullAccessHint: 'voit tout le catalogue, sans abonnement',
        endTitle: 'Fin d\'accès au compte',
        endHint: 'après cette date, le compte ne se connecte plus',
        groupsTitle: 'Groupes',
        groupsHint: 'Enregistrés en même temps que la page',
        groupsPicker: 'Membre de',
        noGroupToPick: 'Cette chaîne n\'a encore aucun groupe',
        groupUnsaved: 'Ajouté, appliqué à l\'enregistrement',
        noGroups: 'Dans aucun groupe.',
        groupGrants: 'donne accès à {count} contenu | donne accès à {count} contenus',
        title: 'Ce à quoi {name} a accès',
        subtitle: 'Chaque contenu, et ce qui lui en donne l\'accès',
        grant: 'Donner accès à un contenu',
        all: 'Tout',
        kind: {
          full_access: 'Accès complet',
          subscription: 'Abonnement',
          group: 'Groupes',
          category: 'Catégories',
          purchase: 'Achats',
          direct: 'Accès direct',
        },
        reason: {
          direct: 'Accès direct',
          group: 'Groupe {name}',
          category: 'Catégorie {name}',
          categoryViaGroup: 'Catégorie {name} · groupe {group}',
          purchase: 'Achat',
          rental: 'Location',
          subscription: 'Abonnement {name}',
          fullAccess: 'Via accès complet',
          fullAccessGroup: 'Via accès complet · groupe {name}',
          fullAccessPlan: 'Via accès complet · abonnement {name}',
        },
        until: 'Jusqu\'au',
        never: 'sans fin',
        content: 'Contenu',
        reachedBy: 'Accès par',
        revokeDirect: 'Retirer l\'accès direct',
        revokeCategory: 'Retirer l\'accès à la catégorie {name}',
        revoked: 'Accès retiré',
        revokeError: 'Le retrait a échoué',
        empty: 'Aucun contenu accordé en particulier.',
        notLive: 'Cette adhésion n\'accorde rien aujourd\'hui (suspendue, expirée ou en attente) : les droits ci-dessous reviendront avec elle.',
        everything: 'Voit tout le catalogue :',
        everythingMember: 'accès complet du membre',
        everythingGroup: 'groupe {name}',
        everythingPlan: 'abonnement {name}',
        openItems: '+ {count} contenu ouvert à tous les membres (non repris ici) | + {count} contenus ouverts à tous les membres (non repris ici)',
        truncated: 'Liste partielle : ce membre a trop de droits pour tous les afficher.',
        pagesTitle: 'Pages accordées',
      },
      commerce: {
        subscriber: 'Abonné · {plan}',
        formerSubscriber: 'Ancien abonné',
        purchases: '{count} achat | {count} achats',
        rentalUntil: 'Location jusqu\'au {date}',
      },
      information: {
        accountTitle: 'Compte',
        securityTitle: 'Sécurité',
        accessUntil: 'Fin d\'accès',
        accessNoEnd: 'Aucune',
        passwordSet: 'Mot de passe défini',
        passwordNone: 'Pas de mot de passe',
        readOnly: 'Lecture seule',
        profileTitle: 'Profil',
        profileEditable: 'Le nom et l\'adresse du compte. Modifiables parce que ce compte n\'existe que sur cette chaîne.',
        accountDescription: 'Les dates clés de l\'adhésion.',
        passwordTitle: 'Mot de passe',
        passwordDescription: 'On ne voit jamais le mot de passe. On peut envoyer au membre un lien pour le changer.',
        newsletterTitle: 'Newsletter',
        newsletterLabel: 'Reçoit la newsletter de la chaîne',
        registrationTitle: 'Formulaire d\'inscription',
        registrationDescription: 'Ce que le membre a répondu en s\'inscrivant. Les champs marqués « interne » ne lui sont pas montrés.',
        memberSince: 'Membre depuis le {date}',
        internal: 'interne',
        passwordSendLink: 'Envoyer un lien de réinitialisation',
        identityTitle: 'Identité',
        identityDescription: 'Identité du compte utilisateur.',
        identityOwnedHint: 'L\'adresse et le nom appartiennent au compte, pas à l\'adhésion : ils se modifient depuis le compte de la personne.',
        emailVerified: 'Vérifié',
        emailUnverified: 'Non vérifié',
        noName: 'Pas de nom',
        approvedAt: 'Approuvé le',
        notApproved: 'Pas encore approuvé',
        noPasswordHint: 'Ce compte n\'a pas de mot de passe : un lien de réinitialisation ne l\'atteindrait pas. Envoyez-lui une invitation.',
        newsletterOptOutHint: 'Un membre est abonné à son arrivée. Vous pouvez enregistrer un désabonnement qu\'il a demandé ; vous ne pouvez pas l\'abonner à sa place.',
        newsletterOptedOut: 'Ce membre s\'est désabonné : lui seul peut se réabonner, depuis son compte.',
        email: 'Email',
        emailGlobalHint: 'Cet email identifie le compte sur l\'ensemble de la plateforme. Le modifier change l\'identifiant de connexion partout.',
        name: 'Nom',
        preferencesTitle: 'Préférences',
        preferencesDescription: 'Préférences de newsletter et de notifications.',
        newsletterEnabled: 'Newsletter',
        newsletterEnabledHint: 'L\'utilisateur reçoit les emails de newsletter',
        passwordHint: 'Envoyer un email pour réinitialiser le mot de passe de cet utilisateur.',
        metadataTitle: 'Champs personnalisés',
        metadataDescription: 'Informations complémentaires collectées pour cet utilisateur.',
        metadataPrivate: 'Admin uniquement',
        metadataSave: 'Enregistrer les champs',
        metadataSaved: 'Champs personnalisés enregistrés',
        metadataError: 'Échec de l\'enregistrement des champs',
      },
      access: {
        title: 'Accès aux contenus',
        subtitle: 'Contenus accessibles par cet utilisateur.',
        description: 'Contenus accessibles par cet utilisateur.',
        banner: {
          title: '{count} contenu(s) accessible(s)',
          description: 'Accès via : {sources}',
          fullAccess: 'Accès complet activé',
          fullAccessHint: 'Cet utilisateur peut accéder à tous les contenus restreints du site.',
        },
        sources: {
          direct: '{count} direct(s)',
          groups: '{count} groupe(s)',
          subscriptions: '{count} abonnement(s)',
          purchases: '{count} achat(s)',
          rentals: '{count} location(s)',
        },
        accessSettings: {
          title: 'Accès complet',
          description: 'Accorder un accès illimité à tous les contenus du site.',
          fullAccess: 'Accès à tout le contenu',
          fullAccessHint: 'Cet utilisateur voit tout le contenu du site, sans restriction.',
          groupsTitle: 'Groupes',
          groupsHint: 'Les groupes ajoutent des accès, ils n\'en retirent jamais. L\'expiration d\'un groupe ne coupe que les contenus partagés via ce groupe ; la date d\'expiration ci-dessus, elle, ferme tout le site à cet utilisateur, quels que soient ses groupes.',
          groupsLabel: 'Groupes',
          groupsCount: 'Membre de {count} groupe | Membre de {count} groupe | Membre de {count} groupes',
          groupsManagedOnGroup: 'L\'appartenance à un groupe se gère depuis le groupe : c\'est là qu\'elle s\'écrit et qu\'elle se lit.',
          groupsPlaceholder: 'Sélectionner des groupes...',
          expirationTitle: 'Expiration',
          expiresAt: 'Date d\'expiration',
          expiresAtHint: 'Au-delà de cette date, l\'utilisateur ne pourra plus accéder au site — quels que soient ses autres droits d\'accès.',
        },
        table: {
          title: 'Titre',
          slug: 'Slug',
          status: 'Statut',
          directAccess: 'Direct',
          accessType: 'Accès',
        },
        published: 'Publié',
        unpublished: 'Non publié',
        directBadge: 'Direct',
        directAccess: 'Direct',
        groupAccess: 'Via groupe',
        btnRevoke: 'Révoquer',
        revoke: 'Révoquer l\'accès',
        emptyState: 'Aucun contenu accessible.',
        emptyTitle: 'Aucun contenu accessible',
        emptyDescription: 'Cet utilisateur n\'a accès à aucun contenu restreint.',
        purchasesAndSubscriptions: {
          title: 'Achats & abonnements',
          count: '{count} source | {count} sources',
        },
        subscriptions: {
          title: 'Abonnements',
          fullAccess: 'Accès complet',
          items: '{count} contenu(s)',
          autoRenew: 'Renouvellement auto',
          expiresOn: 'Se termine le {date}',
          complimentary: 'Offert',
          giftBtn: 'Offrir un abonnement',
          cancel: 'Résilier l\'abonnement',
          cancelConfirmComplimentary: 'Voulez-vous vraiment résilier cet abonnement offert ? L\'accès sera révoqué immédiatement.',
          cancelIrreversible: 'Cette action est irréversible.',
          cancelConfirmPaid: 'L\'utilisateur perdra l\'accès à la fin de la période d\'engagement en cours, le {date}. L\'abonnement ne sera pas renouvelé.',
          cancelTypePrompt: 'Écrivez « {word} » pour confirmer :',
          cancelConfirmWord: 'RÉSILIER',
          cancelConfirmBtn: 'Résilier l\'abonnement',
          cancelSuccess: 'Abonnement résilié',
          cancelError: 'L\'abonnement n\'a pas pu être résilié.',
          noSubscriptions: 'Aucun abonnement',
          cancelledOn: 'Terminé le {date}',
          expiredOn: 'Terminé le {date}',
          renewsOn: 'Renouvelé le {date}',
          noEnd: 'Sans date de fin',
          status: {
            active: 'Actif',
            past_due: 'Paiement en attente',
            cancelled: 'Résilié',
            expired: 'Terminé',
            paused: 'En pause',
          },
        },
        purchases: {
          title: 'Achats',
          purchasedOn: 'Acheté le {date}',
          download: 'Téléchargement autorisé',
        },
        rentals: {
          title: 'Locations',
          expiresOn: 'Expire le {date}',
          hoursRemaining: '{hours}h restantes',
          expiringSoon: 'Expire bientôt',
        },
        directItems: {
          title: 'Accès direct au contenu',
          description: 'Donnez à cet utilisateur l\'accès à tout le contenu, ou à des contenus précis.',
          specificTitle: 'Contenus spécifiques',
          fullAccessActive: 'L\'accès complet est activé : cet utilisateur a déjà accès à tout le contenu. Les accès spécifiques sont inutiles tant que l\'accès complet reste activé.',
          btnGrant: 'Accorder l\'accès',
          revokeConfirmTitle: 'Révoquer l\'accès',
          revokeConfirmMessage: 'Êtes-vous sûr de vouloir révoquer l\'accès direct à « {title} » ?',
          revokeSuccess: 'Accès révoqué avec succès',
          revokeError: 'Échec de la révocation de l\'accès',
          grantSuccess: 'Accès accordé avec succès',
          grantError: 'Échec de l\'accord de l\'accès',
          emptyTitle: 'Aucun accès direct',
          emptyDescription: 'Cet utilisateur n\'a aucun accès direct aux contenus. Utilisez le bouton ci-dessus pour accorder l\'accès.',
          selectedCount: '{count} contenu(s) sélectionné(s)',
          revokeSelection: 'Révoquer la sélection',
          batchRevokeMessage: 'Êtes-vous sûr de vouloir révoquer l\'accès à {count} contenu(s) ?',
          batchRevokeSuccess: '{count} accès révoqué(s) avec succès',
          batchRevokePartial: '{completed} révoqué(s), {failed} échoué(s)',
        },
        groupItems: {
          title: 'Accès via groupes',
          expired: 'Expiré',
          items: '{count} contenu(s)',
          viewAll: 'Voir les {count} contenus',
          viewGroup: 'Voir le groupe',
        },
        grantDialog: {
          title: 'Accorder l\'accès à un contenu',
          searchPlaceholder: 'Rechercher des contenus restreints...',
          noResults: 'Aucun contenu restreint trouvé',
          grantByCategory: 'Accorder par catégorie',
          categoryHint: 'Accorder l\'accès à tous les contenus de la catégorie sélectionnée.',
          grantItems: 'Accorder l\'accès',
          grantCategory: 'Accorder la catégorie',
        },
      },
      statistics: {
        title: 'Statistiques',
        description: 'Vue d\'ensemble de l\'activité de cet utilisateur.',
        lastActivity: 'Dernière activité',
        registrationDate: 'Date d\'inscription',
        groupsCount: 'Groupes',
        never: 'Jamais',
      },
    },
    invite: {
      title: 'Inviter sur votre chaîne',
      header: {
        subtitle: 'Chaque personne recevra une invitation personnelle par e-mail.',
        subtitleLink: 'Un seul lien à partager : toute personne qui l\'ouvre peut rejoindre la chaîne.',
      },
      mode: {
        switchToLink: 'Créer un lien à partager',
        switchToLinkHint: 'Partagez un seul lien pour que les gens rejoignent — sans saisir leurs e-mails.',
        switchToEmail: 'Retour à l\'invitation par e-mail',
        linkHistory: 'Historique des liens',
      },
      history: {
        back: 'Retour au lien',
        created: 'créé le {date}',
      },
      access: {
        title: 'Niveau d\'accès',
        standard: {
          label: 'Accès standard',
          desc: 'Contenu public de la chaîne',
          hint: 'Ils peuvent parcourir tout ce qui est publié publiquement sur cette chaîne.',
        },
        full: {
          label: 'Accès complet',
          desc: 'Tout le contenu, y compris restreint',
          hint: 'Ils accèdent aussi au contenu privé et restreint de cette chaîne.',
        },
      },
      groups: {
        title: 'Ajouter à des groupes (optionnel)',
        placeholder: 'Sélectionner des groupes…',
        hint: 'Les membres héritent de l\'accès au contenu accordé par chaque groupe.',
        count: '{count} groupe(s)',
      },
      expiry: {
        title: 'Expiration de l\'accès',
        never: 'Jamais',
        duration: 'Durée',
        date: 'À une date',
        days: '{count} jours',
        year: '1 an',
        summaryNever: 'N\'expire jamais',
        summaryDuration: 'Expire {count} jours après l\'inscription',
        summaryDate: 'Expire le {date}',
        durationHint: 'Compté à partir de l\'inscription de chaque personne : quelqu\'un qui arrive tard garde toute sa durée.',
      },
      grantsHint: 'Un lien qui accorde un accès complet ou un groupe change ce que les gens voient : il demande aussi le droit de gérer les accès.',
      grantsRefused: 'Il vous manque le droit de gérer les accès : un lien portant un accès complet ou un groupe sera refusé.',
      form: {
        nameLabel: 'Nom du lien (optionnel)',
        nameHelper: 'Uniquement pour le reconnaître plus tard — un nom daté est utilisé si vous le laissez vide.',
        namePlaceholder: 'ex. Abonnés newsletter',
        defaultName: 'Partage · {date}',
        quotasTitle: 'Limites',
        generateButton: 'Générer le lien',
      },
      settings: {
        maxUses: {
          title: 'Limite d\'utilisation',
          hint: 'Le lien sera désactivé une fois cette limite atteinte',
          unlimited: 'Illimité',
          uses: '{count} utilisation(s)',
        },
        expiration: {
          title: 'Durée de validité',
          hint: 'Le lien expirera automatiquement',
          never: 'Jamais',
          default: 'Par défaut (30 jours)',
          '1d': '1 jour',
          '7d': '7 jours',
          '15d': '15 jours',
          '30d': '30 jours',
        },
      },
      review: {
        recipients: 'Destinataires',
        access: 'Niveau d\'accès',
        willSee: 'Ils obtiendront',
        editButton: 'Modifier',
        sendButton: 'Envoyer aucune invitation | Envoyer 1 invitation | Envoyer {count} invitations',
      },
      result: {
        title: 'Lien d\'invitation généré',
        sentTitle: 'Invitations envoyées',
        sentDescription: 'Les adhésions sont créées et chaque personne a reçu son lien personnel.',
        urlsLabel: 'Liens à transmettre',
        description: '« {name} » est prêt à être partagé. Vous pourrez le désactiver, le réactiver ou copier son adresse depuis l\'onglet Invitations ; pour d\'autres réglages d\'accès, créez un nouveau lien.',
        createAnother: 'Créer un autre lien',
        inviteMore: 'Inviter d\'autres personnes',
        resentDescription: 'Aucune adhésion n\'a été créée : chaque personne a reçu un nouveau lien personnel, avec les accès qu\'elle avait déjà.',
      },
      errors: {
        alreadyMembers: 'Ces personnes sont déjà membres de cette chaîne :',
        sendFailed: 'Échec de l\'envoi des invitations à :',
        reinvited: 'Ces adresses avaient déjà une adhésion jamais finalisée : l\'invitation leur a été renvoyée, leurs accès actuels sont inchangés :',
      },
      toast: {
        invitesSent: 'Aucune invitation envoyée | 1 invitation envoyée | {count} invitations envoyées',
        emailsAdded: '{count} e-mail(s) ajouté(s)',
        linkCreated: 'Lien d\'invitation créé',
        linkCreateFailed: 'Échec de la création du lien',
        linkCopied: 'Lien copié dans le presse-papiers',
        linkActivated: 'Lien activé',
        linkDeactivated: 'Lien désactivé',
        linkUpdateFailed: 'Échec de la mise à jour du lien',
      },
    },
  },
  groups: {
    subtitle: 'Gérez les groupes d\'accès de votre site.',
    searchPlaceholder: 'Rechercher des groupes...',
    tabs: {
      access: 'Accès',
    },
    btnCreate: 'Créer un groupe',
    table: {
      name: 'Nom',
      members: 'Membres',
      grants: 'Accès',
      createdAt: 'Créé le',
      expiresAt: 'Expiration',
    },
    staleMessage: 'Quelqu\'un a enregistré avant vous : rien n\'a été écrit. La fiche vient d\'être relue.',
    emptyState: {
      title: 'Aucun groupe',
      description: 'Créez votre premier groupe pour organiser l\'accès des utilisateurs.',
      noResults: 'Aucun groupe trouvé',
      noResultsDescription: 'Essayez d\'ajuster vos termes de recherche.',
    },
    deleteTitle: 'Supprimer le groupe',
    deleteMessage: 'Êtes-vous sûr de vouloir supprimer « {name} » ? Tous les membres seront retirés.',
    deleteSuccess: 'Groupe supprimé avec succès',
    deleteError: 'Échec de la suppression du groupe',
    picker: {
      label: 'Groupes',
      placeholder: 'Sélectionner des groupes...',
      noResults: 'Aucun groupe trouvé',
    },
    detail: {
      backToGroups: 'Retour aux groupes',
      newGroup: 'Nouveau groupe',
      saveSuccess: 'Groupe mis à jour avec succès',
      saveError: 'Échec de la mise à jour du groupe',
      createSuccess: 'Groupe créé avec succès',
      createError: 'Échec de la création du groupe',
      nameTaken: 'Un autre groupe actif de cette chaîne porte déjà ce nom.',
      deleteSuccess: 'Groupe supprimé avec succès',
      deleteError: 'Échec de la suppression du groupe',
      deleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer ce groupe ?',
      invalidForm: 'Veuillez remplir tous les champs requis',
      saveGroupFirst: 'Enregistrez le groupe pour activer cet onglet',
      expiredBadge: 'Expiré',
      expiredAlert: 'Ce groupe a expiré. Les membres n\'ont plus accès au contenu du groupe.',
      tabs: {
        information: 'Informations',
        members: 'Membres',
        access: 'Accès',
      },
      information: {
        name: 'Nom du groupe',
        namePlaceholder: 'ex. Membres Premium',
        groupTitle: 'Groupe',
        groupDescription: 'Comment ce groupe s\'appelle dans le back office, et à quoi il sert.',
        fullAccessTitle: 'Accès complet',
        nameRequired: 'Le nom du groupe est requis',
        nameTooShort: 'Le nom doit contenir au moins 2 caractères',
        nameTooLong: 'Le nom ne doit pas dépasser 100 caractères',
        description: 'Description',
        descriptionPlaceholder: 'Décrivez ce groupe...',
        fullAccess: 'Accès à tout le contenu',
        fullAccessHint: 'Chaque membre de ce groupe accède à tous les contenus de la chaîne, tant que le groupe est actif et non expiré.',
        expirationTitle: 'Expiration',
        expiresAt: 'Date d\'expiration',
        expiresAtHint: 'Passé cette date, les membres de ce groupe perdent l\'accès aux contenus partagés via ce groupe. Leurs autres accès (droits directs, autres groupes, leur propre compte) ne sont pas affectés. Laisser vide pour aucune expiration.',
        expiresAtUserNote: 'La date d\'expiration propre à un utilisateur (définie sur sa fiche) prédomine : un utilisateur expiré perd l\'accès à tout le site, quels que soient ses groupes.',
      },
      members: {
        title: 'Membres',
        addMembers: 'Ajouter des membres',
        searchUsers: 'Rechercher des utilisateurs',
        searchUsersPlaceholder: 'Rechercher par nom ou email...',
        addHint: 'Les personnes déjà dans le groupe y restent : vous pouvez sélectionner librement.',
        addAlreadyThere: '{changed} ajouté(s) sur {requested} : les autres étaient déjà dans le groupe.',
        noUsersFound: 'Aucun utilisateur trouvé',
        addSelected: 'Ajouter ({count})',
        removeMember: 'Retirer',
        removeConfirm: 'Retirer ce membre du groupe ?',
        table: {
          user: 'Utilisateur',
          joinedAt: 'Inscrit le',
        },
        emptyTitle: 'Aucun membre pour le moment',
        emptyState: 'Ajoutez des membres pour leur donner accès aux contenus de ce groupe.',
        addSuccess: 'Membre ajouté avec succès',
        addSuccessCount: '{count} membre(s) ajouté(s)',
        addPartial: '{completed} ajoutés, {failed} en échec',
        addError: 'Échec de l\'ajout du membre',
        removeSuccess: 'Membre retiré avec succès',
        removeError: 'Échec du retrait du membre',
      },
      access: {
        title: 'Contenus accessibles',
        fullAccessActive: 'Ce groupe donne un accès à tout le contenu : les accès ci-dessous ne changent rien tant que cet interrupteur reste activé.',
        btnGrant: 'Accorder l\'accès',
        bannerTitle: '{count} contenu accessible par {members} membres | {count} contenus accessibles par {members} membres',
        bannerDescription: 'Les contenus accordés à ce groupe sont accessibles à tous ses membres.',
        emptyWithMembers: 'Ce groupe a {count} membres mais aucun contenu restreint avec accès. Accordez un accès pour commencer.',
        emptyTitle: 'Aucun contenu accessible',
        emptyDescription: 'Ce groupe n\'a accès à aucun contenu. Utilisez le bouton ci-dessus pour accorder l\'accès à des contenus restreints.',
        searchPlaceholder: 'Rechercher des contenus...',
        revokeConfirmTitle: 'Révoquer l\'accès',
        revokeConfirmMessage: 'Êtes-vous sûr de vouloir révoquer l\'accès à « {title} » pour ce groupe ?',
        revokeSuccess: 'Accès révoqué avec succès',
        revokeError: 'Échec de la révocation de l\'accès',
        grantSuccess: 'Accès accordé avec succès',
        grantError: 'Échec de l\'accord de l\'accès',
        published: 'Publié',
        unpublished: 'Non publié',
        selectedCount: '{count} contenu(s) sélectionné(s)',
        revokeSelection: 'Révoquer la sélection',
        batchRevokeMessage: 'Êtes-vous sûr de vouloir révoquer l\'accès à {count} contenu(s) pour ce groupe ?',
        batchRevokeSuccess: '{count} accès révoqué(s) avec succès',
        batchRevokePartial: '{completed} révoqué(s), {failed} échoué(s)',
        table: {
          title: 'Titre',
          slug: 'Slug',
          status: 'Statut',
        },
        grantDialog: {
          title: 'Accorder l\'accès à un contenu',
          searchPlaceholder: 'Rechercher des contenus restreints...',
          noResults: 'Aucun contenu restreint sans accès trouvé',
          grantByCategory: 'Accorder par catégorie',
          categoryHint: 'Accorder l\'accès à tous les contenus de la catégorie sélectionnée.',
          grantItems: 'Accorder l\'accès',
          grantCategory: 'Accorder la catégorie',
        },
      },
      danger: {
        title: 'Zone dangereuse',
        deleteTitle: 'Supprimer ce groupe',
        deleteDescription: 'Une fois supprimé, tous les membres seront définitivement retirés.',
        deleteButton: 'Supprimer le groupe',
      },
    },
  },
  subscriptions: {
    title: 'Abonnements',
    subtitle: 'Les formules auxquelles vos visiteurs souscrivent, et ce que chacune ouvre.',
    tabs: {
      subscriptions: 'Abonnements',
      coupons: 'Coupons',
    },
    btnCreate: 'Créer un abonnement',
    featured: 'Mis en avant',
    conflict: 'Ce plan a été enregistré ailleurs pendant votre saisie : rien n\'a été écrit. Rechargez, puis renvoyez vos modifications.',
    filterStatus: 'Statut',
    searchPlaceholder: 'Rechercher un abonnement...',
    filterAll: 'Tous',
    filterActive: 'En vente',
    filterInactive: 'Retiré de la vente',
    table: {
      name: 'Nom',
      price: 'Prix',
      term: 'Engagement',
      includes: 'Contenus',
      subscribers: 'Abonnés actifs',
      perPeriod: 'par {period}',
      fullAccess: 'Tout le catalogue',
      itemCount: {
        zero: 'Aucun contenu',
        one: '1 contenu',
        other: '{count} contenus',
      },
      renews: 'Sans fin',
      cycles: '{count} cycles',
      createdAt: 'Créé le',
      status: 'Statut',
    },
    status: {
      notSoldOnline: 'Non vendable en ligne',
      active: 'En vente',
      inactive: 'Retiré',
    },
    emptyState: {
      title: 'Aucun plan d\'abonnement',
      description: 'Créez votre premier plan d\'abonnement pour commencer à monétiser votre contenu.',
      noResults: 'Aucun plan trouvé',
      noResultsDescription: 'Essayez un autre statut.',
    },
    deleteTitle: 'Supprimer le plan d\'abonnement',
    deleteMessage: 'Supprimer « {name} » ? Le plan cesse d\'être vendu ; les abonnés en cours gardent l\'accès qu\'ils ont payé.',
    deleteSuccess: 'Plan d\'abonnement supprimé',
    periods: {
      weekly: 'Hebdomadaire',
      monthly: 'Mensuel',
      quarterly: 'Trimestriel',
      halfYearly: 'Semestriel',
      yearly: 'Annuel',
      custom: 'Personnalisée',
      oneTime: 'Paiement unique',
    },
    detail: {
      newSubscription: 'Nouvel abonnement',
      saveFirst: 'Enregistrez le plan pour activer cet onglet',
      saveError: 'L\'enregistrement du plan a échoué',
      createSuccess: 'Plan d\'abonnement créé',
      updateSuccess: 'Plan d\'abonnement mis à jour',
      tabs: {
        information: 'Informations',
        items: 'Contenus',
        subscribers: 'Abonnés',
      },
      information: {
        basicTitle: 'Informations de base',
        basicDescription: 'Nom, adresse et description du plan.',
        name: 'Nom du plan',
        namePlaceholder: 'ex. Premium mensuel',
        nameRequired: 'Le nom du plan est requis',
        nameTooShort: 'Le nom doit contenir au moins 2 caractères',
        slug: 'Adresse',
        slugHint: 'L\'adresse de la page du plan sur votre site. Elle cesse de suivre le nom dès que vous la modifiez.',
        slugInvalid: 'Une adresse est faite de mots en minuscules reliés par des traits d\'union, comme « abonnement-annuel »',
        description: 'Description',
        descriptionPlaceholder: 'Décrivez ce plan d\'abonnement...',
        thumbnailTitle: 'Illustration',
        thumbnailDescription: 'L\'image affichée sur la page des tarifs.',
        thumbnailHint: 'Une image de votre bibliothèque.',
        pricingTitle: 'Tarification',
        pricingDescription: 'Ce que le plan coûte, et ce qu\'il ouvre.',
        currency: 'Devise',
        fullAccess: 'Accès à tout le catalogue',
        fullAccessHint: 'L\'abonné accède à l\'ensemble des contenus, nouveautés comprises. Sinon, rattachez les contenus inclus depuis l\'onglet Contenus.',
        billingTitle: 'Période de facturation',
        billingDescription: 'La durée d\'un cycle : un nombre et une unité, jamais un nombre de jours.',
        period: 'Période',
        periodCount: 'Nombre',
        periodUnit: 'Unité',
        periodEcho: 'Facturé {price} par {period}.',
        periodInvalid: 'Un cycle dure au moins une unité',
        advancedTitle: 'Durée de l\'engagement',
        advancedDescription: 'Combien de cycles l\'abonnement court, et l\'essai qui le précède.',
        autoRenew: 'Renouvellement sans fin',
        autoRenewHint: 'L\'abonnement se renouvelle jusqu\'à ce que l\'abonné y mette fin.',
        maxIterations: 'Nombre de cycles',
        maxIterationsHint: 'Soit {total} d\'accès en tout ; un seul cycle, c\'est un paiement unique.',
        maxIterationsInvalid: 'Un plan court au moins un cycle',
        trial: 'Essai gratuit',
        trialHint: 'Un premier cycle offert avant la première facturation.',
        trialNotSold: 'Non vendable en ligne : le paiement ne propose pas encore d\'essai gratuit. Retirez l\'essai pour vendre cette formule.',
        trialCount: 'Durée',
        trialUnit: 'Unité',
        trialInvalid: 'Un essai dure au moins une unité',
        publicationTitle: 'Publication',
        publicationDescription: 'Ce que la page des tarifs fait de ce plan.',
        isFeatured: 'Mettre en avant',
        isFeaturedHint: 'Ce plan est affiché avant les autres sur la page des tarifs.',
        isActive: 'En vente',
        isActiveHint: 'Ce plan est visible et souscriptible.',
        withdrawnNote: 'Retirer un plan de la vente n\'annule aucun abonnement : les abonnés en cours gardent leur accès jusqu\'au terme qu\'ils ont payé.',
      },
      items: {
        title: 'Contenus inclus',
        description: 'Les contenus que ce plan ouvre à ses abonnés.',
        btnAdd: 'Ajouter des contenus',
        fullAccessNote: 'Ce plan ouvre tout le catalogue, nouveautés comprises : il n\'y a pas de liste à tenir.',
        missing: 'Contenu supprimé',
        remove: 'Retirer du plan',
        showMore: 'Afficher la suite ({shown} sur {total})',
        duplicate: 'Ce contenu vient d\'être ajouté au plan ailleurs ; la liste a été rechargée.',
        saveError: 'L\'enregistrement du plan a échoué',
        emptyState: {
          title: 'Aucun contenu dans ce plan',
          description: 'Ajoutez des contenus pour les rendre accessibles aux abonnés.',
        },
        addDialog: {
          title: 'Ajouter des contenus au plan',
          searchPlaceholder: 'Rechercher dans le catalogue...',
          noResults: 'Aucun contenu',
          alreadyIn: 'Déjà inclus',
          add: 'Ajouter',
        },
        addSuccess: 'Contenus ajoutés au plan',
        removeSuccess: 'Contenu retiré du plan',
      },
      subscribers: {
        title: 'Abonnés',
        description: 'Utilisateurs abonnés à ce plan.',
        searchPlaceholder: 'Rechercher des abonnés...',
        stats: {
          activeSubscribers: 'Abonnés actifs',
          monthlyRevenue: 'Revenu mensuel',
          cancelling: 'Résiliations en cours',
        },
        filterStatus: 'Statut',
        filterAll: 'Tous',
        extendSuccess: 'Abonnement prolongé.',
        extendError: 'Impossible de prolonger l\'abonnement.',
        grantSuccess: 'Accès offert.',
        grantError: 'Impossible d\'offrir l\'accès.',
        grantNotMember: 'Aucun membre de la chaîne n\'a cette adresse : invitez-le d\'abord.',
        table: {
          user: 'Utilisateur',
          status: 'Statut',
          startDate: 'Date de début',
          endDate: 'Date de fin',
          autoRenew: 'Renouvellement auto',
        },
        status: {
          active: 'Actif',
          cancelled: 'Résilié',
          expired: 'Terminé',
          paused: 'En pause',
          past_due: 'Paiement en attente',
        },
        emptyState: {
          title: 'Aucun abonné',
          description: 'Les abonnés apparaîtront ici une fois que les utilisateurs auront souscrit à ce plan.',
        },
      },
      danger: {
        title: 'Zone dangereuse',
        description: 'Actions irréversibles et destructrices',
        deleteTitle: 'Supprimer ce plan',
        deleteDescription: 'Le plan cesse d\'être vendu et disparaît de la page des tarifs. Aucun abonnement en cours n\'est annulé.',
        deleteButton: 'Supprimer le plan',
      },
    },
  },
  coupons: {
    title: 'Codes promo',
    subtitle: 'Les réductions que vos acheteurs saisissent au paiement, et ce que chacune a rapporté.',
    conflict: 'Ce coupon a été enregistré ailleurs pendant votre saisie : rien n\'a été écrit. Rechargez, puis renvoyez vos modifications.',
    deleteError: 'Le coupon n\'a pas pu être supprimé.',
    tabs: {
      subscriptions: 'Abonnements',
      coupons: 'Coupons',
    },
    searchPlaceholder: 'Rechercher des coupons...',
    btnCreate: 'Créer un coupon',
    filterStatus: 'Statut',
    filterAll: 'Tous',
    filterActive: 'Actif',
    filterInactive: 'Inactif',
    table: {
      code: 'Code',
      discount: 'Réduction',
      usage: 'Utilisation',
      expiration: 'Expiration',
      status: 'Statut',
    },
    status: {
      active: 'Actif',
      scheduled: 'Programmé',
      inactive: 'Inactif',
      expired: 'Expiré',
      exhausted: 'Limite atteinte',
    },
    emptyState: {
      title: 'Aucun code promo',
      description: 'Créez votre premier code promo pour offrir des réductions à vos utilisateurs.',
      noResults: 'Aucun coupon trouvé',
      noResultsDescription: 'Essayez d\'ajuster vos filtres ou vos termes de recherche.',
    },
    deleteTitle: 'Supprimer le coupon',
    deleteMessage: 'Êtes-vous sûr de vouloir supprimer « {code} » ? Cette action est irréversible.',
    deleteSuccess: 'Coupon supprimé avec succès',
    unlimited: 'Illimité',
    noExpiration: 'Sans expiration',
    detail: {
      newCoupon: 'Nouveau coupon',
      createSuccess: 'Coupon créé',
      codeTaken: 'Ce code est déjà utilisé par un autre code promo de cette chaîne.',
      updateSuccess: 'Coupon mis à jour',
      saveError: 'L\'enregistrement du coupon a échoué',
      backToCoupons: 'Retour aux coupons',
      saveFirst: 'Enregistrez le coupon pour activer cet onglet',
      tabs: {
        information: 'Informations',
        usage: 'Utilisation',
      },
      information: {
        basicTitle: 'Informations de base',
        basicDescription: 'Code et description.',
        code: 'Code du coupon',
        codePlaceholder: 'ex. ETE2024',
        codeRequired: 'Le code du coupon est requis',
        codeHint: 'Lettres majuscules, chiffres et tirets uniquement. Le code, la réduction et la date de début ne changent plus une fois le coupon créé.',
        codeInvalid: 'Le code ne contient que des lettres, des chiffres et des tirets',
        percentInvalid: 'Un pourcentage est compris entre 1 et 100',
        endBeforeStart: 'La date de fin est antérieure à la date de début',
        generateCode: 'Générer',
        name: 'Nom',
        namePlaceholder: 'ex. Soldes d\'été',
        nameRequired: 'Le nom est requis',
        description: 'Description',
        descriptionPlaceholder: 'Décrivez ce code promo...',
        discountTitle: 'Réduction',
        discountDescription: 'Définissez le type et la valeur de la réduction.',
        discountType: 'Type de réduction',
        percentage: 'Pourcentage',
        fixedAmount: 'Montant fixe',
        discountValue: 'Valeur de la réduction',
        discountValuePlaceholder: '0',
        discountValueRequired: 'La valeur de la réduction est requise',
        currency: 'Devise',
        maxDiscountAmount: 'Montant maximum de réduction',
        maxDiscountAmountPlaceholder: 'Pas de limite',
        maxDiscountAmountHint: 'Plafonner la réduction pour les coupons en pourcentage',
        limitsTitle: 'Limites d\'utilisation',
        limitsDescription: 'Contrôlez le nombre d\'utilisations de ce coupon.',
        hasMaxUses: 'Limiter le nombre total d\'utilisations',
        maxUses: 'Nombre maximum d\'utilisations',
        maxUsesPlaceholder: 'Illimité',
        maxUsesPerUser: 'Utilisations max par utilisateur',
        maxUsesPerUserPlaceholder: '1',
        validityTitle: 'Période de validité',
        validityDescription: 'Définissez quand ce coupon est valide.',
        startDate: 'Date de début',
        hasEndDate: 'Définir une date de fin',
        endDate: 'Date de fin',
        minimumAmount: 'Montant minimum d\'achat',
        minimumAmountPlaceholder: 'Pas de minimum',
        publicationTitle: 'Publication',
        publicationDescription: 'Contrôlez la disponibilité de ce coupon.',
        isActive: 'Actif',
        isActiveHint: 'Ce coupon peut être utilisé par les clients',
      },
      usage: {
        title: 'Statistiques d\'utilisation',
        description: 'Suivez l\'utilisation de ce coupon.',
        stats: {
          totalUses: 'Utilisations totales',
          uniqueUsers: 'Utilisateurs uniques',
          totalDiscount: 'Réduction totale accordée',
          revenue: 'Ventes encaissées',
          remainingUses: 'Utilisations restantes',
          daysUntilExpiry: 'Jours avant expiration',
        },
        unlimited: 'Illimité',
        noExpiration: 'Sans expiration',
        table: {
          user: 'Utilisateur',
          usedAt: 'Utilisé le',
          item: 'Achat',
          paid: 'Payé TTC',
          discountAmount: 'Réduction',
        },
        refunded: 'Remboursée',
        emptyState: {
          title: 'Aucune utilisation',
          description: 'Les données d\'utilisation apparaîtront ici une fois que les clients utiliseront ce coupon.',
        },
      },
      danger: {
        title: 'Zone dangereuse',
        deleteTitle: 'Supprimer ce coupon',
        deleteDescription: 'Une fois supprimé, ce coupon ne sera plus utilisable.',
        deleteButton: 'Supprimer le coupon',
      },
    },
  },
  categoryTreeSelect: {
    search: 'Rechercher des catégories...',
    noResults: 'Aucune catégorie trouvée',
    nSelected: '{count} catégories sélectionnées',
    currentCategory: '(catégorie courante)',
    resultCount: '{count} résultat | {count} résultats',
    clearSearch: 'Effacer la recherche',
  },
  salesSubscriptions: {
    title: 'Abonnements actifs',
    subtitle: 'Tous les abonnements actifs de l\'ensemble des plans.',
    searchPlaceholder: 'Rechercher par email...',
    filterStatus: 'Statut',
    filterPlan: 'Plan',
    filterAll: 'Tous',
    table: {
      user: 'Utilisateur',
      plan: 'Plan',
      status: 'Statut',
      startDate: 'Date de début',
      endDate: 'Date de fin',
      autoRenew: 'Renouvellement auto',
      daysRemaining: 'Jours restants',
    },
    status: {
      active: 'Actif',
      cancelled: 'Résilié',
      expired: 'Terminé',
      paused: 'En pause',
      past_due: 'Paiement en attente',
    },
    emptyState: {
      title: 'Aucun abonnement',
      description: 'Les abonnements actifs apparaîtront ici une fois que les utilisateurs s\'abonneront à vos plans.',
      noResults: 'Aucun abonnement trouvé',
      noResultsDescription: 'Essayez d\'ajuster vos filtres ou vos termes de recherche.',
    },
    cancelSuccess: 'Abonnement résilié.',
    cancelError: 'L\'abonnement n\'a pas pu être résilié.',
    leaving: 'Se termine à la fin de la période',
    drawer: {
      plan: 'Formule',
      startDate: 'Date de début',
      endDate: 'Date de fin',
      daysRemaining: 'Jours restants',
      autoRenew: 'Renouvellement auto',
      complimentary: 'Offert',
      cancel: 'Résilier l\'abonnement',
      manageUser: 'Gérer l\'abonné',
      cancelRequested: 'Résiliation demandée le',
    },
  },
  sales: {
    revenue: {
      subtitle: 'Exports de vos ventes et factures mensuelles de vos frais {platform}.',
      currentMonth: 'Mois en cours',
      inProgress: 'en cours',
      salesCount: 'Ventes',
      downloadError: 'Le document n\'a pas pu être téléchargé.',
      month: 'Mois',
      grossTTC: 'Ventes TTC',
      ht: 'dont HT',
      vat: 'dont TVA',
      fees: 'Commission prélevée (TTC)',
      refunds: 'Remboursements',
      commissionReturned: 'dont {amount} de commission restituée',
      processingFees: 'dont {fees} de frais de paiement · facture {invoiced}',
      net: 'Net',
      documents: 'Documents',
      salesExport: 'Ventes',
      feeInvoice: 'Facture frais',
      feeCreditNote: 'Avoir',
      annual: {
        title: 'Récapitulatifs annuels',
        subtitle: 'Le récapitulatif de vos transactions de l\'année, toutes chaînes confondues. Il vous est envoyé par e-mail en janvier.',
        operations: '{count} opérations',
        gross: 'brut',
        download: 'Récapitulatif',
      },
      empty: {
        title: 'Aucun relevé pour le moment',
        description: 'Vos relevés mensuels apparaîtront ici à la clôture de chaque mois.',
      },
    },
    overview: {
      title: 'Vue d\'ensemble',
      subtitle: 'Suivez vos revenus d\'abonnements et à l\'acte en un coup d\'œil.',
      vsPrevious: 'vs période précédente',
      kpi: {
        revenue: 'Chiffre d\'affaires TTC',
        revenueDesc: 'Total encaissé sur la période, taxes et contributions de soutien incluses',
        subscriptionRevenue: 'Revenus d\'abonnements',
        subscriptionRevenueDesc: 'Revenus récurrents des abonnements actifs',
        oneTimeRevenue: 'Revenus à l\'acte',
        oneTimeRevenueDesc: 'Revenus des achats et locations à l\'acte',
        activeSubscribers: 'Abonnés actifs',
        activeSubscribersDesc: 'Nombre d\'abonnés ayant un abonnement actif',
        sales: 'Ventes à l\'acte',
        salesDesc: 'Nombre d\'achats à l\'acte sur la période',
        avgSale: 'Vente moyenne',
        avgSaleDesc: 'Montant moyen par vente à l\'acte',
      },
      trend: {
        title: 'Évolution des revenus',
        subtitle: 'Abonnements vs à l\'acte sur la période',
        subscriptions: 'Abonnements',
        oneTime: 'À l\'acte',
      },
      breakdown: {
        title: 'Répartition des revenus',
        subtitle: 'Hors taxes : le total est donc inférieur aux revenus encaissés',
      },
      topContent: {
        title: 'Contenus les plus vendus',
        subtitle: 'Montants hors taxes',
      },
      topPlans: {
        title: 'Formules populaires',
        subtitle: 'Montants hors taxes',
      },
      topCustomers: {
        title: 'Meilleurs clients',
        subtitle: 'Dépensé sur la période, TTC, remboursements déduits',
        count: 'Clients',
        revenue: 'Chiffre d\'affaires clients',
        average: 'Panier moyen par client',
        unattributed: 'Non attribué',
        unattributedHint: 'Payé par des membres supprimés depuis',
        empty: 'Aucun client sur la période.',
      },
      recent: {
        title: 'Dernières ventes',
        empty: 'Aucune vente',
      },
      streams: {
        subscription: 'Abonnement',
        purchase: 'Achat',
        rental: 'Location',
        contribution: 'Contribution de soutien',
      },
    },

    transactions: {
      title: 'Transactions',
      subtitle: 'Tous les paiements — achats, locations et échéances d\'abonnement.',
      searchPlaceholder: 'Rechercher par email...',
      filterStatus: 'Statut',
      filterType: 'Type',
      table: {
        id: 'ID',
        customer: 'Client',
        item: 'Contenu',
        type: 'Type',
        amount: 'Montant',
        status: 'Statut',
        date: 'Date',
        actions: 'Actions',
      },
      refund: 'Rembourser…',
      alreadyRefunded: 'Déjà remboursée.',
      refundedAmount: '{amount} remboursés',
      refundBlocker: {
        fully_refunded: 'Déjà remboursée.',
        refund_pending: 'Un remboursement est en cours sur cette vente : attendez sa confirmation.',
        disputed: 'Vente contestée : pendant le litige, contactez le support.',
        imported: 'Vente antérieure au remboursement dans l\'application — contactez le support.',
        contribution: 'Contribution de soutien : elle ne se rembourse pas ici — contactez le support.',
      },
      notRefundable: 'Vente antérieure au remboursement dans l\'application — contactez le support.',
      refundModal: {
        title: 'Rembourser cette vente',
        warning: 'Un remboursement total retire à l\'acheteur l\'accès à cet achat ou à cette location, un remboursement partiel non. Aucun ne résilie un abonnement. Un remboursement est définitif.',
        customer: 'Client',
        content: 'Contenu',
        paid: 'Payé',
        amount: 'Montant à rembourser (TTC)',
        amountHint: 'Indiquez un montant inférieur pour un remboursement partiel.',
        amountRequired: 'Indiquez un montant à rembourser.',
        amountTooHigh: 'Supérieur à ce qu\'il reste à rembourser sur cette vente.',
        reason: 'Motif (facultatif)',
        commissionNote: 'Le montant remboursé est prélevé sur le solde de votre compte de paiement et rendu à l\'acheteur. La commission {platform} perçue sur cette vente n\'est pas restituée, y compris sur un remboursement total.',
        confirm: 'Rembourser',
        success: 'Vente remboursée.',
        requested: 'Remboursement demandé : il apparaîtra comme effectué dès que notre partenaire de paiement l\'aura confirmé.',
        error: 'Le remboursement n\'a pas pu aboutir.',
      },
      type: {
        purchase: 'Achat',
        rental: 'Location',
        subscription: 'Abonnement',
        contribution: 'Contribution de soutien',
      },
      status: {
        paid: 'Payée',
        partially_refunded: 'Remboursée en partie',
        disputed: 'Contestée',
        charged_back: 'Litige perdu',
        active: 'Terminée',
        expired: 'Expirée',
        refunded: 'Remboursée',
        cancelled: 'Annulée',
      },
      emptyState: {
        title: 'Aucune transaction',
        description: 'Les transactions apparaîtront ici une fois les paiements traités.',
        noResults: 'Aucune transaction trouvée',
        noResultsDescription: 'Essayez de modifier vos filtres ou votre recherche.',
      },
    },
  },
  monetization: {
    // Une période est un nombre et une unité, jamais un nombre de jours. Deux clés par unité
    // plutôt qu'une forme plurielle : le pluriel de vue-i18n n'est pas typé dans cet arbre.
    period: {
      day: 'jour',
      days: '{count} jours',
      week: 'semaine',
      weeks: '{count} semaines',
      month: 'mois',
      months: '{count} mois',
      year: 'an',
      years: '{count} ans',
    },
    // The unit on its own, for a select. The counted forms above read as a duration and would
    // show a count nobody picked.
    periodUnit: {
      day: 'Jours',
      week: 'Semaines',
      month: 'Mois',
      year: 'Ans',
    },
    status: {
      closed: {
        title: 'La vente n\'est pas encore ouverte',
        description: 'Ouvrez-la pour rendre vos contenus payants.',
        action: 'Ouvrir la vente',
      },
      review: {
        title: 'Votre demande est en cours d\'examen',
        description: 'Nous vous écrivons dès qu\'elle est traitée.',
      },
      rejected: {
        title: 'Votre demande a été refusée',
        description: 'Lisez le motif, corrigez, et renvoyez-la.',
        action: 'Voir le motif',
      },
      paymentsPending: {
        title: 'Connectez vos paiements',
        description: 'La vente est ouverte sur votre chaîne, mais personne ne peut encore payer : connectez votre compte de paiement pour recevoir vos premières ventes.',
        action: 'Configurer',
      },
      open: {
        title: 'La vente est ouverte',
        description: 'Marquez un contenu comme payant et fixez son prix.',
      },
    },
    currency: {
      placeholder: '0,00',
      hint: 'Saisissez le montant',
    },
    billingPeriod: {
      monthly: 'Mensuel',
      quarterly: 'Trimestriel',
      biannual: 'Semestriel',
      annual: 'Annuel',
      custom: 'Personnalisé',
      months: 'Mois',
      years: 'Années',
    },
    trial: {
      addTrial: 'Ajouter un essai gratuit',
      days: 'Jours d\'essai',
      hint: 'Nombre de jours d\'essai gratuit (1-365)',
    },
    price: {
      download: 'Téléchargement',
      exclTax: 'HT',
      inclTax: 'TTC',
      isDefault: 'Tarif mis en avant',
      makeDefault: 'Mettre ce tarif en avant',
      downloadHint: 'Ce que l\'acheteur peut emporter, en plus de la lecture en ligne.',
      downloadNone: 'Lecture seule',
      downloadRenditions: 'Versions encodées',
      downloadSource: 'Fichier d\'origine',
      downloadAll: 'Tout le contenu téléchargeable',
      title: 'Ajouter un prix',
      editTitle: 'Modifier le prix',
      name: 'Nom',
      namePlaceholder: 'ex. Standard, Premium...',
      price: 'Prix',
      priceExclVat: 'Prix HT',
      priceInclVat: 'Prix public TTC',
      breakdown: 'Soit {net} HT + {vat} de TVA ({rate}), estimée au taux français.',
      breakdownFranchise: 'Soit {net} HT : franchise en base de TVA, aucune TVA ajoutée.',
      breakdownRounded: 'L\'arrondi de la TVA fera payer {shown}.',
      grossHint: 'Ce que vous touchez, hors commission. Le visiteur paiera {gross} TTC ({rate}) ; un acheteur d\'un autre pays de l\'UE verra le taux de son pays.',
      priceRequired: 'Le prix est requis',
      priceMinimum: 'Le prix minimum est de {amount}',
      period: 'Période d\'accès',
      unlimited: 'Illimité',
      limited: 'Durée limitée',
      hours: 'Heures',
      days: 'Jours',
      months: 'Mois',
      years: 'Années',
      download: 'Téléchargement',
      allowDownload: 'Autoriser le téléchargement',
    },
    subscriptions: {
      freeAccessModal: {
        title: 'Accorder un accès gratuit',
        description: 'Accorder un accès gratuit à ce plan d\'abonnement.',
        user: 'Email de l\'utilisateur',
        userPlaceholder: "utilisateur{'@'}example.com",
        duration: 'Durée (jours)',
        durationHint: 'Laisser 0 pour un accès illimité',
        emailInvalid: 'Email valide requis',
        grant: 'Accorder l\'accès',
      },
      cancelModal: {
        title: 'Annuler l\'abonnement',
        warning: 'Cette action annulera l\'abonnement. L\'utilisateur perdra l\'accès à la fin de sa période de facturation en cours.',
        user: 'Utilisateur',
        endDate: 'Date de fin actuelle',
        confirm: 'Annuler l\'abonnement',
      },
      extendModal: {
        title: 'Prolonger l\'abonnement',
        description: 'Prolonger la date de fin de cet abonnement.',
        user: 'Utilisateur',
        currentEndDate: 'Date de fin actuelle',
        newEndDate: 'Nouvelle date de fin',
        daysAdded: '+ {days} jours',
        confirm: 'Prolonger',
      },
    },
  },
  access: {
    revokeTitle: 'Révoquer l\'accès',
    revokeConfirm: 'Révoquer l\'accès',
    levels: {
      public: 'Public',
      authenticated: 'Connexion requise',
      restricted: 'Restreint',
      paid: 'Payant',
      accessRequest: 'Sur demande',
    },
    alsoViaGroup: 'Aussi accessible via le groupe « {name} »',
  },
  grantAccessModal: {
    title: 'Accorder l\'accès aux contenus',
    titleTarget: 'Accorder l\'accès — {name}',
    tabItems: 'Par contenus',
    tabContent: 'Par contenus',
    tabCategory: 'Par catégorie',
    tabCategoryLabel: 'Par catégorie',
    categoryInfo: 'Sélectionnez une catégorie pour accorder l\'accès à tous ses contenus à accès contrôlé en une fois.',
    selectedSummary: '{items} et {count} autre(s)',
    restrictedHintUser: 'Les contenus à accès contrôlé (restreint, payant ou sur demande) sont affichés ci-dessous. Sélectionnez ceux auxquels cet utilisateur doit avoir accès.',
    restrictedHintGroup: 'Les contenus à accès contrôlé (restreint, payant ou sur demande) que ce groupe ne peut pas encore consulter sont affichés ci-dessous.',
    searchPlaceholder: 'Rechercher un contenu...',
    categoryFilter: 'Catégorie',
    categoryHint: 'Accorder l\'accès à tous les contenus à accès contrôlé de la catégorie sélectionnée.',
    grantCategory: 'Accorder la catégorie',
    columnTitle: 'Titre',
    columnAccess: 'Accès',
    columnStatus: 'Statut',
    restricted: 'Restreint',
    published: 'Publié',
    unpublished: 'Non publié',
    noItems: 'Aucun contenu à accès contrôlé trouvé',
    selectedCount: '{count} contenu(s) sélectionné(s)',
    grantItems: 'Accorder {count} contenu(s)',
    processing: 'Accord en cours... {completed}/{total}',
    grantSuccess: '{count} accès accordé(s) avec succès',
    grantPartial: '{completed} accordé(s), {failed} échoué(s)',
    grantError: 'Échec de l\'accord de l\'accès',
    grantCategorySuccess: 'Accès à la catégorie accordé avec succès',
  },
  campaigns: {
    title: 'Campagnes',
    subtitle: 'Créez et envoyez des emails personnalisés à vos utilisateurs.',
    btnCreate: 'Nouvelle campagne',
    searchPlaceholder: 'Rechercher des campagnes...',
    filterByStatus: 'Filtrer par statut',
    filterByType: 'Filtrer par type',
    tabs: {
      campaigns: 'Campagnes',
      audiences: 'Audiences',
      suppressions: 'Liste de non-envoi',
    },
    status: {
      draft: 'Brouillon',
      scheduled: 'Programmée',
      sending: 'En cours d\'envoi',
      sent: 'Envoyée',
      paused: 'En pause',
      cancelled: 'Annulée',
      partially_failed: 'Échec partiel',
      failed: 'Échouée',
      pending: 'En attente',
    },
    type: {
      one_shot: 'Ponctuelle',
      recurring: 'Récurrente',
    },
    table: {
      name: 'Nom',
      status: 'Statut',
      type: 'Type',
      recipients: 'Destinataires',
      lastSent: 'Dernier envoi',
      nextSend: 'Prochain envoi',
      sendCount: '{count} envoi | {count} envois',
    },
    emptyState: {
      title: 'Aucune campagne',
      description: 'Créez votre première campagne email pour engager votre audience.',
      noResults: 'Aucune campagne trouvée',
      noResultsDescription: 'Essayez d\'ajuster votre recherche ou vos filtres.',
    },
    actions: {
      duplicate: 'Dupliquer',
      delete: 'Supprimer',
    },
    deleteTitle: 'Supprimer la campagne',
    deleteMessage: 'Êtes-vous sûr de vouloir supprimer « {name} » ? Cette action est irréversible.',
    deleteSuccess: 'Campagne supprimée',
    deleteError: 'La campagne n\'a pas pu être supprimée.',
    duplicateSuccess: 'Campagne dupliquée : c\'est un nouveau brouillon.',
    copyName: 'Copie de {name}',
    conflict: 'Cette campagne a changé depuis que vous l\'avez ouverte : elle a été rechargée, vos modifications sont conservées.',
    actionError: 'L\'action n\'a pas abouti.',
    detail: {
      newCampaign: 'Nouvelle campagne',
      saveFirst: 'Enregistrez la campagne d\'abord',
      createSuccess: 'Campagne créée',
      updateSuccess: 'Campagne enregistrée',
      saveError: 'La campagne n\'a pas pu être enregistrée.',
      sentReadOnly: 'Cette campagne est partie : son message, ses destinataires et sa date appartiennent à l\'historique. Dupliquez-la pour en envoyer une autre.',
      cancelledReadOnly: 'Cette campagne est annulée : elle ne partira plus jamais, et ses envois passés restent dans l\'historique. Dupliquez-la pour repartir de son contenu.',
      testSuccess: 'Test envoyé à {to}',
      verbSuccess: {
        schedule: 'Campagne programmée',
        pause: 'Campagne mise en pause',
        resume: 'Campagne reprise',
        cancel: 'Campagne annulée',
      },
      tabs: {
        content: 'Contenu',
        targeting: 'Ciblage',
        schedule: 'Planification',
        history: 'Historique',
      },
      content: {
        sectionTitle: 'Contenu de l\'email',
        campaignTitle: 'Campagne',
        name: 'Nom de la campagne',
        namePlaceholder: 'ex. Newsletter de printemps',
        nameHint: 'Visible par vous seul ; laissé vide, c\'est l\'objet qui la nomme.',
        nameRequired: 'Donnez un nom ou un objet à la campagne.',
        description: 'Note interne',
        replyToInvalid: 'L\'email de réponse n\'est pas une adresse valide.',
        contentRequired: 'Une campagne programmée ou envoyée garde un objet et un corps.',
        subject: 'Objet',
        subjectPlaceholder: 'Saisissez l\'objet de l\'email...',
        fromName: 'Nom de l\'expéditeur',
        fromNamePlaceholder: 'ex. L\'équipe MonSite',
        replyTo: 'Email de réponse',
        replyToPlaceholder: "ex. contact{'@'}example.com",
        fromAddress: "Vos envois partent de l'adresse {address}, définie par l'équipe Videas.",
        customLayout:
          "Vos campagnes portent une mise en page mise en place par l'équipe Videas : l'aperçu est indicatif, faites un envoi de test pour voir le rendu exact.",
        body: 'Corps de l\'email',
        bodyPlaceholder: 'Rédigez le contenu de votre email...',
        contentMode: 'Type de contenu',
        contentModes: {
          manual: 'Contenu personnalisé',
          latest_items: 'Derniers contenus publiés',
        },
        manualItems: 'Contenus sélectionnés',
        manualItemsDescription: 'Choisissez les contenus à mettre en avant dans cette campagne.',
        addItems: 'Ajouter des contenus',
        noItemsSelected: 'Aucun contenu sélectionné',
        noItemsSelectedDescription: 'Cliquez sur « Ajouter des contenus » pour choisir le contenu à inclure dans cet email.',
        searchItems: 'Rechercher des contenus...',
        addSelected: 'Ajouter la sélection ({count})',
        noResults: 'Aucun contenu trouvé',
        noItems: 'Aucun contenu disponible',
        itemsCount: 'Nombre de contenus à inclure',
        itemsCategory: 'Filtrer par catégorie',
        itemsCategoryAll: 'Toutes les catégories',
      },
      targeting: {
        sectionTitle: 'Destinataires',
        description: 'Choisissez qui recevra cette campagne. Les destinataires de toutes les sources ci-dessous sont combinés, puis les exclusions sont appliquées.',
        audiences: 'Audiences',
        audiencesPlaceholder: 'Sélectionner des audiences...',
        groups: 'Groupes',
        groupsPlaceholder: 'Sélectionner des groupes...',
        users: 'Utilisateurs individuels',
        usersPlaceholder: 'Rechercher et sélectionner des utilisateurs...',
        excludeUsers: 'Exclusions',
        excludeUsersPlaceholder: 'Rechercher des utilisateurs à exclure...',
        recipientPreview: 'Destinataires',
        memberCount: '{count} membre | {count} membres',
        inAndOut: 'Un membre ne peut pas être à la fois inclus et exclu.',
        unsubscribeNote: 'Un membre désinscrit de la newsletter ne reçoit aucune campagne, quel que soit le ciblage, et une adresse sur la liste de non-envoi non plus.',
        excluded: {
          by_name: '{count} exclu nommément | {count} exclus nommément',
          unsubscribed: '{count} désinscrit de la newsletter | {count} désinscrits de la newsletter',
          suppressed: '{count} adresse sur la liste de non-envoi | {count} adresses sur la liste de non-envoi',
          closed: '{count} accès suspendu, expiré ou en attente | {count} accès suspendus, expirés ou en attente',
        },
      },
      schedule: {
        sectionTitle: 'Planification',
        type: 'Type d\'envoi',
        types: {
          one_shot: 'Envoi ponctuel',
          recurring: 'Récurrent',
        },
        typeDescriptions: {
          one_shot: 'Envoyer cette campagne une seule fois, maintenant ou à une date précise.',
          recurring: 'Envoyer automatiquement selon un calendrier récurrent.',
        },
        scheduledAt: 'Date d\'envoi',
        scheduledAtHint: 'Laissez vide pour envoyer manuellement.',
        recurrence: 'Fréquence',
        recurrences: {
          daily: 'Tous les jours',
          weekly: 'Toutes les semaines',
          biweekly: 'Toutes les 2 semaines',
          monthly: 'Tous les mois',
        },
        recurrenceDay: 'Jour de la semaine',
        days: {
          monday: 'Lundi',
          tuesday: 'Mardi',
          wednesday: 'Mercredi',
          thursday: 'Jeudi',
          friday: 'Vendredi',
          saturday: 'Samedi',
          sunday: 'Dimanche',
        },
        recurrenceTime: 'Heure',
        recurrenceTimezone: 'Fuseau horaire',
        nextSend: 'Prochain envoi : {date}',
        pausedNote: 'En pause : rien ne part tant que la campagne n\'est pas reprise.',
      },
      history: {
        sectionTitle: 'Historique des envois',
        emptyTitle: 'Aucun envoi',
        emptyDescription: 'Cette campagne n\'a pas encore été envoyée.',
        table: {
          date: 'Date',
          status: 'Statut',
          recipients: 'Destinataires',
          sent: 'Envoyés',
          failed: 'Échoués',
          delivered: 'Délivrés',
          pending: 'En attente',
          unsubscribed: 'Désinscriptions',
          excluded: 'Écartés',
        },
        excluded: {
          by_name: '{count} exclu nommément | {count} exclus nommément',
          closed: '{count} accès suspendu, expiré ou en attente | {count} accès suspendus, expirés ou en attente',
          unsubscribed: '{count} désinscrit de la newsletter | {count} désinscrits de la newsletter',
          suppressed: '{count} adresse sur la liste de non-envoi | {count} adresses sur la liste de non-envoi',
        },
      },
      actions: {
        send: 'Envoyer maintenant',
        schedule: 'Programmer',
        previewAndTest: 'Aperçu & test',
        duplicate: 'Dupliquer',
        pause: 'Mettre en pause',
        resume: 'Reprendre',
        cancel: 'Annuler la campagne',
        scheduleBlocked: {
          content: 'Ajoutez un objet et un corps avant de programmer.',
          date: 'Choisissez une date d\'envoi dans l\'onglet Planification.',
          past: 'La date d\'envoi est passée : choisissez-en une nouvelle.',
          recurrence: 'Complétez la récurrence dans l\'onglet Planification.',
        },
      },
      cancelDialog: {
        title: 'Annuler la campagne ?',
        message: '« {name} » ne partira plus jamais : ni à sa date, ni par un envoi manuel. Ses envois passés restent dans l\'historique. Pour l\'arrêter seulement un temps, mettez-la plutôt en pause.',
        confirm: 'Annuler définitivement',
      },
      sendDialog: {
        title: 'Envoyer la campagne',
        subject: 'Objet',
        sender: 'Expéditeur',
        recipients: 'Destinataires',
        recipientsSuffix: 'destinataire | destinataires',
        content: 'Contenu',
        contentManual: '{count} contenu sélectionné | {count} contenus sélectionnés',
        contentLatest: '{count} dernier contenu | {count} derniers contenus',
        noRecipients: 'Cette campagne n\'a aucun destinataire. Configurez le ciblage pour ajouter des destinataires avant d\'envoyer.',
        warning: 'Cette action enverra l\'email à tous les destinataires immédiatement. Cette action est irréversible.',
        confirm: 'Envoyer à {count} destinataire | Envoyer à {count} destinataires',
        sendSuccess: 'Campagne envoyée avec succès',
        dropped: '{count} membre ciblé ne sera pas écrit : désinscrit, adresse bloquée ou accès fermé. | {count} membres ciblés ne seront pas écrits : désinscrits, adresses bloquées ou accès fermés.',
      },
      danger: {
        title: 'Zone dangereuse',
        deleteTitle: 'Supprimer cette campagne',
        deleteDescription: 'Supprimer définitivement cette campagne et tout son historique.',
        deleteButton: 'Supprimer la campagne',
      },
    },
    preview: {
      title: 'Aperçu de l\'email',
      from: 'De :',
      replyTo: 'Répondre à :',
      subject: 'Objet :',
      noFromName: 'Aucun nom d\'expéditeur',
      noSubject: 'Aucun objet',
      noBody: 'Aucun contenu pour le moment.',
      featuredItems: 'Contenus mis en avant',
      latestItems: '{count} derniers contenus',
      latestItemsAuto: 'Les contenus seront automatiquement sélectionnés au moment de l\'envoi.',
      watchNow: 'Regarder',
      itemPlaceholder: 'Contenu {n}',
      footerAuto: 'Cet e-mail a été envoyé automatiquement par {name}.',
      unsubscribe: 'Se désinscrire',
      sendTest: 'Envoyer un test',
      testEmailPlaceholder: "test{'@'}example.com",
    },
    suppressions: {
      title: 'Liste de non-envoi',
      subtitle: 'Les adresses auxquelles aucune campagne de votre organisation n\'est envoyée, sur toutes ses chaînes.',
      btnAdd: 'Ajouter une adresse',
      searchPlaceholder: 'Rechercher une adresse...',
      allReasons: 'Toutes les raisons',
      reason: {
        unsubscribed: 'Désinscription',
        bounced: 'Adresse en échec',
        operator: 'Ajout manuel',
      },
      table: {
        email: 'Adresse',
        reason: 'Raison',
        since: 'Depuis le',
      },
      emptyState: {
        title: 'Aucune adresse exclue',
        noResults: 'Aucune adresse trouvée',
        description: 'Une adresse arrive ici quand son propriétaire se désinscrit depuis un e-mail, quand le serveur de messagerie la refuse définitivement, ou quand vous l\'ajoutez.',
      },
      lift: 'Réautoriser',
      ownerOnly: 'Le propriétaire de cette adresse s\'est désinscrit : lui seul peut la réautoriser, en réactivant la newsletter depuis son compte sur la chaîne.',
      addDialog: {
        title: 'Ne plus écrire à une adresse',
        description: 'Aucune campagne d\'aucune chaîne de votre organisation ne lui sera envoyée. Les e-mails de compte (mot de passe, reçus) ne sont pas concernés.',
        email: 'Adresse e-mail',
        note: 'Note (facultative)',
        confirm: 'Ajouter',
      },
      liftDialog: {
        title: 'Réautoriser l\'adresse ?',
        message: '{email} recevra de nouveau les campagnes de votre organisation qui la ciblent.',
      },
      addSuccess: '{email} est sur la liste de non-envoi',
      addError: 'L\'adresse n\'a pas pu être ajoutée.',
      liftSuccess: '{email} peut de nouveau recevoir vos campagnes',
      liftError: 'L\'adresse n\'a pas pu être réautorisée.',
    },
    audiences: {
      title: 'Audiences',
      subtitle: 'Gérez vos audiences et listes de diffusion.',
      btnCreate: 'Nouvelle audience',
      searchPlaceholder: 'Rechercher des audiences...',
      // Clés calquées sur `system_key` du backend : les audiences système sont
      // créées avec un nom anglais écrit en base, on les réaffiche traduites.
      system: {
        all_users: {
          name: 'Tous les utilisateurs',
          description: 'Tous les utilisateurs actifs du site',
        },
        newsletter: {
          name: 'Abonnés newsletter',
          description: 'Les utilisateurs qui ont accepté de recevoir la newsletter',
        },
        active_subscribers: {
          name: 'Abonnés actifs',
          description: 'Les utilisateurs ayant un abonnement en cours',
        },
        free_users: {
          name: 'Utilisateurs gratuits',
          description: 'Les utilisateurs sans abonnement en cours',
        },
      },
      table: {
        name: 'Nom',
        type: 'Type',
        members: 'Membres',
        createdAt: 'Créée le',
        updatedAt: 'Modifiée le',
      },
      type: {
        static: 'Statique',
        dynamic: 'Dynamique',
        combined: 'Mixte',
      },
      typeDescription: {
        static: 'Gérer les membres manuellement.',
        dynamic: 'Automatiquement selon des règles.',
        combined: 'Une liste à la main, plus les règles.',
      },
      systemBadge: 'Système',
      emptyState: {
        title: 'Aucune audience',
        description: 'Créez des audiences pour cibler vos utilisateurs dans vos campagnes email.',
        noResults: 'Aucune audience trouvée',
        noResultsDescription: 'Essayez d\'ajuster votre recherche.',
      },
      presets: {
        sectionTitle: 'Audiences suggérées',
        dismiss: 'Masquer',
        engaged_users: {
          name: 'Utilisateurs engagés',
          description: 'Utilisateurs actifs ces 7 derniers jours.',
          suggestedDescription: 'Cible les utilisateurs actifs au cours des 7 derniers jours, idéal pour les campagnes de fidélisation et de nouveautés.',
        },
        premium_members: {
          name: 'Membres premium',
          description: 'Utilisateurs avec accès complet.',
          suggestedDescription: 'Cible les utilisateurs ayant un accès complet, idéal pour les campagnes de contenus exclusifs.',
        },
        non_newsletter: {
          name: 'Non-inscrits newsletter',
          description: 'Utilisateurs non inscrits à la newsletter.',
          suggestedDescription: 'Cible les utilisateurs qui ne sont pas encore inscrits à la newsletter, idéal pour les campagnes d\'incitation.',
        },
        engaged_subscribers: {
          name: 'Abonnés engagés',
          description: 'Abonnés actifs ces 7 derniers jours.',
          suggestedDescription: 'Cible les abonnés actifs récemment, idéal pour les campagnes d\'upsell et de rétention.',
        },
      },
      deleteTitle: 'Supprimer l\'audience',
      deleteMessage: 'Êtes-vous sûr de vouloir supprimer « {name} » ? Cette action est irréversible.',
      deleteSuccess: 'Audience supprimée',
      deleteError: 'L\'audience n\'a pas pu être supprimée.',
      conflict: 'Cette audience a changé depuis que vous l\'avez ouverte : elle a été rechargée, vos modifications sont conservées.',
      detail: {
        newAudience: 'Nouvelle audience',
        saveFirst: 'Enregistrez l\'audience d\'abord',
        createSuccess: 'Audience créée',
        updateSuccess: 'Audience enregistrée',
        saveError: 'L\'audience n\'a pas pu être enregistrée.',
        tabs: {
          information: 'Informations',
          members: 'Membres',
        },
        info: {
          sectionTitle: 'Informations de l\'audience',
          name: 'Nom',
          namePlaceholder: 'ex. Abonnés Premium',
          description: 'Description',
          descriptionPlaceholder: 'Décrivez cette audience...',
          type: 'Type',
          nameRequired: 'Donnez un nom à l\'audience.',
          systemReadOnly: 'Cette audience est fournie avec la chaîne : elle ne se renomme pas, ne se modifie pas et ne se supprime pas.',
        },
        rules: {
          sectionTitle: 'Règles',
          description: 'Un membre fait partie de l\'audience s\'il remplit toutes les règles « Inclure » et aucune règle « Exclure ».',
          subscriptionStatus: 'Statut d\'abonnement',
          groups: 'Groupes',
          newsletterOptIn: 'Inscrits à la newsletter uniquement',
          hasFullAccess: 'A un accès complet',
          joinedAfter: 'Inscrit après le',
          joinedBefore: 'Inscrit avant le',
          lastActiveWithinDays: 'Actif dans les (jours)',
          statusActive: 'Abonnement actif',
          statusNone: 'Sans abonnement actif',
          empty: 'Aucune règle pour l\'instant : ajoutez-en au moins une.',
          addRule: 'Ajouter une règle',
          removeRule: 'Retirer la règle',
          plans: 'Formules',
          plansAll: 'Toutes les formules',
          newsletterYes: 'Inscrit à la newsletter',
          newsletterNo: 'Désinscrit de la newsletter',
          fullAccessYes: 'A un accès complet',
          fullAccessNo: 'N\'a pas d\'accès complet',
          operators: {
            include: 'Inclure',
            exclude: 'Exclure',
          },
          kinds: {
            subscription_status: 'Abonnement',
            group_membership: 'Groupe',
            newsletter_consent: 'Newsletter',
            full_access: 'Accès complet',
            joined: 'Date d\'inscription',
            last_active: 'Dernière activité',
          },
          problems: {
            ruleRequired: 'Une audience dynamique ou mixte a au moins une règle, sinon elle viserait tout le monde.',
            groupRequired: 'Choisissez au moins un groupe.',
            dateRequired: 'Indiquez au moins une date.',
            dateOrder: 'La première date est après la seconde.',
            daysRequired: 'Indiquez un nombre de jours, au moins 1.',
          },
        },
        members: {
          sectionTitle: 'Membres',
          staticDescription: 'Ajoutez ou retirez des membres manuellement.',
          dynamicDescription: 'Les membres sont calculés automatiquement selon les règles.',
          combinedDescription: 'Les membres ajoutés à la main, plus ceux que les règles trouvent. Seuls les premiers se retirent ici.',
          filterPlaceholder: 'Filtrer les membres...',
          tableSource: 'Origine',
          byRule: 'Par règle',
          addedOn: 'Ajouté le {date}',
          unsubscribed: 'Désinscrit',
          unsubscribedHint: 'Ce membre s\'est désinscrit de la newsletter : aucune campagne ne lui sera envoyée.',
          added: '{count} membre ajouté | {count} membres ajoutés',
          changeError: 'La liste n\'a pas pu être modifiée.',
          count: '{count} membre | {count} membres',
          addMembers: 'Ajouter des membres',
          removeMember: 'Retirer',
          searchPlaceholder: 'Rechercher des utilisateurs...',
          emptyTitle: 'Aucun membre',
          tableUser: 'Utilisateur',
          tableJoined: 'Inscrit le',
        },
        danger: {
          title: 'Zone dangereuse',
          deleteTitle: 'Supprimer cette audience',
          deleteDescription: 'Supprimer définitivement cette audience.',
          deleteButton: 'Supprimer l\'audience',
        },
      },
    },
  },
  comments: {
    title: 'Commentaires',
    subtitle: 'Modérez et gérez les commentaires de votre audience.',
    searchPlaceholder: 'Rechercher par contenu ou email...',
    filterByStatus: 'Filtrer par statut',
    // Le filtre par contenu ou article de la liste, qu'aucun serveur ne sert encore.
    filterByTarget: 'Contenu ou article',
    targetKinds: {
      item: 'Contenu',
      article: 'Article',
    },
    reply: 'Réponse',
    adminBadge: 'Admin',
    replyForm: {
      label: 'Votre réponse',
      placeholder: 'Rédigez une réponse en tant qu\'admin...',
      asChannelHint: 'La réponse est publiée au nom de la chaîne, via votre propre adhésion — il vous en faut une sur cette chaîne.',
    },
    scrubbed: '(contenu effacé)',
    scrubbedAuthor: 'Auteur effacé',
    status: {
      pending: 'En attente',
      approved: 'Approuvé',
      rejected: 'Rejeté',
    },
    filters: {
      all: 'Tous',
      pending: 'En attente',
      approved: 'Approuvés',
      rejected: 'Rejetés',
    },
    stats: {
      shown: 'Affichés',
      total: 'Total',
      pending: 'En attente',
      approved: 'Approuvés',
      rejected: 'Rejetés',
    },
    table: {
      user: 'Utilisateur',
      comment: 'Commentaire',
      item: 'Contenu',
      status: 'Statut',
      date: 'Date',
    },
    actions: {
      approve: 'Approuver',
      reject: 'Rejeter',
      delete: 'Supprimer',
      reply: 'Répondre',
      sendReply: 'Envoyer la réponse',
    },
    quick: {
      approved: 'Commentaire approuvé',
      rejected: 'Commentaire rejeté',
      removed: 'Commentaire supprimé',
      rejectWithReason: 'Rejeter avec un motif',
      more: 'Autres actions sur le commentaire',
    },
    bulk: {
      selected: '{count} sélectionné(s)',
    },
    emptyState: {
      title: 'Aucun commentaire',
      description: 'Les commentaires de votre audience apparaîtront ici.',
      noResults: 'Aucun commentaire trouvé',
      noResultsDescription: 'Essayez d\'ajuster votre recherche ou vos filtres.',
      cleared: 'Tout est modéré',
      clearedDescription: 'Aucun commentaire n\'attend de décision.',
    },
    rejectModal: {
      title: 'Rejeter le commentaire',
      description: 'Veuillez fournir une raison pour le rejet de ce commentaire.',
      reasonLabel: 'Raison',
      reasonPlaceholder: 'Saisissez la raison du rejet...',
      reasonRequired: 'Une raison est requise pour le rejet',
    },
    deleteDialog: {
      title: 'Supprimer le commentaire',
      message: 'Ce commentaire sera définitivement supprimé. Cette action est irréversible.',
    },
    time: {
      justNow: 'À l\'instant',
      minutesAgo: 'Il y a {count} min',
      hoursAgo: 'Il y a {count}h',
      daysAgo: 'Il y a {count}j',
    },
    detail: {
      title: 'Détails du commentaire',
      user: 'Utilisateur',
      email: 'Email',
      item: 'Contenu',
      postedOn: 'Publié le',
      editedOn: 'Modifié le',
      likes: 'Mentions j\'aime',
      replies: 'Réponses',
      moderation: 'Modération',
      moderatedBy: 'Modéré par',
      moderatedOn: 'Modéré le',
      rejectionReason: 'Raison du rejet',
    },
    toast: {
      moderateSuccess: 'Commentaire modéré avec succès',
      moderateError: 'Échec de la modération du commentaire',
      deleteSuccess: 'Commentaire supprimé avec succès',
      deleteError: 'Échec de la suppression du commentaire',
      replySuccess: 'Réponse envoyée avec succès',
      replyError: 'Échec de l\'envoi de la réponse',
      replyNoMembership: 'Vous n\'avez pas d\'adhésion sur cette chaîne : une réponse est écrite au nom d\'un membre, pas d\'un opérateur.',
      bulkPartial: '{done} traité(s), {failed} en échec',
      bulkSuccess: '{count} commentaire(s) modéré(s) avec succès',
      bulkError: 'Échec de la modération des commentaires',
    },
  },
  giftSubscriptionModal: {
    title: 'Offrir un abonnement',
    description: 'Offrir un abonnement gratuit à {name}.',
    selectPlan: 'Plan d\'abonnement',
    selectPlanPlaceholder: 'Choisir un plan...',
    endDate: 'Date de fin',
    endDateHint: 'L\'abonnement expirera à cette date — par défaut, une période du plan. Videz le champ pour un abonnement sans fin.',
    autoRenewOff: 'Le renouvellement automatique est désactivé pour les abonnements offerts.',
    gift: 'Offrir l\'abonnement',
    giftSuccess: 'Abonnement offert avec succès',
    giftError: 'Échec de l\'offre d\'abonnement',
    alreadySubscribed: 'Déjà abonné',
    alreadyHasPlan: 'L\'utilisateur a déjà un abonnement actif pour ce plan',
  },
  blog: {
    title: 'Blog',
    subtitle: 'Créez et gérez les articles de blog de votre site.',
    btnCreate: 'Nouvel article',
    searchPlaceholder: 'Rechercher des articles...',
    filterByStatus: 'Filtrer par statut',
    featured: 'Mis en avant',
    status: {
      draft: 'Brouillon',
      published: 'Publié',
      scheduled: 'Programmé',
      archived: 'Archivé',
    },
    table: {
      title: 'Titre',
      status: 'Statut',
      date: 'Publié le',
      author: 'Auteur',
    },
    unknownAuthor: '—',
    emptyState: {
      title: 'Aucun article pour le moment',
      description: 'Créez votre premier article de blog pour engager votre audience.',
      noResults: 'Aucun article trouvé',
      noResultsDescription: 'Essayez de modifier vos filtres ou vos termes de recherche.',
    },
    deleteTitle: 'Supprimer l\'article',
    deleteMessage: 'Êtes-vous sûr de vouloir supprimer « {title} » ? Cette action est irréversible.',
    conflict: 'Quelqu\'un d\'autre a enregistré cet article depuis son ouverture, et rien n\'a été écrit. Il vient d\'être rechargé : vérifiez votre texte, puis enregistrez à nouveau.',
    validation: {
      titleRequired: 'Un article a besoin d\'un titre.',
      slugInvalid: 'L\'adresse est faite de mots en minuscules reliés par des tirets simples.',
      contentRequired: 'Un article a besoin d\'un contenu : un article vide est une page qui répond sans rien dire.',
    },
    danger: {
      title: 'Zone dangereuse',
      deleteTitle: 'Supprimer cet article',
      deleteDescription: 'Une fois supprimé, cet article sera définitivement supprimé.',
      deleteButton: 'Supprimer l\'article',
    },
    form: {
      newArticle: 'Nouvel article',
      titleSection: 'Titre',
      titlePlaceholder: 'Saisissez le titre de l\'article...',
      slug: 'Adresse',
      slugPlaceholder: 'derriere-le-decor',
      slugHint: 'L\'adresse de l\'article sur votre blog. Des mots en minuscules reliés par des tirets.',
      content: 'Contenu',
      contentPlaceholder: 'Rédigez votre article...',
      excerpt: 'Extrait',
      excerptPlaceholder: 'Un court résumé de l\'article...',
      options: 'Options',
      tags: 'Tags',
      tagsPlaceholder: 'Ajouter des tags...',
      tagsHint: 'Saisissez un tag, puis Entrée.',
      featured: 'Mis en avant',
      featuredHint: 'Mettre cet article en avant sur votre blog',
      allowsComments: 'Autoriser les commentaires',
      allowsCommentsHint: 'Les visiteurs peuvent commenter cet article sur votre blog',
      language: 'Langue',
      languageHint: 'La langue dans laquelle l\'article est écrit. Laissée vide, c\'est celle de la chaîne.',
      languages: {
        fr: 'Français',
        en: 'Anglais',
      },
      thumbnail: 'Image de couverture',
      thumbnailHint: 'Utilisée comme aperçu de l\'article et pour le partage social (recommandé 1200×630).',
      categories: 'Catégories',
      categoriesPlaceholder: 'Associer des catégories...',
      categoriesCreate: 'Créer la catégorie « {name} »',
      categoriesCreated: 'Catégorie créée',
      seo: 'Paramètres SEO',
      metaTitle: 'Meta titre',
      metaDescription: 'Meta description',
      metaDescriptionPlaceholder: 'Une brève description pour les moteurs de recherche...',
      saveDraft: 'Enregistrer le brouillon',
      publish: 'Publier',
      unpublish: 'Dépublier',
    },
    toast: {
      createSuccess: 'Article créé avec succès',
      updateSuccess: 'Article mis à jour avec succès',
      deleteSuccess: 'Article supprimé avec succès',
      publishSuccess: 'Article publié',
      publishError: 'Échec de la publication de l\'article',
      unpublishSuccess: 'Article dépublié',
      unpublishError: 'Échec de la dépublication de l\'article',
      error: 'Une erreur est survenue. Veuillez réessayer.',
      bodyImagesError: 'L\'article est enregistré, mais ses images n\'ont pas pu lui être rattachées.',
    },
  },
  accessRequests: {
    title: 'Demandes d\'accès',
    subtitle: 'Gérer les demandes d\'accès des utilisateurs au contenu restreint',
    itemCount: '{count} contenu | {count} contenus',
    stats: {
      shown: 'Affichées',
      total: 'Total',
      pending: 'En attente',
      approved: 'Approuvées',
      rejected: 'Refusées',
    },
    table: {
      user: 'Utilisateur',
      items: 'Contenus',
      message: 'Message',
      submittedAt: 'Soumise le',
      status: 'Statut',
    },
    status: {
      pending: 'En attente',
      approved: 'Approuvée',
      rejected: 'Refusée',
    },
    filters: {
      all: 'Tous les statuts',
      pending: 'En attente',
      approved: 'Approuvées',
      rejected: 'Refusées',
    },
    approve: 'Approuver',
    reject: 'Refuser',
    approved: 'Demande approuvée',
    rejected: 'Demande refusée',
    approveError: 'Échec de l\'approbation de la demande',
    rejectError: 'Échec du refus de la demande',
    approveDialog: {
      title: 'Approuver la demande',
      description: 'Les accès demandés seront accordés. Vous pouvez leur fixer une date de fin.',
      expiresAt: 'Accès jusqu\'au',
      expiresAtHint: 'Laissé vide, l\'accès n\'expire pas.',
    },
    rejectDialog: {
      title: 'Refuser la demande d\'accès',
      reason: 'Raison (visible par l\'utilisateur)',
      confirm: 'Refuser la demande',
    },
    detail: {
      message: 'Message',
      rejectionReason: 'Raison du refus',
      reviewedBy: 'Examinée par',
      requestedItems: '{count} contenu(s) demandé(s)',
      viewUser: 'Voir le profil utilisateur',
    },
    filterByStatus: 'Filtrer par statut',
    searchPlaceholder: 'Rechercher par nom ou email...',
    empty: 'Aucune demande d\'accès',
    quick: {
      approveUntil: 'Approuver avec une date de fin',
      rejectWithReason: 'Refuser avec une raison',
      more: 'Autres actions',
    },
    cleared: 'Aucune demande en attente',
    answer: {
      full: 'Déjà accessible',
      locked: 'Verrouillé',
      nothing: 'Invisible',
    },
  },
  grants: {
    neverExpires: 'Sans expiration',
    kind: {
      item: 'Contenu',
      category: 'Catégorie',
      page: 'Page',
    },
    table: {
      kind: 'Type',
      expires: 'Expiration',
    },
  },
  submissions: {
    title: 'Dépôts',
    subtitle: 'Les fichiers déposés par vos membres, et votre décision sur chacun.',
    tabs: {
      pending: 'En attente',
      pendingCount: 'En attente ({count})',
      approved: 'Acceptés',
      rejected: 'Refusés',
      interrupted: 'Interrompus',
      empty: {
        pending: 'Aucun dépôt en attente',
        approved: 'Aucun dépôt accepté',
        rejected: 'Aucun dépôt refusé',
        interrupted: 'Aucun envoi interrompu',
      },
    },
    approve: 'Accepter',
    reject: 'Refuser',
    approved: 'Dépôt accepté',
    rejected: 'Dépôt refusé',
    approveError: 'Échec de l\'acceptation du dépôt',
    rejectError: 'Échec du refus du dépôt',
    files: '{count} fichier | {count} fichier | {count} fichiers',
    selection: {
      all: 'Tout sélectionner',
      sending: 'Sélectionner « {title} »',
      unfold: 'Afficher les fichiers',
      bar: 'Sélection',
      count: '{count} sélectionné | {count} sélectionné | {count} sélectionnés',
      clear: 'Désélectionner',
      approve: 'Accepter la sélection',
      reject: 'Refuser la sélection',
      approved: '{count} dépôt accepté | {count} dépôt accepté | {count} dépôts acceptés',
      rejected: '{count} dépôt refusé | {count} dépôt refusé | {count} dépôts refusés',
      skipped: {
        decided:
          '{count} fichier laissé de côté : déjà décidé | {count} fichier laissé de côté : déjà décidé | {count} fichiers laissés de côté : déjà décidés',
        arriving:
          '{count} fichier laissé de côté : encore en cours d\'envoi | {count} fichier laissé de côté : encore en cours d\'envoi | {count} fichiers laissés de côté : encore en cours d\'envoi',
        unfinished:
          '{count} fichier laissé de côté : son envoi n\'est jamais arrivé à son terme | {count} fichier laissé de côté : son envoi n\'est jamais arrivé à son terme | {count} fichiers laissés de côté : leur envoi n\'est jamais arrivé à son terme',
        gone:
          '{count} fichier laissé de côté : il n\'est plus dans la boîte de dépôt | {count} fichier laissé de côté : il n\'est plus dans la boîte de dépôt | {count} fichiers laissés de côté : ils ne sont plus dans la boîte de dépôt',
      },
    },
    sending: {
      approve: 'Accepter tout l\'envoi',
      reject: 'Refuser tout l\'envoi',
    },
    quick: {
      approveElsewhere: 'Accepter ailleurs…',
      rejectWithReason: 'Refuser avec un motif',
      more: 'Autres actions',
    },
    status: {
      uploading: 'Envoi en cours',
      interrupted: 'Envoi interrompu',
      pending: 'En attente',
      approved: 'Accepté',
      rejected: 'Refusé',
    },
    inbox: {
      closed: 'La boîte de dépôt est fermée : aucun membre ne peut rien déposer.',
      suspended: 'L\'espace de travail qui reçoit les dépôts est à la corbeille : choisissez-en un autre dans les options de la chaîne.',
    },
    detail: {
      message: 'Message',
      rejectionReason: 'Raison du refus',
      asset: 'Média',
      openLibrary: 'Voir dans la médiathèque',
      uploading: 'Le fichier est encore en cours d\'envoi : il pourra être lu ici une fois arrivé.',
      neverFinished: 'L\'envoi n\'est jamais arrivé à son terme.',
      assetGone: 'Ce média n\'est plus dans la médiathèque.',
    },
    rejectDialog: {
      title: 'Refuser le dépôt',
      titleMany: 'Refuser {count} fichiers',
      reason: 'Raison (visible par le membre)',
    },
    acceptDialog: {
      title: 'Accepter le dépôt',
      titleMany: 'Accepter {count} fichiers',
      hint:
        'Il reste là où il est, sauf si vous le rangez ailleurs. | Il reste là où il est, sauf si vous le rangez ailleurs. | Ils restent là où ils sont, sauf si vous les rangez ailleurs.',
      elsewhere: 'Ranger ailleurs (facultatif)',
      folder: 'Dossier',
      destination: 'Sera rangé dans | Sera rangé dans | Seront rangés dans',
      stays:
        'Restera dans {workspace}. | Restera dans {workspace}. | Resteront dans {workspace}.',
      staysUnnamed:
        'Restera là où il est. | Restera là où il est. | Resteront là où ils sont.',
      root: 'racine de l\'espace',
      noWorkspace: 'Vous ne pouvez ajouter de média dans aucun espace de travail.',
    },
  },
  messages: {
    title: 'Messages',
    subtitle: 'Ce que vos visiteurs vous ont écrit depuis le formulaire de contact.',
    empty: 'Aucun message',
    noSubject: '(sans objet)',
    unreadCount: '{count} non lu | {count} non lu | {count} non lus',
    markRead: 'Marquer comme lu',
    markUnread: 'Remettre en non lu',
    markError: 'Échec de la mise à jour du message',
    replyByMail: 'Répondre par e-mail',
    filters: {
      unread: 'Non lus',
      all: 'Tous',
    },
    table: {
      from: 'De',
      subject: 'Objet',
      receivedAt: 'Reçu le',
    },
    phone: 'Téléphone',
    delete: 'Supprimer',
    deleteTitle: 'Supprimer ce message ?',
    deleteMessage: 'Le message de {name} sera supprimé définitivement. Cette action est irréversible.',
    deleted: 'Message supprimé',
    deleteError: 'Échec de la suppression du message',
    pick: 'Sélectionnez un message pour le lire',
    back: 'Retour aux messages',
  },
  pending: {
    chip: 'Aperçu – données fictives',
    tooltip: 'Aucun serveur ne sert encore cet écran : les chiffres sont inventés, en développement uniquement, et rien de ce que vous faites ici n\'est enregistré.',
    // Sur un écran servi, à côté du seul réglage qui ne l'est pas encore.
    extensionTooltip: 'Cet écran lit vos vraies données. Ce qui porte cette marque — un filtre, un tri, un total, un réglage — n\'est encore servi par aucun serveur : c\'est simulé dans le navigateur, en développement uniquement, et un réglage fait là n\'est pas enregistré.',
  },
}
